/**
 * SN: Settlement Name
 * REG: Region
 * OR: Overall Ranking
 * NE: Natural environment
 * WB: Wellbeing
 * HC: Heritage /culture
 * SCH: Schools, employment and connectivity
 * HP: House Price Quality and Value
 * AP: Average price of family home (based on average sales price per square foot in last year x 1500 square foot home)
 * SPC: Average sales price change in last 12 months (based on change in overall average price paid per square foot)
 *
 */

const data = [
    {
        "UID": 1,
        "SN": "Twyford (Wokingham)",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 1,
        "NE": 360,
        "WB": 15,
        "HC": 198,
        "SCH": 30,
        "HP": 26,
        "AP": "£767,521",
        "SPC": "-3.0%"
    },
    {
        "UID": 2,
        "SN": "St Albans",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 2,
        "NE": 193,
        "WB": 281,
        "HC": 82,
        "SCH": 142,
        "HP": 33,
        "AP": "£972,494",
        "SPC": "0.4%"
    },
    {
        "UID": 3,
        "SN": "Epsom",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 3,
        "NE": 184,
        "WB": 282,
        "HC": 90,
        "SCH": 99,
        "HP": 93,
        "AP": "£810,809",
        "SPC": "0.4%"
    },
    {
        "UID": 4,
        "SN": "New Mills",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 4,
        "NE": 45,
        "WB": 50,
        "HC": 303,
        "SCH": 277,
        "HP": 215,
        "AP": "£409,662",
        "SPC": "-1.4%"
    },
    {
        "UID": 5,
        "SN": "Bowdon",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 5,
        "NE": 189,
        "WB": 426,
        "HC": 45,
        "SCH": 253,
        "HP": 2,
        "AP": "£709,036",
        "SPC": "-5.9%"
    },
    {
        "UID": 6,
        "SN": "Godalming",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 6,
        "NE": 82,
        "WB": 53,
        "HC": 54,
        "SCH": 529,
        "HP": 203,
        "AP": "£824,636",
        "SPC": "4.0%"
    },
    {
        "UID": 7,
        "SN": "Tring",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 7,
        "NE": 72,
        "WB": 80,
        "HC": 481,
        "SCH": 331,
        "HP": 114,
        "AP": "£790,325",
        "SPC": "1.2%"
    },
    {
        "UID": 8,
        "SN": "Cheltenham",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 8,
        "NE": 172,
        "WB": 437,
        "HC": 27,
        "SCH": 271,
        "HP": 248,
        "AP": "£570,503",
        "SPC": "0.5%"
    },
    {
        "UID": 9,
        "SN": "Farncombe",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 9,
        "NE": 127,
        "WB": 248,
        "HC": 172,
        "SCH": 710,
        "HP": 36,
        "AP": "£764,678",
        "SPC": "-1.5%"
    },
    {
        "UID": 10,
        "SN": "Henley-on-Thames",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 10,
        "NE": 973,
        "WB": 49,
        "HC": 64,
        "SCH": 22,
        "HP": 198,
        "AP": "£950,580",
        "SPC": "3.4%"
    },
    {
        "UID": 11,
        "SN": "Guildford",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 11,
        "NE": 149,
        "WB": 628,
        "HC": 100,
        "SCH": 205,
        "HP": 251,
        "AP": "£814,899",
        "SPC": "2.5%"
    },
    {
        "UID": 12,
        "SN": "Woking",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 12,
        "NE": 307,
        "WB": 304,
        "HC": 331,
        "SCH": 345,
        "HP": 78,
        "AP": "£748,455",
        "SPC": "-0.6%"
    },
    {
        "UID": 13,
        "SN": "Watford (Watford)",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 13,
        "NE": 138,
        "WB": 855,
        "HC": 212,
        "SCH": 122,
        "HP": 65,
        "AP": "£745,971",
        "SPC": "-1.4%"
    },
    {
        "UID": 14,
        "SN": "Bath",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 14,
        "NE": 273,
        "WB": 269,
        "HC": 11,
        "SCH": 825,
        "HP": 30,
        "AP": "£744,845",
        "SPC": "-1.1%"
    },
    {
        "UID": 15,
        "SN": "Marple",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 15,
        "NE": 33,
        "WB": 1043,
        "HC": 115,
        "SCH": 57,
        "HP": 170,
        "AP": "£513,087",
        "SPC": "3.3%"
    },
    {
        "UID": 16,
        "SN": "Harpenden",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 15,
        "NE": 467,
        "WB": 285,
        "HC": 411,
        "SCH": 252,
        "HP": 3,
        "AP": "£990,969",
        "SPC": "-3.1%"
    },
    {
        "UID": 17,
        "SN": "Ewell",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 17,
        "NE": 388,
        "WB": 669,
        "HC": 252,
        "SCH": 81,
        "HP": 38,
        "AP": "£853,254",
        "SPC": "-1.3%"
    },
    {
        "UID": 18,
        "SN": "Weybourne (Waverley)",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 18,
        "NE": 239,
        "WB": 328,
        "HC": 545,
        "SCH": 287,
        "HP": 37,
        "AP": "£686,592",
        "SPC": "-5.4%"
    },
    {
        "UID": 19,
        "SN": "Wallingford",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 19,
        "NE": 153,
        "WB": 150,
        "HC": 381,
        "SCH": 292,
        "HP": 484,
        "AP": "£812,881",
        "SPC": "28.1%"
    },
    {
        "UID": 20,
        "SN": "Chinnor",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 20,
        "NE": 32,
        "WB": 43,
        "HC": 1131,
        "SCH": 183,
        "HP": 86,
        "AP": "£691,306",
        "SPC": "-2.7%"
    },
    {
        "UID": 21,
        "SN": "Berkhamsted",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 21,
        "NE": 86,
        "WB": 407,
        "HC": 261,
        "SCH": 447,
        "HP": 277,
        "AP": "£937,050",
        "SPC": "4.6%"
    },
    {
        "UID": 22,
        "SN": "Reddish",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 22,
        "NE": 39,
        "WB": 900,
        "HC": 146,
        "SCH": 105,
        "HP": 289,
        "AP": "£398,539",
        "SPC": "3.5%"
    },
    {
        "UID": 23,
        "SN": "Clitheroe",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 22,
        "NE": 256,
        "WB": 425,
        "HC": 495,
        "SCH": 214,
        "HP": 89,
        "AP": "£342,652",
        "SPC": "-3.2%"
    },
    {
        "UID": 24,
        "SN": "Hemel Hempstead",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 24,
        "NE": 169,
        "WB": 530,
        "HC": 432,
        "SCH": 228,
        "HP": 126,
        "AP": "£672,666",
        "SPC": "0.4%"
    },
    {
        "UID": 25,
        "SN": "Prestwich",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 25,
        "NE": 89,
        "WB": 911,
        "HC": 130,
        "SCH": 15,
        "HP": 347,
        "AP": "£433,887",
        "SPC": "1.1%"
    },
    {
        "UID": 26,
        "SN": "Winchester",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 26,
        "NE": 217,
        "WB": 554,
        "HC": 126,
        "SCH": 489,
        "HP": 115,
        "AP": "£770,987",
        "SPC": "0.1%"
    },
    {
        "UID": 27,
        "SN": "Rickmansworth",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 27,
        "NE": 688,
        "WB": 509,
        "HC": 233,
        "SCH": 52,
        "HP": 32,
        "AP": "£871,218",
        "SPC": "-1.8%"
    },
    {
        "UID": 28,
        "SN": "Chesham",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 28,
        "NE": 271,
        "WB": 88,
        "HC": 367,
        "SCH": 511,
        "HP": 311,
        "AP": "£739,966",
        "SPC": "2.0%"
    },
    {
        "UID": 29,
        "SN": "Great Malvern",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 29,
        "NE": 2,
        "WB": 136,
        "HC": 223,
        "SCH": 1065,
        "HP": 131,
        "AP": "£464,925",
        "SPC": "1.0%"
    },
    {
        "UID": 30,
        "SN": "Dronfield",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 29,
        "NE": 61,
        "WB": 64,
        "HC": 315,
        "SCH": 772,
        "HP": 345,
        "AP": "£478,106",
        "SPC": "1.8%"
    },
    {
        "UID": 31,
        "SN": "Caversham",
        "COU": "Reading",
        "REG": "South East",
        "OR": 31,
        "NE": 372,
        "WB": 443,
        "HC": 283,
        "SCH": 136,
        "HP": 354,
        "AP": "£701,805",
        "SPC": "-1.9%"
    },
    {
        "UID": 32,
        "SN": "Tadworth and Epsom Downs",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 32,
        "NE": 17,
        "WB": 686,
        "HC": 594,
        "SCH": 268,
        "HP": 27,
        "AP": "£808,819",
        "SPC": "-3.4%"
    },
    {
        "UID": 33,
        "SN": "Hitchin",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 33,
        "NE": 228,
        "WB": 259,
        "HC": 351,
        "SCH": 679,
        "HP": 81,
        "AP": "£753,230",
        "SPC": "1.2%"
    },
    {
        "UID": 34,
        "SN": "Alnwick",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 34,
        "NE": 92,
        "WB": 289,
        "HC": 765,
        "SCH": 402,
        "HP": 53,
        "AP": "£330,655",
        "SPC": "-1.7%"
    },
    {
        "UID": 35,
        "SN": "Abbots Langley and Kings Langley",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 35,
        "NE": 59,
        "WB": 974,
        "HC": 118,
        "SCH": 448,
        "HP": 16,
        "AP": "£731,844",
        "SPC": "-8.2%"
    },
    {
        "UID": 36,
        "SN": "Kenilworth",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 36,
        "NE": 882,
        "WB": 207,
        "HC": 133,
        "SCH": 225,
        "HP": 175,
        "AP": "£605,800",
        "SPC": "4.1%"
    },
    {
        "UID": 37,
        "SN": "Saltash",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 37,
        "NE": 80,
        "WB": 75,
        "HC": 273,
        "SCH": 322,
        "HP": 888,
        "AP": "£396,560",
        "SPC": "-2.9%"
    },
    {
        "UID": 38,
        "SN": "Marlow",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 38,
        "NE": 510,
        "WB": 280,
        "HC": 256,
        "SCH": 550,
        "HP": 50,
        "AP": "£904,221",
        "SPC": "-2.8%"
    },
    {
        "UID": 39,
        "SN": "Bromley",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 39,
        "NE": 336,
        "WB": 533,
        "HC": 141,
        "SCH": 98,
        "HP": 540,
        "AP": "£817,006",
        "SPC": "0.4%"
    },
    {
        "UID": 40,
        "SN": "Frampton Cotterell and Winterbourne",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 40,
        "NE": 341,
        "WB": 487,
        "HC": 489,
        "SCH": 126,
        "HP": 206,
        "AP": "£582,596",
        "SPC": "0.7%"
    },
    {
        "UID": 41,
        "SN": "Redbourn",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 41,
        "NE": 68,
        "WB": 730,
        "HC": 49,
        "SCH": 736,
        "HP": 84,
        "AP": "£836,116",
        "SPC": "2.0%"
    },
    {
        "UID": 42,
        "SN": "Macclesfield",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 42,
        "NE": 318,
        "WB": 721,
        "HC": 278,
        "SCH": 164,
        "HP": 188,
        "AP": "£422,199",
        "SPC": "2.2%"
    },
    {
        "UID": 43,
        "SN": "Royal Tunbridge Wells",
        "COU": "Kent",
        "REG": "South East",
        "OR": 43,
        "NE": 58,
        "WB": 451,
        "HC": 110,
        "SCH": 701,
        "HP": 361,
        "AP": "£710,806",
        "SPC": "-1.2%"
    },
    {
        "UID": 44,
        "SN": "Burley in Wharfedale",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 44,
        "NE": 207,
        "WB": 63,
        "HC": 113,
        "SCH": 683,
        "HP": 621,
        "AP": "£567,066",
        "SPC": "3.9%"
    },
    {
        "UID": 45,
        "SN": "Abingdon-on-Thames",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 45,
        "NE": 767,
        "WB": 57,
        "HC": 190,
        "SCH": 243,
        "HP": 432,
        "AP": "£605,119",
        "SPC": "-0.1%"
    },
    {
        "UID": 46,
        "SN": "Wilmslow",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 46,
        "NE": 403,
        "WB": 350,
        "HC": 440,
        "SCH": 333,
        "HP": 188,
        "AP": "£620,634",
        "SPC": "3.5%"
    },
    {
        "UID": 47,
        "SN": "Dorchester (Dorset)",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 47,
        "NE": 143,
        "WB": 198,
        "HC": 295,
        "SCH": 798,
        "HP": 301,
        "AP": "£501,625",
        "SPC": "-4.8%"
    },
    {
        "UID": 48,
        "SN": "Altrincham",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 48,
        "NE": 771,
        "WB": 527,
        "HC": 206,
        "SCH": 153,
        "HP": 79,
        "AP": "£622,850",
        "SPC": "1.6%"
    },
    {
        "UID": 49,
        "SN": "Rawdon",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 49,
        "NE": 202,
        "WB": 791,
        "HC": 52,
        "SCH": 601,
        "HP": 112,
        "AP": "£497,967",
        "SPC": "0.6%"
    },
    {
        "UID": 50,
        "SN": "Poynton",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 50,
        "NE": 492,
        "WB": 276,
        "HC": 493,
        "SCH": 123,
        "HP": 384,
        "AP": "£666,870",
        "SPC": "9.7%"
    },
    {
        "UID": 51,
        "SN": "Long Ashton",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 51,
        "NE": 708,
        "WB": 614,
        "HC": 38,
        "SCH": 387,
        "HP": 44,
        "AP": "£663,730",
        "SPC": "-4.7%"
    },
    {
        "UID": 52,
        "SN": "Sonning Common",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 52,
        "NE": 222,
        "WB": 467,
        "HC": 577,
        "SCH": 477,
        "HP": 54,
        "AP": "£749,329",
        "SPC": "-2.9%"
    },
    {
        "UID": 53,
        "SN": "Morley (Leeds)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 53,
        "NE": 297,
        "WB": 986,
        "HC": 56,
        "SCH": 247,
        "HP": 231,
        "AP": "£370,587",
        "SPC": "0.5%"
    },
    {
        "UID": 54,
        "SN": "Killingworth",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 54,
        "NE": 130,
        "WB": 337,
        "HC": 614,
        "SCH": 658,
        "HP": 87,
        "AP": "£281,574",
        "SPC": "-5.5%"
    },
    {
        "UID": 55,
        "SN": "Islington",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 55,
        "NE": 345,
        "WB": 1414,
        "HC": 5,
        "SCH": 40,
        "HP": 46,
        "AP": "£1,349,504",
        "SPC": "-2.5%"
    },
    {
        "UID": 56,
        "SN": "Steyning",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 56,
        "NE": 48,
        "WB": 35,
        "HC": 123,
        "SCH": 1311,
        "HP": 337,
        "AP": "£688,471",
        "SPC": "-1.3%"
    },
    {
        "UID": 57,
        "SN": "Stockport",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 57,
        "NE": 305,
        "WB": 1189,
        "HC": 60,
        "SCH": 38,
        "HP": 274,
        "AP": "£460,425",
        "SPC": "4.7%"
    },
    {
        "UID": 58,
        "SN": "Thame",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 58,
        "NE": 112,
        "WB": 13,
        "HC": 935,
        "SCH": 317,
        "HP": 498,
        "AP": "£776,055",
        "SPC": "10.3%"
    },
    {
        "UID": 59,
        "SN": "Otley (Leeds)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 59,
        "NE": 711,
        "WB": 390,
        "HC": 66,
        "SCH": 496,
        "HP": 213,
        "AP": "£467,919",
        "SPC": "2.4%"
    },
    {
        "UID": 60,
        "SN": "Salisbury",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 60,
        "NE": 740,
        "WB": 334,
        "HC": 332,
        "SCH": 17,
        "HP": 454,
        "AP": "£521,962",
        "SPC": "0.5%"
    },
    {
        "UID": 61,
        "SN": "Keynsham",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 61,
        "NE": 886,
        "WB": 551,
        "HC": 215,
        "SCH": 65,
        "HP": 167,
        "AP": "£557,172",
        "SPC": "0.3%"
    },
    {
        "UID": 62,
        "SN": "Old Trafford",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 62,
        "NE": 537,
        "WB": 1101,
        "HC": 127,
        "SCH": 105,
        "HP": 15,
        "AP": "£454,802",
        "SPC": "-2.3%"
    },
    {
        "UID": 63,
        "SN": "Saltburn-by-the-Sea",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 63,
        "NE": 27,
        "WB": 102,
        "HC": 374,
        "SCH": 872,
        "HP": 520,
        "AP": "£344,782",
        "SPC": "2.0%"
    },
    {
        "UID": 64,
        "SN": "Longridge (Ribble Valley)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 64,
        "NE": 51,
        "WB": 202,
        "HC": 967,
        "SCH": 596,
        "HP": 99,
        "AP": "£325,803",
        "SPC": "-5.1%"
    },
    {
        "UID": 65,
        "SN": "Ruddington",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 65,
        "NE": 1191,
        "WB": 73,
        "HC": 240,
        "SCH": 390,
        "HP": 27,
        "AP": "£475,849",
        "SPC": "-2.0%"
    },
    {
        "UID": 66,
        "SN": "Chorleywood",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 66,
        "NE": 387,
        "WB": 1037,
        "HC": 355,
        "SCH": 93,
        "HP": 56,
        "AP": "£959,978",
        "SPC": "-0.3%"
    },
    {
        "UID": 67,
        "SN": "Malmesbury",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 67,
        "NE": 477,
        "WB": 109,
        "HC": 574,
        "SCH": 592,
        "HP": 177,
        "AP": "£530,893",
        "SPC": "-15.9%"
    },
    {
        "UID": 68,
        "SN": "Brixham",
        "COU": "Torbay",
        "REG": "South West",
        "OR": 68,
        "NE": 656,
        "WB": 182,
        "HC": 41,
        "SCH": 329,
        "HP": 728,
        "AP": "£513,252",
        "SPC": "-4.6%"
    },
    {
        "UID": 69,
        "SN": "Brighton and Hove",
        "COU": "Brighton and Hove",
        "REG": "South East",
        "OR": 69,
        "NE": 115,
        "WB": 1007,
        "HC": 9,
        "SCH": 162,
        "HP": 651,
        "AP": "£808,948",
        "SPC": "1.4%"
    },
    {
        "UID": 70,
        "SN": "Shaftesbury",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 70,
        "NE": 70,
        "WB": 22,
        "HC": 611,
        "SCH": 757,
        "HP": 487,
        "AP": "£480,211",
        "SPC": "-0.9%"
    },
    {
        "UID": 71,
        "SN": "Yeadon",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 71,
        "NE": 744,
        "WB": 456,
        "HC": 237,
        "SCH": 274,
        "HP": 241,
        "AP": "£428,882",
        "SPC": "2.2%"
    },
    {
        "UID": 72,
        "SN": "Warlingham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 72,
        "NE": 242,
        "WB": 524,
        "HC": 702,
        "SCH": 263,
        "HP": 225,
        "AP": "£731,410",
        "SPC": "2.1%"
    },
    {
        "UID": 73,
        "SN": "Romiley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 73,
        "NE": 401,
        "WB": 881,
        "HC": 286,
        "SCH": 41,
        "HP": 350,
        "AP": "£485,680",
        "SPC": "7.9%"
    },
    {
        "UID": 74,
        "SN": "Woodley",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 74,
        "NE": 408,
        "WB": 297,
        "HC": 957,
        "SCH": 165,
        "HP": 135,
        "AP": "£671,703",
        "SPC": "-0.3%"
    },
    {
        "UID": 75,
        "SN": "Wokingham",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 75,
        "NE": 749,
        "WB": 59,
        "HC": 352,
        "SCH": 495,
        "HP": 327,
        "AP": "£726,746",
        "SPC": "3.9%"
    },
    {
        "UID": 76,
        "SN": "Knowle and Dorridge",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 76,
        "NE": 193,
        "WB": 319,
        "HC": 920,
        "SCH": 549,
        "HP": 5,
        "AP": "£687,716",
        "SPC": "-3.3%"
    },
    {
        "UID": 77,
        "SN": "West Molesey",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 77,
        "NE": 905,
        "WB": 437,
        "HC": 97,
        "SCH": 529,
        "HP": 24,
        "AP": "£972,293",
        "SPC": "-0.0%"
    },
    {
        "UID": 78,
        "SN": "Whitley Bay",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 78,
        "NE": 413,
        "WB": 449,
        "HC": 362,
        "SCH": 551,
        "HP": 220,
        "AP": "£430,256",
        "SPC": "2.8%"
    },
    {
        "UID": 79,
        "SN": "Barri",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 79,
        "NE": 354,
        "WB": 1147,
        "HC": 187,
        "SCH": 76,
        "HP": 244,
        "AP": "£377,641",
        "SPC": "0.3%"
    },
    {
        "UID": 80,
        "SN": "Bramhall",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 80,
        "NE": 320,
        "WB": 674,
        "HC": 692,
        "SCH": 203,
        "HP": 128,
        "AP": "£602,513",
        "SPC": "2.8%"
    },
    {
        "UID": 81,
        "SN": "Whitburn (South Tyneside)",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 80,
        "NE": 41,
        "WB": 195,
        "HC": 136,
        "SCH": 1077,
        "HP": 568,
        "AP": "£333,897",
        "SPC": "2.4%"
    },
    {
        "UID": 82,
        "SN": "Chapel-en-le-Frith",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 82,
        "NE": 6,
        "WB": 241,
        "HC": 454,
        "SCH": 973,
        "HP": 345,
        "AP": "£433,540",
        "SPC": "1.2%"
    },
    {
        "UID": 83,
        "SN": "Lymm",
        "COU": "Warrington",
        "REG": "North West",
        "OR": 83,
        "NE": 792,
        "WB": 422,
        "HC": 279,
        "SCH": 177,
        "HP": 350,
        "AP": "£548,260",
        "SPC": "3.9%"
    },
    {
        "UID": 84,
        "SN": "Stretford",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 84,
        "NE": 719,
        "WB": 882,
        "HC": 319,
        "SCH": 21,
        "HP": 80,
        "AP": "£433,413",
        "SPC": "0.5%"
    },
    {
        "UID": 85,
        "SN": "Paulton",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 85,
        "NE": 23,
        "WB": 58,
        "HC": 1180,
        "SCH": 648,
        "HP": 124,
        "AP": "£480,041",
        "SPC": "-10.1%"
    },
    {
        "UID": 86,
        "SN": "Camden",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 86,
        "NE": 555,
        "WB": 1398,
        "HC": 3,
        "SCH": 18,
        "HP": 67,
        "AP": "£1,712,511",
        "SPC": "-0.2%"
    },
    {
        "UID": 87,
        "SN": "Kingswood and Fishponds",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 87,
        "NE": 169,
        "WB": 963,
        "HC": 249,
        "SCH": 215,
        "HP": 452,
        "AP": "£539,147",
        "SPC": "1.9%"
    },
    {
        "UID": 88,
        "SN": "Bovingdon",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 88,
        "NE": 335,
        "WB": 501,
        "HC": 431,
        "SCH": 349,
        "HP": 434,
        "AP": "£824,156",
        "SPC": "12.9%"
    },
    {
        "UID": 89,
        "SN": "Whitby",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 89,
        "NE": 134,
        "WB": 30,
        "HC": 155,
        "SCH": 1299,
        "HP": 442,
        "AP": "£438,004",
        "SPC": "3.5%"
    },
    {
        "UID": 90,
        "SN": "St Ives (Cornwall)",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 90,
        "NE": 130,
        "WB": 465,
        "HC": 155,
        "SCH": 1014,
        "HP": 299,
        "AP": "£833,754",
        "SPC": "-0.2%"
    },
    {
        "UID": 91,
        "SN": "Urmston",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 91,
        "NE": 568,
        "WB": 1084,
        "HC": 284,
        "SCH": 111,
        "HP": 21,
        "AP": "£507,083",
        "SPC": "-0.9%"
    },
    {
        "UID": 92,
        "SN": "Netley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 92,
        "NE": 47,
        "WB": 294,
        "HC": 352,
        "SCH": 881,
        "HP": 495,
        "AP": "£553,061",
        "SPC": "-4.8%"
    },
    {
        "UID": 93,
        "SN": "Ilkley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 93,
        "NE": 847,
        "WB": 374,
        "HC": 200,
        "SCH": 283,
        "HP": 366,
        "AP": "£557,439",
        "SPC": "0.9%"
    },
    {
        "UID": 94,
        "SN": "Southborough",
        "COU": "Kent",
        "REG": "South East",
        "OR": 94,
        "NE": 3,
        "WB": 381,
        "HC": 189,
        "SCH": 1094,
        "HP": 404,
        "AP": "£686,642",
        "SPC": "-1.1%"
    },
    {
        "UID": 95,
        "SN": "Farnham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 95,
        "NE": 920,
        "WB": 160,
        "HC": 103,
        "SCH": 585,
        "HP": 307,
        "AP": "£862,996",
        "SPC": "7.7%"
    },
    {
        "UID": 96,
        "SN": "Rainford",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 96,
        "NE": 1065,
        "WB": 29,
        "HC": 568,
        "SCH": 151,
        "HP": 272,
        "AP": "£389,375",
        "SPC": "-3.6%"
    },
    {
        "UID": 97,
        "SN": "Harrogate",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 96,
        "NE": 193,
        "WB": 352,
        "HC": 419,
        "SCH": 897,
        "HP": 224,
        "AP": "£499,708",
        "SPC": "1.5%"
    },
    {
        "UID": 98,
        "SN": "Bebington",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 98,
        "NE": 421,
        "WB": 627,
        "HC": 135,
        "SCH": 413,
        "HP": 507,
        "AP": "£350,994",
        "SPC": "2.3%"
    },
    {
        "UID": 99,
        "SN": "Prestwood and Great Missenden",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 99,
        "NE": 67,
        "WB": 20,
        "HC": 435,
        "SCH": 1156,
        "HP": 436,
        "AP": "£827,406",
        "SPC": "4.9%"
    },
    {
        "UID": 100,
        "SN": "Lytham St Anne's",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 100,
        "NE": 893,
        "WB": 184,
        "HC": 297,
        "SCH": 260,
        "HP": 483,
        "AP": "£380,105",
        "SPC": "6.8%"
    },
    {
        "UID": 101,
        "SN": "Haslemere",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 101,
        "NE": 137,
        "WB": 134,
        "HC": 837,
        "SCH": 998,
        "HP": 12,
        "AP": "£725,805",
        "SPC": "-6.7%"
    },
    {
        "UID": 102,
        "SN": "Falmouth",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 102,
        "NE": 257,
        "WB": 907,
        "HC": 367,
        "SCH": 220,
        "HP": 382,
        "AP": "£585,441",
        "SPC": "-2.3%"
    },
    {
        "UID": 103,
        "SN": "Bristol",
        "COU": "Bristol, City of",
        "REG": "South West",
        "OR": 103,
        "NE": 556,
        "WB": 1162,
        "HC": 58,
        "SCH": 74,
        "HP": 285,
        "AP": "£626,319",
        "SPC": "1.9%"
    },
    {
        "UID": 104,
        "SN": "Whitnash",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 103,
        "NE": 459,
        "WB": 519,
        "HC": 937,
        "SCH": 80,
        "HP": 140,
        "AP": "£546,435",
        "SPC": "2.9%"
    },
    {
        "UID": 105,
        "SN": "Crosby (Sefton)",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 105,
        "NE": 359,
        "WB": 920,
        "HC": 32,
        "SCH": 118,
        "HP": 710,
        "AP": "£340,375",
        "SPC": "2.8%"
    },
    {
        "UID": 106,
        "SN": "Hadfield",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 106,
        "NE": 199,
        "WB": 506,
        "HC": 204,
        "SCH": 309,
        "HP": 922,
        "AP": "£394,747",
        "SPC": "9.7%"
    },
    {
        "UID": 107,
        "SN": "Penzance",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 107,
        "NE": 190,
        "WB": 368,
        "HC": 195,
        "SCH": 748,
        "HP": 649,
        "AP": "£483,298",
        "SPC": "-2.5%"
    },
    {
        "UID": 108,
        "SN": "New Alresford",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 108,
        "NE": 352,
        "WB": 12,
        "HC": 728,
        "SCH": 913,
        "HP": 148,
        "AP": "£724,952",
        "SPC": "0.1%"
    },
    {
        "UID": 109,
        "SN": "Chigwell",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 109,
        "NE": 124,
        "WB": 1404,
        "HC": 334,
        "SCH": 293,
        "HP": 1,
        "AP": "£859,195",
        "SPC": "-6.1%"
    },
    {
        "UID": 110,
        "SN": "Bradford-on-Avon",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 110,
        "NE": 218,
        "WB": 39,
        "HC": 20,
        "SCH": 1237,
        "HP": 646,
        "AP": "£648,816",
        "SPC": "7.2%"
    },
    {
        "UID": 111,
        "SN": "Haddenham (Buckinghamshire)",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 111,
        "NE": 118,
        "WB": 195,
        "HC": 591,
        "SCH": 881,
        "HP": 392,
        "AP": "£679,252",
        "SPC": "1.8%"
    },
    {
        "UID": 112,
        "SN": "Borrowash",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 112,
        "NE": 975,
        "WB": 137,
        "HC": 157,
        "SCH": 278,
        "HP": 633,
        "AP": "£448,240",
        "SPC": "6.1%"
    },
    {
        "UID": 113,
        "SN": "Pembury",
        "COU": "Kent",
        "REG": "South East",
        "OR": 113,
        "NE": 253,
        "WB": 356,
        "HC": 254,
        "SCH": 853,
        "HP": 472,
        "AP": "£655,414",
        "SPC": "-0.8%"
    },
    {
        "UID": 114,
        "SN": "Hazel Grove",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 114,
        "NE": 673,
        "WB": 1012,
        "HC": 456,
        "SCH": 35,
        "HP": 14,
        "AP": "£469,607",
        "SPC": "-2.4%"
    },
    {
        "UID": 115,
        "SN": "Gatley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 115,
        "NE": 141,
        "WB": 1123,
        "HC": 679,
        "SCH": 97,
        "HP": 156,
        "AP": "£513,730",
        "SPC": "2.9%"
    },
    {
        "UID": 116,
        "SN": "Broseley",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 116,
        "NE": 178,
        "WB": 118,
        "HC": 358,
        "SCH": 678,
        "HP": 865,
        "AP": "£416,044",
        "SPC": "7.5%"
    },
    {
        "UID": 117,
        "SN": "East Horsley",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 117,
        "NE": 1030,
        "WB": 275,
        "HC": 501,
        "SCH": 370,
        "HP": 25,
        "AP": "£1,025,567",
        "SPC": "-2.8%"
    },
    {
        "UID": 118,
        "SN": "Truro",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 118,
        "NE": 121,
        "WB": 219,
        "HC": 509,
        "SCH": 733,
        "HP": 629,
        "AP": "£485,743",
        "SPC": "-2.6%"
    },
    {
        "UID": 119,
        "SN": "Arlesey",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 119,
        "NE": 466,
        "WB": 488,
        "HC": 566,
        "SCH": 558,
        "HP": 135,
        "AP": "£563,639",
        "SPC": "-2.6%"
    },
    {
        "UID": 120,
        "SN": "Sale",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 119,
        "NE": 838,
        "WB": 977,
        "HC": 265,
        "SCH": 39,
        "HP": 94,
        "AP": "£569,039",
        "SPC": "1.9%"
    },
    {
        "UID": 121,
        "SN": "Eynsham",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 121,
        "NE": 1240,
        "WB": 213,
        "HC": 65,
        "SCH": 151,
        "HP": 545,
        "AP": "£616,843",
        "SPC": "-2.2%"
    },
    {
        "UID": 122,
        "SN": "Glossop",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 121,
        "NE": 368,
        "WB": 377,
        "HC": 311,
        "SCH": 394,
        "HP": 764,
        "AP": "£429,971",
        "SPC": "8.0%"
    },
    {
        "UID": 123,
        "SN": "Pudsey",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 123,
        "NE": 285,
        "WB": 822,
        "HC": 53,
        "SCH": 547,
        "HP": 511,
        "AP": "£405,998",
        "SPC": "6.3%"
    },
    {
        "UID": 124,
        "SN": "Cheadle Hulme",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 124,
        "NE": 361,
        "WB": 875,
        "HC": 690,
        "SCH": 270,
        "HP": 31,
        "AP": "£596,643",
        "SPC": "-0.4%"
    },
    {
        "UID": 125,
        "SN": "Knaresborough",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 125,
        "NE": 773,
        "WB": 8,
        "HC": 372,
        "SCH": 716,
        "HP": 368,
        "AP": "£506,853",
        "SPC": "3.1%"
    },
    {
        "UID": 126,
        "SN": "Bolton-le-Sands",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 126,
        "NE": 447,
        "WB": 317,
        "HC": 532,
        "SCH": 415,
        "HP": 528,
        "AP": "£407,002",
        "SPC": "-0.3%"
    },
    {
        "UID": 127,
        "SN": "Llandudno",
        "COU": "Conwy",
        "REG": "Wales",
        "OR": 127,
        "NE": 14,
        "WB": 387,
        "HC": 73,
        "SCH": 671,
        "HP": 1100,
        "AP": "£331,840",
        "SPC": "6.8%"
    },
    {
        "UID": 128,
        "SN": "Newcastle upon Tyne",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 128,
        "NE": 251,
        "WB": 1042,
        "HC": 61,
        "SCH": 775,
        "HP": 117,
        "AP": "£314,382",
        "SPC": "-1.2%"
    },
    {
        "UID": 129,
        "SN": "Stroud",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 129,
        "NE": 521,
        "WB": 81,
        "HC": 409,
        "SCH": 469,
        "HP": 782,
        "AP": "£506,725",
        "SPC": "3.7%"
    },
    {
        "UID": 130,
        "SN": "Hayle",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 130,
        "NE": 349,
        "WB": 525,
        "HC": 167,
        "SCH": 515,
        "HP": 713,
        "AP": "£503,983",
        "SPC": "-0.2%"
    },
    {
        "UID": 131,
        "SN": "Southwark",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 131,
        "NE": 972,
        "WB": 1104,
        "HC": 12,
        "SCH": 63,
        "HP": 122,
        "AP": "£1,116,948",
        "SPC": "-3.4%"
    },
    {
        "UID": 132,
        "SN": "Stotfold",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 132,
        "NE": 246,
        "WB": 34,
        "HC": 676,
        "SCH": 1153,
        "HP": 174,
        "AP": "£585,800",
        "SPC": "-0.3%"
    },
    {
        "UID": 133,
        "SN": "Worcester Park and Stoneleigh",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 133,
        "NE": 736,
        "WB": 556,
        "HC": 721,
        "SCH": 231,
        "HP": 40,
        "AP": "£864,098",
        "SPC": "-1.1%"
    },
    {
        "UID": 134,
        "SN": "Totnes",
        "COU": "Devon",
        "REG": "South West",
        "OR": 134,
        "NE": 1019,
        "WB": 476,
        "HC": 263,
        "SCH": 258,
        "HP": 270,
        "AP": "£601,853",
        "SPC": "-1.0%"
    },
    {
        "UID": 135,
        "SN": "Manchester",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 135,
        "NE": 694,
        "WB": 1341,
        "HC": 39,
        "SCH": 46,
        "HP": 168,
        "AP": "£425,589",
        "SPC": "-5.1%"
    },
    {
        "UID": 136,
        "SN": "Caterham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 136,
        "NE": 96,
        "WB": 400,
        "HC": 660,
        "SCH": 1003,
        "HP": 131,
        "AP": "£685,210",
        "SPC": "-0.5%"
    },
    {
        "UID": 137,
        "SN": "Southwick (Adur)",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 137,
        "NE": 21,
        "WB": 862,
        "HC": 360,
        "SCH": 20,
        "HP": 1032,
        "AP": "£651,163",
        "SPC": "1.6%"
    },
    {
        "UID": 138,
        "SN": "Hungerford",
        "COU": "West Berkshire",
        "REG": "South East",
        "OR": 138,
        "NE": 13,
        "WB": 179,
        "HC": 963,
        "SCH": 863,
        "HP": 282,
        "AP": "£595,574",
        "SPC": "-1.2%"
    },
    {
        "UID": 139,
        "SN": "Lydiate",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 139,
        "NE": 655,
        "WB": 37,
        "HC": 1327,
        "SCH": 27,
        "HP": 260,
        "AP": "£369,414",
        "SPC": "-1.1%"
    },
    {
        "UID": 140,
        "SN": "Amesbury",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 140,
        "NE": 126,
        "WB": 68,
        "HC": 1363,
        "SCH": 312,
        "HP": 447,
        "AP": "£490,162",
        "SPC": "-0.6%"
    },
    {
        "UID": 141,
        "SN": "Kidlington",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 141,
        "NE": 1198,
        "WB": 139,
        "HC": 378,
        "SCH": 29,
        "HP": 578,
        "AP": "£659,228",
        "SPC": "1.4%"
    },
    {
        "UID": 142,
        "SN": "Bollington",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 142,
        "NE": 821,
        "WB": 972,
        "HC": 219,
        "SCH": 316,
        "HP": 8,
        "AP": "£471,390",
        "SPC": "-6.9%"
    },
    {
        "UID": 143,
        "SN": "Guiseley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 143,
        "NE": 143,
        "WB": 692,
        "HC": 292,
        "SCH": 1038,
        "HP": 173,
        "AP": "£466,530",
        "SPC": "1.8%"
    },
    {
        "UID": 144,
        "SN": "Chipping Norton",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 144,
        "NE": 369,
        "WB": 617,
        "HC": 557,
        "SCH": 147,
        "HP": 651,
        "AP": "£557,310",
        "SPC": "-4.4%"
    },
    {
        "UID": 145,
        "SN": "Swinton (Salford)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 145,
        "NE": 347,
        "WB": 1392,
        "HC": 249,
        "SCH": 23,
        "HP": 335,
        "AP": "£385,996",
        "SPC": "-3.9%"
    },
    {
        "UID": 146,
        "SN": "Royal Leamington Spa",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 145,
        "NE": 1204,
        "WB": 765,
        "HC": 31,
        "SCH": 170,
        "HP": 176,
        "AP": "£557,250",
        "SPC": "3.8%"
    },
    {
        "UID": 147,
        "SN": "Wandsworth",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 147,
        "NE": 933,
        "WB": 1323,
        "HC": 37,
        "SCH": 45,
        "HP": 18,
        "AP": "£1,192,824",
        "SPC": "-4.6%"
    },
    {
        "UID": 148,
        "SN": "Bredbury and Woodley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 148,
        "NE": 663,
        "WB": 1050,
        "HC": 294,
        "SCH": 58,
        "HP": 292,
        "AP": "£440,927",
        "SPC": "4.8%"
    },
    {
        "UID": 149,
        "SN": "Barnet",
        "COU": "London",
        "REG": "Greater London",
        "OR": 149,
        "NE": 485,
        "WB": 874,
        "HC": 173,
        "SCH": 233,
        "HP": 601,
        "AP": "£954,170",
        "SPC": "-2.1%"
    },
    {
        "UID": 150,
        "SN": "Benson",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 150,
        "NE": 570,
        "WB": 129,
        "HC": 464,
        "SCH": 685,
        "HP": 519,
        "AP": "£678,916",
        "SPC": "4.9%"
    },
    {
        "UID": 151,
        "SN": "Swadlincote",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 151,
        "NE": 416,
        "WB": 191,
        "HC": 943,
        "SCH": 255,
        "HP": 563,
        "AP": "£338,407",
        "SPC": "2.4%"
    },
    {
        "UID": 152,
        "SN": "Spencers Wood and Three Mile Cross",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 152,
        "NE": 35,
        "WB": 946,
        "HC": 400,
        "SCH": 757,
        "HP": 233,
        "AP": "£644,818",
        "SPC": "0.8%"
    },
    {
        "UID": 153,
        "SN": "Biddulph",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 153,
        "NE": 490,
        "WB": 148,
        "HC": 531,
        "SCH": 258,
        "HP": 948,
        "AP": "£340,476",
        "SPC": "7.0%"
    },
    {
        "UID": 154,
        "SN": "Reigate",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 154,
        "NE": 346,
        "WB": 889,
        "HC": 154,
        "SCH": 965,
        "HP": 22,
        "AP": "£805,337",
        "SPC": "-4.2%"
    },
    {
        "UID": 155,
        "SN": "Stratford-upon-Avon",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 155,
        "NE": 959,
        "WB": 801,
        "HC": 342,
        "SCH": 217,
        "HP": 61,
        "AP": "£565,447",
        "SPC": "-0.1%"
    },
    {
        "UID": 156,
        "SN": "Peasedown St John",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 156,
        "NE": 88,
        "WB": 14,
        "HC": 945,
        "SCH": 1106,
        "HP": 229,
        "AP": "£501,046",
        "SPC": "-0.3%"
    },
    {
        "UID": 157,
        "SN": "Westhoughton",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 157,
        "NE": 331,
        "WB": 844,
        "HC": 518,
        "SCH": 26,
        "HP": 666,
        "AP": "£350,183",
        "SPC": "-0.1%"
    },
    {
        "UID": 158,
        "SN": "Warwick",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 158,
        "NE": 1288,
        "WB": 686,
        "HC": 225,
        "SCH": 114,
        "HP": 75,
        "AP": "£535,562",
        "SPC": "1.0%"
    },
    {
        "UID": 159,
        "SN": "Frimley",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 159,
        "NE": 599,
        "WB": 399,
        "HC": 849,
        "SCH": 442,
        "HP": 109,
        "AP": "£666,708",
        "SPC": "-0.8%"
    },
    {
        "UID": 160,
        "SN": "Newport (Telford and Wrekin)",
        "COU": "Telford and Wrekin",
        "REG": "West Midlands",
        "OR": 160,
        "NE": 531,
        "WB": 60,
        "HC": 1014,
        "SCH": 64,
        "HP": 736,
        "AP": "£403,365",
        "SPC": "2.7%"
    },
    {
        "UID": 161,
        "SN": "Tower Hamlets",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 161,
        "NE": 1061,
        "WB": 1171,
        "HC": 43,
        "SCH": 37,
        "HP": 100,
        "AP": "£1,089,828",
        "SPC": "-9.6%"
    },
    {
        "UID": 162,
        "SN": "Banstead",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 162,
        "NE": 136,
        "WB": 795,
        "HC": 862,
        "SCH": 279,
        "HP": 341,
        "AP": "£842,510",
        "SPC": "5.3%"
    },
    {
        "UID": 163,
        "SN": "Borehamwood",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 163,
        "NE": 603,
        "WB": 561,
        "HC": 731,
        "SCH": 55,
        "HP": 474,
        "AP": "£809,410",
        "SPC": "0.2%"
    },
    {
        "UID": 164,
        "SN": "Tetbury",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 163,
        "NE": 9,
        "WB": 149,
        "HC": 566,
        "SCH": 1149,
        "HP": 551,
        "AP": "£647,491",
        "SPC": "9.0%"
    },
    {
        "UID": 165,
        "SN": "Sevenoaks",
        "COU": "Kent",
        "REG": "South East",
        "OR": 165,
        "NE": 334,
        "WB": 899,
        "HC": 245,
        "SCH": 888,
        "HP": 60,
        "AP": "£873,327",
        "SPC": "-0.5%"
    },
    {
        "UID": 166,
        "SN": "Dorking",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 165,
        "NE": 291,
        "WB": 284,
        "HC": 184,
        "SCH": 911,
        "HP": 756,
        "AP": "£787,269",
        "SPC": "1.3%"
    },
    {
        "UID": 167,
        "SN": "Wroughton",
        "COU": "Swindon",
        "REG": "South West",
        "OR": 167,
        "NE": 119,
        "WB": 220,
        "HC": 620,
        "SCH": 714,
        "HP": 756,
        "AP": "£487,330",
        "SPC": "3.0%"
    },
    {
        "UID": 168,
        "SN": "West Bridgford",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 168,
        "NE": 1221,
        "WB": 372,
        "HC": 537,
        "SCH": 53,
        "HP": 254,
        "AP": "£551,682",
        "SPC": "5.6%"
    },
    {
        "UID": 169,
        "SN": "Aston Clinton",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 169,
        "NE": 4,
        "WB": 356,
        "HC": 306,
        "SCH": 1228,
        "HP": 547,
        "AP": "£712,954",
        "SPC": "4.6%"
    },
    {
        "UID": 170,
        "SN": "Stonehouse (Stroud)",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 170,
        "NE": 77,
        "WB": 540,
        "HC": 716,
        "SCH": 689,
        "HP": 421,
        "AP": "£477,613",
        "SPC": "-1.3%"
    },
    {
        "UID": 171,
        "SN": "London Colney",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 170,
        "NE": 575,
        "WB": 1019,
        "HC": 496,
        "SCH": 305,
        "HP": 48,
        "AP": "£719,864",
        "SPC": "-0.1%"
    },
    {
        "UID": 172,
        "SN": "Letchworth",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 172,
        "NE": 241,
        "WB": 488,
        "HC": 823,
        "SCH": 847,
        "HP": 45,
        "AP": "£636,630",
        "SPC": "-2.9%"
    },
    {
        "UID": 173,
        "SN": "City of Westminster",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 173,
        "NE": 1243,
        "WB": 1117,
        "HC": 1,
        "SCH": 79,
        "HP": 10,
        "AP": "£2,175,157",
        "SPC": "-1.0%"
    },
    {
        "UID": 174,
        "SN": "Menston",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 174,
        "NE": 358,
        "WB": 154,
        "HC": 178,
        "SCH": 1201,
        "HP": 560,
        "AP": "£477,844",
        "SPC": "2.8%"
    },
    {
        "UID": 175,
        "SN": "Paignton",
        "COU": "Torbay",
        "REG": "South West",
        "OR": 175,
        "NE": 481,
        "WB": 707,
        "HC": 95,
        "SCH": 144,
        "HP": 1025,
        "AP": "£447,598",
        "SPC": "-2.0%"
    },
    {
        "UID": 176,
        "SN": "Bracknell",
        "COU": "Bracknell Forest",
        "REG": "South East",
        "OR": 176,
        "NE": 435,
        "WB": 100,
        "HC": 1111,
        "SCH": 300,
        "HP": 509,
        "AP": "£646,600",
        "SPC": "1.5%"
    },
    {
        "UID": 177,
        "SN": "Richmond upon Thames",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 177,
        "NE": 948,
        "WB": 972,
        "HC": 13,
        "SCH": 347,
        "HP": 178,
        "AP": "£1,229,585",
        "SPC": "2.4%"
    },
    {
        "UID": 178,
        "SN": "Wallsend",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 178,
        "NE": 161,
        "WB": 1085,
        "HC": 246,
        "SCH": 674,
        "HP": 294,
        "AP": "£250,316",
        "SPC": "-0.4%"
    },
    {
        "UID": 179,
        "SN": "Ledbury",
        "COU": "Herefordshire, County of",
        "REG": "West Midlands",
        "OR": 179,
        "NE": 84,
        "WB": 71,
        "HC": 584,
        "SCH": 817,
        "HP": 906,
        "AP": "£464,314",
        "SPC": "4.0%"
    },
    {
        "UID": 180,
        "SN": "Llanilltud Fawr",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 179,
        "NE": 197,
        "WB": 175,
        "HC": 1197,
        "SCH": 810,
        "HP": 83,
        "AP": "£459,551",
        "SPC": "-1.5%"
    },
    {
        "UID": 181,
        "SN": "Bournemouth",
        "COU": "Bournemouth, Christchurch and Poole",
        "REG": "South West",
        "OR": 181,
        "NE": 19,
        "WB": 940,
        "HC": 160,
        "SCH": 575,
        "HP": 772,
        "AP": "£570,476",
        "SPC": "3.2%"
    },
    {
        "UID": 182,
        "SN": "Egglescliffe",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 182,
        "NE": 46,
        "WB": 879,
        "HC": 550,
        "SCH": 645,
        "HP": 347,
        "AP": "£327,558",
        "SPC": "2.8%"
    },
    {
        "UID": 183,
        "SN": "Belper",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 183,
        "NE": 544,
        "WB": 93,
        "HC": 478,
        "SCH": 693,
        "HP": 660,
        "AP": "£429,133",
        "SPC": "3.3%"
    },
    {
        "UID": 184,
        "SN": "Denton (Tameside)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 184,
        "NE": 125,
        "WB": 1119,
        "HC": 247,
        "SCH": 31,
        "HP": 954,
        "AP": "£369,252",
        "SPC": "3.0%"
    },
    {
        "UID": 185,
        "SN": "Oxford",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 185,
        "NE": 762,
        "WB": 898,
        "HC": 27,
        "SCH": 242,
        "HP": 557,
        "AP": "£815,514",
        "SPC": "4.0%"
    },
    {
        "UID": 186,
        "SN": "Leeds",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 186,
        "NE": 584,
        "WB": 1305,
        "HC": 67,
        "SCH": 340,
        "HP": 191,
        "AP": "£373,306",
        "SPC": "0.2%"
    },
    {
        "UID": 187,
        "SN": "Bacup",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 187,
        "NE": 347,
        "WB": 406,
        "HC": 101,
        "SCH": 228,
        "HP": 1406,
        "AP": "£248,658",
        "SPC": "5.8%"
    },
    {
        "UID": 188,
        "SN": "Balsall Common",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 188,
        "NE": 703,
        "WB": 38,
        "HC": 680,
        "SCH": 1061,
        "HP": 8,
        "AP": "£548,297",
        "SPC": "-2.9%"
    },
    {
        "UID": 189,
        "SN": "Garforth",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 188,
        "NE": 212,
        "WB": 274,
        "HC": 1284,
        "SCH": 395,
        "HP": 325,
        "AP": "£431,091",
        "SPC": "3.3%"
    },
    {
        "UID": 190,
        "SN": "Reading",
        "COU": "Reading",
        "REG": "South East",
        "OR": 190,
        "NE": 240,
        "WB": 1089,
        "HC": 173,
        "SCH": 150,
        "HP": 841,
        "AP": "£631,603",
        "SPC": "2.1%"
    },
    {
        "UID": 191,
        "SN": "Ventnor",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 191,
        "NE": 122,
        "WB": 166,
        "HC": 221,
        "SCH": 677,
        "HP": 1310,
        "AP": "£440,586",
        "SPC": "0.2%"
    },
    {
        "UID": 192,
        "SN": "Lymington",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 192,
        "NE": 163,
        "WB": 521,
        "HC": 456,
        "SCH": 1176,
        "HP": 183,
        "AP": "£749,425",
        "SPC": "-6.7%"
    },
    {
        "UID": 193,
        "SN": "Nailsea",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 193,
        "NE": 379,
        "WB": 395,
        "HC": 1254,
        "SCH": 115,
        "HP": 357,
        "AP": "£608,412",
        "SPC": "2.7%"
    },
    {
        "UID": 194,
        "SN": "Conwy",
        "COU": "Conwy",
        "REG": "Wales",
        "OR": 194,
        "NE": 486,
        "WB": 660,
        "HC": 219,
        "SCH": 533,
        "HP": 604,
        "AP": "£417,066",
        "SPC": "3.3%"
    },
    {
        "UID": 195,
        "SN": "Yateley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 195,
        "NE": 799,
        "WB": 107,
        "HC": 969,
        "SCH": 533,
        "HP": 97,
        "AP": "£687,017",
        "SPC": "-0.5%"
    },
    {
        "UID": 196,
        "SN": "Silsden",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 195,
        "NE": 568,
        "WB": 430,
        "HC": 232,
        "SCH": 967,
        "HP": 308,
        "AP": "£382,318",
        "SPC": "-3.0%"
    },
    {
        "UID": 197,
        "SN": "Liskeard",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 197,
        "NE": 181,
        "WB": 163,
        "HC": 736,
        "SCH": 484,
        "HP": 943,
        "AP": "£378,436",
        "SPC": "-2.2%"
    },
    {
        "UID": 198,
        "SN": "Washingborough and Heighington",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 198,
        "NE": 1128,
        "WB": 202,
        "HC": 375,
        "SCH": 375,
        "HP": 428,
        "AP": "£393,696",
        "SPC": "0.7%"
    },
    {
        "UID": 199,
        "SN": "Hackney",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 199,
        "NE": 811,
        "WB": 1253,
        "HC": 14,
        "SCH": 34,
        "HP": 397,
        "AP": "£1,212,597",
        "SPC": "1.7%"
    },
    {
        "UID": 200,
        "SN": "Ormskirk",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 200,
        "NE": 638,
        "WB": 25,
        "HC": 989,
        "SCH": 236,
        "HP": 627,
        "AP": "£377,291",
        "SPC": "5.5%"
    },
    {
        "UID": 201,
        "SN": "Wivenhoe",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 201,
        "NE": 1313,
        "WB": 79,
        "HC": 75,
        "SCH": 505,
        "HP": 544,
        "AP": "£597,600",
        "SPC": "0.8%"
    },
    {
        "UID": 202,
        "SN": "Whickham",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 202,
        "NE": 364,
        "WB": 788,
        "HC": 308,
        "SCH": 389,
        "HP": 668,
        "AP": "£337,279",
        "SPC": "6.8%"
    },
    {
        "UID": 203,
        "SN": "Shoreham-by-Sea",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 203,
        "NE": 313,
        "WB": 859,
        "HC": 238,
        "SCH": 383,
        "HP": 725,
        "AP": "£713,462",
        "SPC": "-0.0%"
    },
    {
        "UID": 204,
        "SN": "Guisborough",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 203,
        "NE": 276,
        "WB": 151,
        "HC": 738,
        "SCH": 412,
        "HP": 941,
        "AP": "£302,490",
        "SPC": "6.3%"
    },
    {
        "UID": 205,
        "SN": "Chester",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 203,
        "NE": 774,
        "WB": 669,
        "HC": 241,
        "SCH": 435,
        "HP": 399,
        "AP": "£430,668",
        "SPC": "4.5%"
    },
    {
        "UID": 206,
        "SN": "Baldock",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 206,
        "NE": 128,
        "WB": 607,
        "HC": 445,
        "SCH": 951,
        "HP": 389,
        "AP": "£665,258",
        "SPC": "6.2%"
    },
    {
        "UID": 207,
        "SN": "Great Shelford and Stapleford",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 207,
        "NE": 1125,
        "WB": 128,
        "HC": 217,
        "SCH": 1022,
        "HP": 35,
        "AP": "£777,406",
        "SPC": "-0.7%"
    },
    {
        "UID": 208,
        "SN": "Stanwell",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 208,
        "NE": 132,
        "WB": 1102,
        "HC": 700,
        "SCH": 377,
        "HP": 217,
        "AP": "£658,590",
        "SPC": "-0.1%"
    },
    {
        "UID": 209,
        "SN": "Dunstable",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 209,
        "NE": 8,
        "WB": 717,
        "HC": 875,
        "SCH": 218,
        "HP": 713,
        "AP": "£541,342",
        "SPC": "5.5%"
    },
    {
        "UID": 210,
        "SN": "Caerdydd",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 209,
        "NE": 955,
        "WB": 1270,
        "HC": 50,
        "SCH": 133,
        "HP": 123,
        "AP": "£439,480",
        "SPC": "0.1%"
    },
    {
        "UID": 211,
        "SN": "Hammersmith and Fulham",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 211,
        "NE": 1213,
        "WB": 1195,
        "HC": 21,
        "SCH": 43,
        "HP": 68,
        "AP": "£1,419,508",
        "SPC": "-0.7%"
    },
    {
        "UID": 212,
        "SN": "Filey",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 212,
        "NE": 5,
        "WB": 122,
        "HC": 985,
        "SCH": 1259,
        "HP": 172,
        "AP": "£385,942",
        "SPC": "-1.7%"
    },
    {
        "UID": 213,
        "SN": "Cranfield",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 213,
        "NE": 420,
        "WB": 197,
        "HC": 851,
        "SCH": 742,
        "HP": 339,
        "AP": "£518,520",
        "SPC": "0.1%"
    },
    {
        "UID": 214,
        "SN": "Cotgrave",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 214,
        "NE": 613,
        "WB": 469,
        "HC": 1185,
        "SCH": 189,
        "HP": 95,
        "AP": "£395,763",
        "SPC": "-2.2%"
    },
    {
        "UID": 215,
        "SN": "Bushey",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 214,
        "NE": 849,
        "WB": 954,
        "HC": 169,
        "SCH": 181,
        "HP": 398,
        "AP": "£819,003",
        "SPC": "-0.9%"
    },
    {
        "UID": 216,
        "SN": "Didcot",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 216,
        "NE": 307,
        "WB": 447,
        "HC": 1183,
        "SCH": 185,
        "HP": 430,
        "AP": "£583,680",
        "SPC": "1.1%"
    },
    {
        "UID": 217,
        "SN": "Oswaldtwistle",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 217,
        "NE": 266,
        "WB": 737,
        "HC": 355,
        "SCH": 261,
        "HP": 934,
        "AP": "£222,697",
        "SPC": "-6.9%"
    },
    {
        "UID": 218,
        "SN": "Barwell",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 218,
        "NE": 366,
        "WB": 213,
        "HC": 1302,
        "SCH": 118,
        "HP": 558,
        "AP": "£368,151",
        "SPC": "1.1%"
    },
    {
        "UID": 219,
        "SN": "Penarth",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 218,
        "NE": 846,
        "WB": 1065,
        "HC": 46,
        "SCH": 107,
        "HP": 493,
        "AP": "£529,417",
        "SPC": "7.6%"
    },
    {
        "UID": 220,
        "SN": "Honley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 220,
        "NE": 682,
        "WB": 409,
        "HC": 81,
        "SCH": 1078,
        "HP": 308,
        "AP": "£403,924",
        "SPC": "0.7%"
    },
    {
        "UID": 221,
        "SN": "Southwell (Newark and Sherwood)",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 221,
        "NE": 1079,
        "WB": 223,
        "HC": 559,
        "SCH": 650,
        "HP": 51,
        "AP": "£496,387",
        "SPC": "-3.0%"
    },
    {
        "UID": 222,
        "SN": "Merton",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 222,
        "NE": 629,
        "WB": 824,
        "HC": 131,
        "SCH": 109,
        "HP": 870,
        "AP": "£1,033,377",
        "SPC": "1.5%"
    },
    {
        "UID": 223,
        "SN": "Gomersal and Birkenshaw",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 223,
        "NE": 298,
        "WB": 810,
        "HC": 92,
        "SCH": 776,
        "HP": 588,
        "AP": "£359,523",
        "SPC": "2.3%"
    },
    {
        "UID": 224,
        "SN": "Hebburn",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 224,
        "NE": 99,
        "WB": 825,
        "HC": 473,
        "SCH": 707,
        "HP": 462,
        "AP": "£241,440",
        "SPC": "-8.5%"
    },
    {
        "UID": 225,
        "SN": "Enderby and Narborough",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 225,
        "NE": 791,
        "WB": 527,
        "HC": 200,
        "SCH": 319,
        "HP": 731,
        "AP": "£451,417",
        "SPC": "9.0%"
    },
    {
        "UID": 226,
        "SN": "Hazlemere",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 226,
        "NE": 233,
        "WB": 161,
        "HC": 831,
        "SCH": 1270,
        "HP": 77,
        "AP": "£735,494",
        "SPC": "-5.0%"
    },
    {
        "UID": 227,
        "SN": "Gateshead",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 227,
        "NE": 183,
        "WB": 1056,
        "HC": 129,
        "SCH": 446,
        "HP": 766,
        "AP": "£259,567",
        "SPC": "3.2%"
    },
    {
        "UID": 228,
        "SN": "Ecclesfield and Grenoside",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 228,
        "NE": 267,
        "WB": 943,
        "HC": 168,
        "SCH": 1058,
        "HP": 153,
        "AP": "£363,226",
        "SPC": "-3.2%"
    },
    {
        "UID": 229,
        "SN": "Ascot",
        "COU": "Berkshire",
        "REG": "South East",
        "OR": 229,
        "NE": 1343,
        "WB": 314,
        "HC": 193,
        "SCH": 507,
        "HP": 235,
        "AP": "£825,914",
        "SPC": "3.2%"
    },
    {
        "UID": 230,
        "SN": "Shepshed",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 230,
        "NE": 473,
        "WB": 463,
        "HC": 930,
        "SCH": 418,
        "HP": 313,
        "AP": "£397,831",
        "SPC": "0.4%"
    },
    {
        "UID": 231,
        "SN": "Crowthorne",
        "COU": "Bracknell Forest",
        "REG": "South East",
        "OR": 230,
        "NE": 294,
        "WB": 266,
        "HC": 1102,
        "SCH": 571,
        "HP": 364,
        "AP": "£689,161",
        "SPC": "0.6%"
    },
    {
        "UID": 232,
        "SN": "Ashtead",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 230,
        "NE": 396,
        "WB": 783,
        "HC": 471,
        "SCH": 327,
        "HP": 620,
        "AP": "£856,514",
        "SPC": "0.5%"
    },
    {
        "UID": 233,
        "SN": "Workington",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 233,
        "NE": 479,
        "WB": 419,
        "HC": 360,
        "SCH": 792,
        "HP": 552,
        "AP": "£183,328",
        "SPC": "-2.5%"
    },
    {
        "UID": 234,
        "SN": "Stoke Gifford",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 234,
        "NE": 65,
        "WB": 1077,
        "HC": 436,
        "SCH": 517,
        "HP": 508,
        "AP": "£604,758",
        "SPC": "5.9%"
    },
    {
        "UID": 235,
        "SN": "Lambeth",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 235,
        "NE": 1169,
        "WB": 1204,
        "HC": 8,
        "SCH": 61,
        "HP": 164,
        "AP": "£1,088,314",
        "SPC": "-3.3%"
    },
    {
        "UID": 236,
        "SN": "Drighlington",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 235,
        "NE": 732,
        "WB": 993,
        "HC": 42,
        "SCH": 334,
        "HP": 505,
        "AP": "£384,090",
        "SPC": "4.7%"
    },
    {
        "UID": 237,
        "SN": "Rusthall and Langton Green",
        "COU": "Kent",
        "REG": "South East",
        "OR": 237,
        "NE": 322,
        "WB": 624,
        "HC": 179,
        "SCH": 1205,
        "HP": 279,
        "AP": "£711,867",
        "SPC": "-3.1%"
    },
    {
        "UID": 238,
        "SN": "Lancaster",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 238,
        "NE": 315,
        "WB": 666,
        "HC": 179,
        "SCH": 235,
        "HP": 1215,
        "AP": "£326,310",
        "SPC": "3.7%"
    },
    {
        "UID": 239,
        "SN": "Brockworth",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 239,
        "NE": 50,
        "WB": 578,
        "HC": 688,
        "SCH": 610,
        "HP": 686,
        "AP": "£449,121",
        "SPC": "0.1%"
    },
    {
        "UID": 240,
        "SN": "Matlock",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 239,
        "NE": 262,
        "WB": 170,
        "HC": 742,
        "SCH": 1301,
        "HP": 137,
        "AP": "£426,519",
        "SPC": "0.4%"
    },
    {
        "UID": 241,
        "SN": "Burntwood",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 241,
        "NE": 44,
        "WB": 437,
        "HC": 934,
        "SCH": 802,
        "HP": 400,
        "AP": "£410,868",
        "SPC": "2.2%"
    },
    {
        "UID": 242,
        "SN": "Kensington and Chelsea",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 241,
        "NE": 1134,
        "WB": 1393,
        "HC": 4,
        "SCH": 14,
        "HP": 72,
        "AP": "£2,352,956",
        "SPC": "-8.7%"
    },
    {
        "UID": 243,
        "SN": "Shaw (Oldham)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 243,
        "NE": 594,
        "WB": 766,
        "HC": 235,
        "SCH": 2,
        "HP": 1021,
        "AP": "£337,463",
        "SPC": "1.5%"
    },
    {
        "UID": 244,
        "SN": "Chadwell St Mary",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 244,
        "NE": 81,
        "WB": 483,
        "HC": 1370,
        "SCH": 223,
        "HP": 470,
        "AP": "£569,077",
        "SPC": "-0.4%"
    },
    {
        "UID": 245,
        "SN": "Barnard Castle",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 244,
        "NE": 522,
        "WB": 101,
        "HC": 815,
        "SCH": 509,
        "HP": 680,
        "AP": "£328,742",
        "SPC": "4.9%"
    },
    {
        "UID": 246,
        "SN": "Droylsden",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 246,
        "NE": 55,
        "WB": 1328,
        "HC": 194,
        "SCH": 44,
        "HP": 1008,
        "AP": "£356,718",
        "SPC": "3.1%"
    },
    {
        "UID": 247,
        "SN": "Billericay",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 247,
        "NE": 760,
        "WB": 413,
        "HC": 991,
        "SCH": 364,
        "HP": 108,
        "AP": "£736,233",
        "SPC": "-3.1%"
    },
    {
        "UID": 248,
        "SN": "Witney",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 248,
        "NE": 573,
        "WB": 116,
        "HC": 880,
        "SCH": 118,
        "HP": 951,
        "AP": "£570,003",
        "SPC": "1.1%"
    },
    {
        "UID": 249,
        "SN": "Knutsford",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 249,
        "NE": 635,
        "WB": 347,
        "HC": 441,
        "SCH": 1102,
        "HP": 116,
        "AP": "£605,753",
        "SPC": "2.0%"
    },
    {
        "UID": 250,
        "SN": "Penryn",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 250,
        "NE": 441,
        "WB": 523,
        "HC": 282,
        "SCH": 375,
        "HP": 1027,
        "AP": "£526,186",
        "SPC": "3.6%"
    },
    {
        "UID": 251,
        "SN": "Bradley Stoke",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 251,
        "NE": 753,
        "WB": 581,
        "HC": 1018,
        "SCH": 148,
        "HP": 151,
        "AP": "£639,910",
        "SPC": "0.7%"
    },
    {
        "UID": 252,
        "SN": "Chalford",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 251,
        "NE": 433,
        "WB": 141,
        "HC": 304,
        "SCH": 1151,
        "HP": 622,
        "AP": "£634,436",
        "SPC": "6.5%"
    },
    {
        "UID": 253,
        "SN": "Merley",
        "COU": "Bournemouth, Christchurch and Poole",
        "REG": "South West",
        "OR": 253,
        "NE": 56,
        "WB": 843,
        "HC": 505,
        "SCH": 445,
        "HP": 815,
        "AP": "£664,872",
        "SPC": "6.6%"
    },
    {
        "UID": 254,
        "SN": "Kings Hill",
        "COU": "Kent",
        "REG": "South East",
        "OR": 254,
        "NE": 456,
        "WB": 321,
        "HC": 1155,
        "SCH": 385,
        "HP": 352,
        "AP": "£624,721",
        "SPC": "-3.2%"
    },
    {
        "UID": 255,
        "SN": "Croydon",
        "COU": "London",
        "REG": "Greater London",
        "OR": 255,
        "NE": 272,
        "WB": 1164,
        "HC": 125,
        "SCH": 103,
        "HP": 1006,
        "AP": "£713,575",
        "SPC": "-0.2%"
    },
    {
        "UID": 256,
        "SN": "York",
        "COU": "York",
        "REG": "Yorkshire and The Humber",
        "OR": 256,
        "NE": 1068,
        "WB": 764,
        "HC": 30,
        "SCH": 423,
        "HP": 387,
        "AP": "£532,746",
        "SPC": "2.7%"
    },
    {
        "UID": 257,
        "SN": "Ashby-de-la-Zouch",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 257,
        "NE": 1024,
        "WB": 261,
        "HC": 729,
        "SCH": 525,
        "HP": 134,
        "AP": "£435,960",
        "SPC": "-0.4%"
    },
    {
        "UID": 258,
        "SN": "Torpoint",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 258,
        "NE": 15,
        "WB": 697,
        "HC": 463,
        "SCH": 149,
        "HP": 1353,
        "AP": "£390,534",
        "SPC": "4.5%"
    },
    {
        "UID": 259,
        "SN": "Leatherhead",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 259,
        "NE": 303,
        "WB": 557,
        "HC": 161,
        "SCH": 1162,
        "HP": 496,
        "AP": "£753,126",
        "SPC": "-2.6%"
    },
    {
        "UID": 260,
        "SN": "Litherland",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 260,
        "NE": 262,
        "WB": 819,
        "HC": 270,
        "SCH": 117,
        "HP": 1222,
        "AP": "£254,349",
        "SPC": "4.8%"
    },
    {
        "UID": 261,
        "SN": "Ludlow",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 260,
        "NE": 97,
        "WB": 530,
        "HC": 690,
        "SCH": 994,
        "HP": 379,
        "AP": "£421,360",
        "SPC": "0.6%"
    },
    {
        "UID": 262,
        "SN": "Broadstairs",
        "COU": "Kent",
        "REG": "South East",
        "OR": 262,
        "NE": 418,
        "WB": 794,
        "HC": 57,
        "SCH": 166,
        "HP": 1258,
        "AP": "£599,292",
        "SPC": "2.8%"
    },
    {
        "UID": 263,
        "SN": "Lewes",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 263,
        "NE": 639,
        "WB": 360,
        "HC": 159,
        "SCH": 1020,
        "HP": 517,
        "AP": "£823,239",
        "SPC": "1.3%"
    },
    {
        "UID": 264,
        "SN": "Milford and Witley",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 264,
        "NE": 229,
        "WB": 700,
        "HC": 427,
        "SCH": 1196,
        "HP": 146,
        "AP": "£770,968",
        "SPC": "2.2%"
    },
    {
        "UID": 265,
        "SN": "Swanage",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 265,
        "NE": 167,
        "WB": 27,
        "HC": 456,
        "SCH": 1397,
        "HP": 654,
        "AP": "£708,460",
        "SPC": "8.0%"
    },
    {
        "UID": 266,
        "SN": "Haringey",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 266,
        "NE": 923,
        "WB": 1232,
        "HC": 22,
        "SCH": 68,
        "HP": 458,
        "AP": "£1,094,310",
        "SPC": "-0.9%"
    },
    {
        "UID": 267,
        "SN": "Colchester",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 267,
        "NE": 216,
        "WB": 1173,
        "HC": 299,
        "SCH": 143,
        "HP": 878,
        "AP": "£521,951",
        "SPC": "1.9%"
    },
    {
        "UID": 268,
        "SN": "Exmouth",
        "COU": "Devon",
        "REG": "South West",
        "OR": 268,
        "NE": 449,
        "WB": 199,
        "HC": 528,
        "SCH": 619,
        "HP": 917,
        "AP": "£536,297",
        "SPC": "1.6%"
    },
    {
        "UID": 269,
        "SN": "Stamford",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 269,
        "NE": 805,
        "WB": 297,
        "HC": 555,
        "SCH": 769,
        "HP": 287,
        "AP": "£528,497",
        "SPC": "0.2%"
    },
    {
        "UID": 270,
        "SN": "Haxby",
        "COU": "York",
        "REG": "Yorkshire and The Humber",
        "OR": 270,
        "NE": 906,
        "WB": 341,
        "HC": 912,
        "SCH": 470,
        "HP": 91,
        "AP": "£536,043",
        "SPC": "-3.1%"
    },
    {
        "UID": 271,
        "SN": "Hyde (Tameside)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 271,
        "NE": 156,
        "WB": 1325,
        "HC": 186,
        "SCH": 85,
        "HP": 969,
        "AP": "£351,929",
        "SPC": "2.4%"
    },
    {
        "UID": 272,
        "SN": "Cheadle (Stockport)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 271,
        "NE": 751,
        "WB": 1080,
        "HC": 234,
        "SCH": 325,
        "HP": 331,
        "AP": "£542,971",
        "SPC": "8.5%"
    },
    {
        "UID": 273,
        "SN": "Royal Wootton Bassett",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 273,
        "NE": 102,
        "WB": 278,
        "HC": 600,
        "SCH": 906,
        "HP": 848,
        "AP": "£484,744",
        "SPC": "3.2%"
    },
    {
        "UID": 274,
        "SN": "Cowes",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 274,
        "NE": 73,
        "WB": 767,
        "HC": 133,
        "SCH": 436,
        "HP": 1328,
        "AP": "£500,486",
        "SPC": "1.4%"
    },
    {
        "UID": 275,
        "SN": "Failsworth",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 275,
        "NE": 83,
        "WB": 1225,
        "HC": 153,
        "SCH": 1,
        "HP": 1278,
        "AP": "£345,309",
        "SPC": "5.6%"
    },
    {
        "UID": 276,
        "SN": "Kibworth Beauchamp and Kibworth Harcourt",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 275,
        "NE": 910,
        "WB": 32,
        "HC": 838,
        "SCH": 873,
        "HP": 87,
        "AP": "£462,579",
        "SPC": "-0.7%"
    },
    {
        "UID": 277,
        "SN": "Princes Risborough",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 275,
        "NE": 502,
        "WB": 10,
        "HC": 1150,
        "SCH": 557,
        "HP": 521,
        "AP": "£768,688",
        "SPC": "5.9%"
    },
    {
        "UID": 278,
        "SN": "Y Fenni",
        "COU": "Monmouthshire",
        "REG": "Wales",
        "OR": 275,
        "NE": 339,
        "WB": 1268,
        "HC": 556,
        "SCH": 529,
        "HP": 48,
        "AP": "£427,700",
        "SPC": "-2.2%"
    },
    {
        "UID": 279,
        "SN": "Birkenhead",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 279,
        "NE": 289,
        "WB": 1214,
        "HC": 26,
        "SCH": 553,
        "HP": 659,
        "AP": "£257,040",
        "SPC": "-0.5%"
    },
    {
        "UID": 280,
        "SN": "Hersham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 280,
        "NE": 1156,
        "WB": 457,
        "HC": 414,
        "SCH": 419,
        "HP": 296,
        "AP": "£959,450",
        "SPC": "10.2%"
    },
    {
        "UID": 281,
        "SN": "Newport (Isle of Wight)",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 281,
        "NE": 243,
        "WB": 400,
        "HC": 77,
        "SCH": 792,
        "HP": 1231,
        "AP": "£378,420",
        "SPC": "-2.3%"
    },
    {
        "UID": 282,
        "SN": "Wendover",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 282,
        "NE": 631,
        "WB": 243,
        "HC": 426,
        "SCH": 1006,
        "HP": 438,
        "AP": "£775,441",
        "SPC": "4.2%"
    },
    {
        "UID": 283,
        "SN": "Beeston (Broxtowe)",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 283,
        "NE": 1200,
        "WB": 616,
        "HC": 475,
        "SCH": 193,
        "HP": 262,
        "AP": "£462,970",
        "SPC": "2.0%"
    },
    {
        "UID": 284,
        "SN": "Sawston",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 284,
        "NE": 280,
        "WB": 1,
        "HC": 1022,
        "SCH": 1168,
        "HP": 281,
        "AP": "£623,020",
        "SPC": "2.6%"
    },
    {
        "UID": 285,
        "SN": "Buxton (High Peak)",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 284,
        "NE": 623,
        "WB": 127,
        "HC": 429,
        "SCH": 638,
        "HP": 935,
        "AP": "£380,776",
        "SPC": "7.4%"
    },
    {
        "UID": 286,
        "SN": "Leek",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 286,
        "NE": 299,
        "WB": 227,
        "HC": 681,
        "SCH": 657,
        "HP": 903,
        "AP": "£330,701",
        "SPC": "4.9%"
    },
    {
        "UID": 287,
        "SN": "Tynemouth",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 286,
        "NE": 230,
        "WB": 1330,
        "HC": 150,
        "SCH": 609,
        "HP": 448,
        "AP": "£348,767",
        "SPC": "6.5%"
    },
    {
        "UID": 288,
        "SN": "Deal",
        "COU": "Kent",
        "REG": "South East",
        "OR": 288,
        "NE": 411,
        "WB": 709,
        "HC": 302,
        "SCH": 206,
        "HP": 1143,
        "AP": "£577,247",
        "SPC": "2.2%"
    },
    {
        "UID": 289,
        "SN": "Aberhonddu",
        "COU": "Powys",
        "REG": "Wales",
        "OR": 288,
        "NE": 460,
        "WB": 258,
        "HC": 379,
        "SCH": 1207,
        "HP": 467,
        "AP": "£379,395",
        "SPC": "-6.4%"
    },
    {
        "UID": 290,
        "SN": "Lichfield",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 288,
        "NE": 287,
        "WB": 586,
        "HC": 692,
        "SCH": 829,
        "HP": 377,
        "AP": "£499,336",
        "SPC": "4.8%"
    },
    {
        "UID": 291,
        "SN": "City and County of the City of London",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 291,
        "NE": 1387,
        "WB": 1290,
        "HC": 2,
        "SCH": 31,
        "HP": 65,
        "AP": "£1,850,873",
        "SPC": "-16.5%"
    },
    {
        "UID": 292,
        "SN": "Little Chalfont",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 291,
        "NE": 301,
        "WB": 308,
        "HC": 1019,
        "SCH": 1000,
        "HP": 147,
        "AP": "£942,777",
        "SPC": "1.2%"
    },
    {
        "UID": 293,
        "SN": "Hale (Trafford)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 293,
        "NE": 833,
        "WB": 1339,
        "HC": 71,
        "SCH": 155,
        "HP": 378,
        "AP": "£739,757",
        "SPC": "1.7%"
    },
    {
        "UID": 294,
        "SN": "Wem",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 294,
        "NE": 269,
        "WB": 355,
        "HC": 982,
        "SCH": 873,
        "HP": 299,
        "AP": "£376,638",
        "SPC": "-3.2%"
    },
    {
        "UID": 295,
        "SN": "Snodland",
        "COU": "Kent",
        "REG": "South East",
        "OR": 295,
        "NE": 103,
        "WB": 804,
        "HC": 175,
        "SCH": 563,
        "HP": 1138,
        "AP": "£570,875",
        "SPC": "5.6%"
    },
    {
        "UID": 296,
        "SN": "Maidenhead",
        "COU": "Windsor and Maidenhead",
        "REG": "South East",
        "OR": 296,
        "NE": 1009,
        "WB": 485,
        "HC": 741,
        "SCH": 474,
        "HP": 76,
        "AP": "£739,531",
        "SPC": "-1.3%"
    },
    {
        "UID": 297,
        "SN": "Hereford",
        "COU": "Herefordshire, County of",
        "REG": "West Midlands",
        "OR": 296,
        "NE": 371,
        "WB": 267,
        "HC": 797,
        "SCH": 431,
        "HP": 919,
        "AP": "£418,683",
        "SPC": "2.5%"
    },
    {
        "UID": 298,
        "SN": "Northam",
        "COU": "Devon",
        "REG": "South West",
        "OR": 298,
        "NE": 141,
        "WB": 420,
        "HC": 399,
        "SCH": 589,
        "HP": 1237,
        "AP": "£511,599",
        "SPC": "3.5%"
    },
    {
        "UID": 299,
        "SN": "High Wycombe",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 299,
        "NE": 165,
        "WB": 581,
        "HC": 843,
        "SCH": 797,
        "HP": 401,
        "AP": "£624,330",
        "SPC": "0.5%"
    },
    {
        "UID": 300,
        "SN": "Marske-by-the-Sea",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 300,
        "NE": 162,
        "WB": 315,
        "HC": 884,
        "SCH": 487,
        "HP": 941,
        "AP": "£307,650",
        "SPC": "6.8%"
    },
    {
        "UID": 301,
        "SN": "Brotton",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 301,
        "NE": 7,
        "WB": 579,
        "HC": 1038,
        "SCH": 433,
        "HP": 734,
        "AP": "£221,621",
        "SPC": "-2.4%"
    },
    {
        "UID": 302,
        "SN": "Aldershot",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 302,
        "NE": 324,
        "WB": 783,
        "HC": 338,
        "SCH": 335,
        "HP": 1013,
        "AP": "£564,222",
        "SPC": "1.0%"
    },
    {
        "UID": 303,
        "SN": "Burghfield Common",
        "COU": "West Berkshire",
        "REG": "South East",
        "OR": 303,
        "NE": 208,
        "WB": 417,
        "HC": 987,
        "SCH": 854,
        "HP": 329,
        "AP": "£652,541",
        "SPC": "1.0%"
    },
    {
        "UID": 304,
        "SN": "Cookham",
        "COU": "Windsor and Maidenhead",
        "REG": "South East",
        "OR": 304,
        "NE": 1012,
        "WB": 65,
        "HC": 118,
        "SCH": 1250,
        "HP": 354,
        "AP": "£1,056,397",
        "SPC": "7.6%"
    },
    {
        "UID": 305,
        "SN": "Ashton-under-Lyne",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 305,
        "NE": 255,
        "WB": 1333,
        "HC": 63,
        "SCH": 56,
        "HP": 1094,
        "AP": "£311,020",
        "SPC": "1.8%"
    },
    {
        "UID": 306,
        "SN": "East Grinstead",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 306,
        "NE": 64,
        "WB": 463,
        "HC": 1006,
        "SCH": 1088,
        "HP": 182,
        "AP": "£645,080",
        "SPC": "-1.0%"
    },
    {
        "UID": 307,
        "SN": "Crawcrook and Greenside",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 307,
        "NE": 213,
        "WB": 56,
        "HC": 948,
        "SCH": 813,
        "HP": 774,
        "AP": "£276,679",
        "SPC": "4.7%"
    },
    {
        "UID": 308,
        "SN": "Neston (Cheshire West and Chester)",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 308,
        "NE": 694,
        "WB": 270,
        "HC": 924,
        "SCH": 857,
        "HP": 63,
        "AP": "£442,839",
        "SPC": "-1.9%"
    },
    {
        "UID": 309,
        "SN": "West Kirby",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 308,
        "NE": 237,
        "WB": 72,
        "HC": 1075,
        "SCH": 931,
        "HP": 493,
        "AP": "£477,483",
        "SPC": "7.3%"
    },
    {
        "UID": 310,
        "SN": "Ripley (Amber Valley)",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 310,
        "NE": 452,
        "WB": 322,
        "HC": 808,
        "SCH": 649,
        "HP": 578,
        "AP": "£320,164",
        "SPC": "-2.8%"
    },
    {
        "UID": 311,
        "SN": "Sandown",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 311,
        "NE": 63,
        "WB": 323,
        "HC": 483,
        "SCH": 514,
        "HP": 1429,
        "AP": "£449,534",
        "SPC": "9.2%"
    },
    {
        "UID": 312,
        "SN": "Tavistock",
        "COU": "Devon",
        "REG": "South West",
        "OR": 312,
        "NE": 426,
        "WB": 91,
        "HC": 821,
        "SCH": 474,
        "HP": 1006,
        "AP": "£473,463",
        "SPC": "-0.5%"
    },
    {
        "UID": 313,
        "SN": "Hassocks and Hurstpierpoint",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 312,
        "NE": 652,
        "WB": 201,
        "HC": 604,
        "SCH": 1221,
        "HP": 140,
        "AP": "£760,876",
        "SPC": "0.6%"
    },
    {
        "UID": 314,
        "SN": "Camberley",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 314,
        "NE": 307,
        "WB": 1026,
        "HC": 650,
        "SCH": 673,
        "HP": 164,
        "AP": "£631,920",
        "SPC": "-0.3%"
    },
    {
        "UID": 315,
        "SN": "Cambridge (Cambridge)",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 315,
        "NE": 809,
        "WB": 876,
        "HC": 94,
        "SCH": 971,
        "HP": 74,
        "AP": "£823,582",
        "SPC": "0.7%"
    },
    {
        "UID": 316,
        "SN": "Rayleigh",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 316,
        "NE": 759,
        "WB": 624,
        "HC": 540,
        "SCH": 719,
        "HP": 187,
        "AP": "£667,843",
        "SPC": "2.4%"
    },
    {
        "UID": 317,
        "SN": "Longfield, New Ash Green and Hartley",
        "COU": "Kent",
        "REG": "South East",
        "OR": 317,
        "NE": 211,
        "WB": 955,
        "HC": 1103,
        "SCH": 366,
        "HP": 195,
        "AP": "£664,490",
        "SPC": "0.1%"
    },
    {
        "UID": 318,
        "SN": "Horsham",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 318,
        "NE": 71,
        "WB": 511,
        "HC": 841,
        "SCH": 1045,
        "HP": 364,
        "AP": "£694,310",
        "SPC": "-0.7%"
    },
    {
        "UID": 319,
        "SN": "Sutton (Sutton)",
        "COU": "London",
        "REG": "Greater London",
        "OR": 319,
        "NE": 426,
        "WB": 841,
        "HC": 316,
        "SCH": 130,
        "HP": 1124,
        "AP": "£791,821",
        "SPC": "0.4%"
    },
    {
        "UID": 320,
        "SN": "Dursley",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 319,
        "NE": 408,
        "WB": 44,
        "HC": 1025,
        "SCH": 776,
        "HP": 584,
        "AP": "£455,399",
        "SPC": "0.0%"
    },
    {
        "UID": 321,
        "SN": "Uppermill",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 321,
        "NE": 1125,
        "WB": 559,
        "HC": 51,
        "SCH": 96,
        "HP": 1008,
        "AP": "£473,119",
        "SPC": "6.2%"
    },
    {
        "UID": 322,
        "SN": "East Ardsley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 322,
        "NE": 827,
        "WB": 1141,
        "HC": 268,
        "SCH": 410,
        "HP": 198,
        "AP": "£367,568",
        "SPC": "0.1%"
    },
    {
        "UID": 323,
        "SN": "Easingwold",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 323,
        "NE": 152,
        "WB": 6,
        "HC": 1179,
        "SCH": 1010,
        "HP": 498,
        "AP": "£469,155",
        "SPC": "5.2%"
    },
    {
        "UID": 324,
        "SN": "Anstey",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 324,
        "NE": 1147,
        "WB": 576,
        "HC": 139,
        "SCH": 444,
        "HP": 540,
        "AP": "£424,038",
        "SPC": "4.2%"
    },
    {
        "UID": 325,
        "SN": "Faringdon",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 324,
        "NE": 520,
        "WB": 446,
        "HC": 742,
        "SCH": 569,
        "HP": 569,
        "AP": "£506,599",
        "SPC": "-1.3%"
    },
    {
        "UID": 326,
        "SN": "Corsham",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 326,
        "NE": 174,
        "WB": 371,
        "HC": 717,
        "SCH": 824,
        "HP": 761,
        "AP": "£536,706",
        "SPC": "4.3%"
    },
    {
        "UID": 327,
        "SN": "Cottenham",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 327,
        "NE": 738,
        "WB": 426,
        "HC": 203,
        "SCH": 1255,
        "HP": 230,
        "AP": "£606,054",
        "SPC": "1.7%"
    },
    {
        "UID": 328,
        "SN": "Bingham",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 328,
        "NE": 1047,
        "WB": 55,
        "HC": 1349,
        "SCH": 291,
        "HP": 111,
        "AP": "£446,649",
        "SPC": "0.7%"
    },
    {
        "UID": 329,
        "SN": "Wareham",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 328,
        "NE": 353,
        "WB": 113,
        "HC": 568,
        "SCH": 1316,
        "HP": 503,
        "AP": "£609,527",
        "SPC": "2.9%"
    },
    {
        "UID": 330,
        "SN": "Cottam (Preston)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 330,
        "NE": 37,
        "WB": 761,
        "HC": 786,
        "SCH": 704,
        "HP": 567,
        "AP": "£347,706",
        "SPC": "1.2%"
    },
    {
        "UID": 331,
        "SN": "Accrington",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 331,
        "NE": 260,
        "WB": 1338,
        "HC": 188,
        "SCH": 92,
        "HP": 978,
        "AP": "£185,647",
        "SPC": "-6.3%"
    },
    {
        "UID": 332,
        "SN": "Folkestone",
        "COU": "Kent",
        "REG": "South East",
        "OR": 332,
        "NE": 296,
        "WB": 561,
        "HC": 222,
        "SCH": 544,
        "HP": 1234,
        "AP": "£462,986",
        "SPC": "0.1%"
    },
    {
        "UID": 333,
        "SN": "Exeter",
        "COU": "Devon",
        "REG": "South West",
        "OR": 333,
        "NE": 683,
        "WB": 622,
        "HC": 239,
        "SCH": 354,
        "HP": 963,
        "AP": "£523,276",
        "SPC": "2.7%"
    },
    {
        "UID": 334,
        "SN": "Ulverston",
        "COU": "Westmorland and Furness",
        "REG": "North West",
        "OR": 334,
        "NE": 1034,
        "WB": 124,
        "HC": 525,
        "SCH": 886,
        "HP": 296,
        "AP": "£372,318",
        "SPC": "-0.2%"
    },
    {
        "UID": 335,
        "SN": "Kendal",
        "COU": "Westmorland and Furness",
        "REG": "North West",
        "OR": 335,
        "NE": 727,
        "WB": 165,
        "HC": 685,
        "SCH": 717,
        "HP": 572,
        "AP": "£444,804",
        "SPC": "5.7%"
    },
    {
        "UID": 336,
        "SN": "Royston (North Hertfordshire)",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 336,
        "NE": 199,
        "WB": 671,
        "HC": 1026,
        "SCH": 841,
        "HP": 130,
        "AP": "£617,993",
        "SPC": "0.4%"
    },
    {
        "UID": 337,
        "SN": "Carlisle",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 336,
        "NE": 584,
        "WB": 748,
        "HC": 320,
        "SCH": 597,
        "HP": 618,
        "AP": "£237,731",
        "SPC": "-0.5%"
    },
    {
        "UID": 338,
        "SN": "Shipston-on-Stour",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 338,
        "NE": 955,
        "WB": 190,
        "HC": 1118,
        "SCH": 301,
        "HP": 305,
        "AP": "£538,185",
        "SPC": "4.9%"
    },
    {
        "UID": 339,
        "SN": "Ealing",
        "COU": "London",
        "REG": "Greater London",
        "OR": 339,
        "NE": 535,
        "WB": 1063,
        "HC": 117,
        "SCH": 154,
        "HP": 1002,
        "AP": "£1,014,449",
        "SPC": "1.2%"
    },
    {
        "UID": 340,
        "SN": "Willington (County Durham)",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 340,
        "NE": 78,
        "WB": 429,
        "HC": 1318,
        "SCH": 241,
        "HP": 806,
        "AP": "£172,405",
        "SPC": "-2.9%"
    },
    {
        "UID": 341,
        "SN": "Dukinfield",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 341,
        "NE": 134,
        "WB": 1249,
        "HC": 244,
        "SCH": 131,
        "HP": 1115,
        "AP": "£344,516",
        "SPC": "3.6%"
    },
    {
        "UID": 342,
        "SN": "Warrington",
        "COU": "Warrington",
        "REG": "North West",
        "OR": 342,
        "NE": 1100,
        "WB": 680,
        "HC": 455,
        "SCH": 315,
        "HP": 325,
        "AP": "£382,979",
        "SPC": "1.3%"
    },
    {
        "UID": 343,
        "SN": "Rochester",
        "COU": "Medway",
        "REG": "South East",
        "OR": 343,
        "NE": 247,
        "WB": 1006,
        "HC": 68,
        "SCH": 373,
        "HP": 1185,
        "AP": "£535,065",
        "SPC": "2.3%"
    },
    {
        "UID": 344,
        "SN": "Blaydon",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 343,
        "NE": 509,
        "WB": 734,
        "HC": 207,
        "SCH": 735,
        "HP": 694,
        "AP": "£258,606",
        "SPC": "2.4%"
    },
    {
        "UID": 345,
        "SN": "Skelton (Redcar and Cleveland)",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 345,
        "NE": 258,
        "WB": 636,
        "HC": 663,
        "SCH": 809,
        "HP": 514,
        "AP": "£239,411",
        "SPC": "-5.6%"
    },
    {
        "UID": 346,
        "SN": "Warminster",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 345,
        "NE": 452,
        "WB": 209,
        "HC": 422,
        "SCH": 1167,
        "HP": 630,
        "AP": "£456,780",
        "SPC": "0.3%"
    },
    {
        "UID": 347,
        "SN": "Liverpool",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 347,
        "NE": 528,
        "WB": 1228,
        "HC": 17,
        "SCH": 212,
        "HP": 896,
        "AP": "£288,991",
        "SPC": "0.7%"
    },
    {
        "UID": 348,
        "SN": "Patchway",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 347,
        "NE": 250,
        "WB": 1374,
        "HC": 783,
        "SCH": 282,
        "HP": 192,
        "AP": "£516,921",
        "SPC": "-1.7%"
    },
    {
        "UID": 349,
        "SN": "Windsor",
        "COU": "Windsor and Maidenhead",
        "REG": "South East",
        "OR": 349,
        "NE": 1102,
        "WB": 902,
        "HC": 102,
        "SCH": 726,
        "HP": 52,
        "AP": "£810,807",
        "SPC": "-1.4%"
    },
    {
        "UID": 350,
        "SN": "Salford",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 350,
        "NE": 1064,
        "WB": 1399,
        "HC": 143,
        "SCH": 70,
        "HP": 223,
        "AP": "£405,029",
        "SPC": "-16.3%"
    },
    {
        "UID": 351,
        "SN": "Weston (Dorset)",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 351,
        "NE": 193,
        "WB": 474,
        "HC": 254,
        "SCH": 1252,
        "HP": 727,
        "AP": "£378,607",
        "SPC": "-1.5%"
    },
    {
        "UID": 352,
        "SN": "Alton (East Hampshire)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 352,
        "NE": 114,
        "WB": 99,
        "HC": 992,
        "SCH": 1243,
        "HP": 453,
        "AP": "£594,305",
        "SPC": "-1.3%"
    },
    {
        "UID": 353,
        "SN": "Hindhead",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 352,
        "NE": 223,
        "WB": 309,
        "HC": 1200,
        "SCH": 744,
        "HP": 425,
        "AP": "£725,216",
        "SPC": "7.3%"
    },
    {
        "UID": 354,
        "SN": "Sawbridgeworth",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 352,
        "NE": 1327,
        "WB": 224,
        "HC": 414,
        "SCH": 774,
        "HP": 162,
        "AP": "£714,191",
        "SPC": "2.8%"
    },
    {
        "UID": 355,
        "SN": "Sunderland",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 355,
        "NE": 98,
        "WB": 1377,
        "HC": 111,
        "SCH": 523,
        "HP": 801,
        "AP": "£218,196",
        "SPC": "-5.1%"
    },
    {
        "UID": 356,
        "SN": "East Cowes",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 355,
        "NE": 173,
        "WB": 345,
        "HC": 166,
        "SCH": 798,
        "HP": 1428,
        "AP": "£445,950",
        "SPC": "8.5%"
    },
    {
        "UID": 357,
        "SN": "Plymouth",
        "COU": "Plymouth",
        "REG": "South West",
        "OR": 357,
        "NE": 159,
        "WB": 1077,
        "HC": 163,
        "SCH": 121,
        "HP": 1391,
        "AP": "£376,822",
        "SPC": "4.4%"
    },
    {
        "UID": 358,
        "SN": "Wideopen",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 358,
        "NE": 157,
        "WB": 646,
        "HC": 666,
        "SCH": 1371,
        "HP": 73,
        "AP": "£345,325",
        "SPC": "-1.2%"
    },
    {
        "UID": 359,
        "SN": "Telford",
        "COU": "Telford and Wrekin",
        "REG": "West Midlands",
        "OR": 359,
        "NE": 148,
        "WB": 780,
        "HC": 656,
        "SCH": 328,
        "HP": 1003,
        "AP": "£336,341",
        "SPC": "2.6%"
    },
    {
        "UID": 360,
        "SN": "Earl Shilton",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 360,
        "NE": 260,
        "WB": 385,
        "HC": 1279,
        "SCH": 573,
        "HP": 419,
        "AP": "£373,857",
        "SPC": "-0.3%"
    },
    {
        "UID": 361,
        "SN": "Newquay",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 361,
        "NE": 433,
        "WB": 468,
        "HC": 994,
        "SCH": 538,
        "HP": 485,
        "AP": "£555,126",
        "SPC": "-1.1%"
    },
    {
        "UID": 362,
        "SN": "Penfro",
        "COU": "Pembrokeshire",
        "REG": "Wales",
        "OR": 362,
        "NE": 93,
        "WB": 450,
        "HC": 546,
        "SCH": 1352,
        "HP": 480,
        "AP": "£305,294",
        "SPC": "-4.0%"
    },
    {
        "UID": 363,
        "SN": "Bury (Bury)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 363,
        "NE": 944,
        "WB": 1224,
        "HC": 80,
        "SCH": 59,
        "HP": 615,
        "AP": "£351,434",
        "SPC": "1.7%"
    },
    {
        "UID": 364,
        "SN": "Rawtenstall",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 364,
        "NE": 896,
        "WB": 706,
        "HC": 79,
        "SCH": 285,
        "HP": 958,
        "AP": "£303,601",
        "SPC": "-0.6%"
    },
    {
        "UID": 365,
        "SN": "Streetly",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 364,
        "NE": 512,
        "WB": 409,
        "HC": 875,
        "SCH": 302,
        "HP": 826,
        "AP": "£549,791",
        "SPC": "3.2%"
    },
    {
        "UID": 366,
        "SN": "Otford and Kemsing",
        "COU": "Kent",
        "REG": "South East",
        "OR": 366,
        "NE": 204,
        "WB": 541,
        "HC": 825,
        "SCH": 1139,
        "HP": 217,
        "AP": "£842,645",
        "SPC": "3.1%"
    },
    {
        "UID": 367,
        "SN": "Jarrow",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 367,
        "NE": 218,
        "WB": 1055,
        "HC": 398,
        "SCH": 486,
        "HP": 771,
        "AP": "£219,686",
        "SPC": "-1.4%"
    },
    {
        "UID": 368,
        "SN": "Yate",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 367,
        "NE": 443,
        "WB": 571,
        "HC": 1386,
        "SCH": 273,
        "HP": 255,
        "AP": "£514,277",
        "SPC": "-0.7%"
    },
    {
        "UID": 369,
        "SN": "Bagshot",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 369,
        "NE": 1116,
        "WB": 505,
        "HC": 738,
        "SCH": 504,
        "HP": 69,
        "AP": "£671,952",
        "SPC": "-3.1%"
    },
    {
        "UID": 370,
        "SN": "Hedon",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 370,
        "NE": 1426,
        "WB": 292,
        "HC": 650,
        "SCH": 199,
        "HP": 371,
        "AP": "£305,643",
        "SPC": "-1.7%"
    },
    {
        "UID": 371,
        "SN": "Sheffield",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 371,
        "NE": 375,
        "WB": 1201,
        "HC": 145,
        "SCH": 784,
        "HP": 437,
        "AP": "£376,243",
        "SPC": "2.4%"
    },
    {
        "UID": 372,
        "SN": "Winslow",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 371,
        "NE": 285,
        "WB": 61,
        "HC": 1027,
        "SCH": 1241,
        "HP": 328,
        "AP": "£614,082",
        "SPC": "-0.6%"
    },
    {
        "UID": 373,
        "SN": "Smethwick",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 373,
        "NE": 284,
        "WB": 1116,
        "HC": 87,
        "SCH": 91,
        "HP": 1373,
        "AP": "£320,557",
        "SPC": "3.6%"
    },
    {
        "UID": 374,
        "SN": "Blandford Forum",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 374,
        "NE": 656,
        "WB": 104,
        "HC": 754,
        "SCH": 1079,
        "HP": 359,
        "AP": "£490,195",
        "SPC": "-4.2%"
    },
    {
        "UID": 375,
        "SN": "Loughton",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 375,
        "NE": 1035,
        "WB": 867,
        "HC": 890,
        "SCH": 99,
        "HP": 62,
        "AP": "£862,659",
        "SPC": "1.0%"
    },
    {
        "UID": 376,
        "SN": "Greenwich",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 376,
        "NE": 806,
        "WB": 1179,
        "HC": 40,
        "SCH": 137,
        "HP": 792,
        "AP": "£839,928",
        "SPC": "-3.0%"
    },
    {
        "UID": 377,
        "SN": "Chadderton",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 377,
        "NE": 116,
        "WB": 1289,
        "HC": 259,
        "SCH": 7,
        "HP": 1292,
        "AP": "£333,171",
        "SPC": "4.8%"
    },
    {
        "UID": 378,
        "SN": "Birmingham",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 377,
        "NE": 597,
        "WB": 1295,
        "HC": 108,
        "SCH": 247,
        "HP": 716,
        "AP": "£382,655",
        "SPC": "-0.5%"
    },
    {
        "UID": 379,
        "SN": "Stapleford",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 379,
        "NE": 1076,
        "WB": 622,
        "HC": 355,
        "SCH": 175,
        "HP": 741,
        "AP": "£368,828",
        "SPC": "4.4%"
    },
    {
        "UID": 380,
        "SN": "Walton-on-Thames",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 380,
        "NE": 943,
        "WB": 942,
        "HC": 388,
        "SCH": 687,
        "HP": 11,
        "AP": "£815,693",
        "SPC": "-2.2%"
    },
    {
        "UID": 381,
        "SN": "Carterton",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 381,
        "NE": 312,
        "WB": 202,
        "HC": 1329,
        "SCH": 47,
        "HP": 1082,
        "AP": "£528,297",
        "SPC": "1.4%"
    },
    {
        "UID": 382,
        "SN": "Oldham",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 382,
        "NE": 221,
        "WB": 1266,
        "HC": 69,
        "SCH": 10,
        "HP": 1407,
        "AP": "£260,567",
        "SPC": "5.5%"
    },
    {
        "UID": 383,
        "SN": "Christchurch (Bournemouth, Christchurch and Poole)",
        "COU": "Bournemouth, Christchurch and Poole",
        "REG": "South West",
        "OR": 383,
        "NE": 869,
        "WB": 620,
        "HC": 288,
        "SCH": 1038,
        "HP": 160,
        "AP": "£659,850",
        "SPC": "-4.6%"
    },
    {
        "UID": 384,
        "SN": "Beverley",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 384,
        "NE": 1301,
        "WB": 579,
        "HC": 616,
        "SCH": 245,
        "HP": 235,
        "AP": "£391,694",
        "SPC": "0.8%"
    },
    {
        "UID": 385,
        "SN": "Houghton-le-Spring",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 385,
        "NE": 252,
        "WB": 830,
        "HC": 905,
        "SCH": 196,
        "HP": 794,
        "AP": "£214,103",
        "SPC": "-8.1%"
    },
    {
        "UID": 386,
        "SN": "Llandrindod",
        "COU": "Powys",
        "REG": "Wales",
        "OR": 385,
        "NE": 618,
        "WB": 267,
        "HC": 910,
        "SCH": 211,
        "HP": 971,
        "AP": "£265,219",
        "SPC": "-10.7%"
    },
    {
        "UID": 387,
        "SN": "Sandy",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 385,
        "NE": 582,
        "WB": 306,
        "HC": 1206,
        "SCH": 226,
        "HP": 657,
        "AP": "£521,534",
        "SPC": "3.5%"
    },
    {
        "UID": 388,
        "SN": "Radcliffe on Trent",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 385,
        "NE": 1402,
        "WB": 236,
        "HC": 513,
        "SCH": 489,
        "HP": 337,
        "AP": "£440,546",
        "SPC": "4.3%"
    },
    {
        "UID": 389,
        "SN": "Ramsbottom",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 389,
        "NE": 1219,
        "WB": 1234,
        "HC": 120,
        "SCH": 132,
        "HP": 273,
        "AP": "£422,946",
        "SPC": "0.1%"
    },
    {
        "UID": 390,
        "SN": "Waddington (North Kesteven)",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 390,
        "NE": 1047,
        "WB": 16,
        "HC": 868,
        "SCH": 174,
        "HP": 874,
        "AP": "£379,627",
        "SPC": "5.1%"
    },
    {
        "UID": 391,
        "SN": "Newcastle-under-Lyme",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 391,
        "NE": 437,
        "WB": 709,
        "HC": 419,
        "SCH": 367,
        "HP": 1048,
        "AP": "£299,026",
        "SPC": "0.7%"
    },
    {
        "UID": 392,
        "SN": "Abertawe",
        "COU": "Swansea",
        "REG": "Wales",
        "OR": 392,
        "NE": 388,
        "WB": 1222,
        "HC": 122,
        "SCH": 580,
        "HP": 669,
        "AP": "£299,478",
        "SPC": "-0.3%"
    },
    {
        "UID": 393,
        "SN": "Liphook",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 392,
        "NE": 274,
        "WB": 82,
        "HC": 1299,
        "SCH": 834,
        "HP": 492,
        "AP": "£643,933",
        "SPC": "0.6%"
    },
    {
        "UID": 394,
        "SN": "Bootle (Sefton)",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 394,
        "NE": 224,
        "WB": 1212,
        "HC": 176,
        "SCH": 127,
        "HP": 1244,
        "AP": "£207,642",
        "SPC": "4.1%"
    },
    {
        "UID": 395,
        "SN": "Pershore",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 395,
        "NE": 729,
        "WB": 392,
        "HC": 953,
        "SCH": 804,
        "HP": 109,
        "AP": "£450,332",
        "SPC": "-5.8%"
    },
    {
        "UID": 396,
        "SN": "Norwich",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 396,
        "NE": 205,
        "WB": 1083,
        "HC": 55,
        "SCH": 337,
        "HP": 1309,
        "AP": "£465,199",
        "SPC": "2.5%"
    },
    {
        "UID": 397,
        "SN": "Stoke-on-Trent",
        "COU": "Stoke-on-Trent",
        "REG": "West Midlands",
        "OR": 396,
        "NE": 437,
        "WB": 817,
        "HC": 275,
        "SCH": 275,
        "HP": 1185,
        "AP": "£252,166",
        "SPC": "-1.5%"
    },
    {
        "UID": 398,
        "SN": "Y Rhws",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 398,
        "NE": 391,
        "WB": 651,
        "HC": 1388,
        "SCH": 473,
        "HP": 101,
        "AP": "£430,946",
        "SPC": "-1.5%"
    },
    {
        "UID": 399,
        "SN": "Market Harborough",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 399,
        "NE": 1171,
        "WB": 135,
        "HC": 670,
        "SCH": 763,
        "HP": 271,
        "AP": "£494,346",
        "SPC": "3.3%"
    },
    {
        "UID": 400,
        "SN": "Boldon Colliery",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 400,
        "NE": 337,
        "WB": 738,
        "HC": 443,
        "SCH": 948,
        "HP": 545,
        "AP": "£253,722",
        "SPC": "-1.3%"
    },
    {
        "UID": 401,
        "SN": "Ibstock",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 401,
        "NE": 517,
        "WB": 636,
        "HC": 966,
        "SCH": 685,
        "HP": 213,
        "AP": "£352,041",
        "SPC": "-3.9%"
    },
    {
        "UID": 402,
        "SN": "Oadby",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 401,
        "NE": 1149,
        "WB": 385,
        "HC": 599,
        "SCH": 459,
        "HP": 425,
        "AP": "£478,349",
        "SPC": "-2.5%"
    },
    {
        "UID": 403,
        "SN": "Solihull",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 403,
        "NE": 648,
        "WB": 1285,
        "HC": 661,
        "SCH": 289,
        "HP": 142,
        "AP": "£538,972",
        "SPC": "2.7%"
    },
    {
        "UID": 404,
        "SN": "Walkden",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 404,
        "NE": 939,
        "WB": 1278,
        "HC": 417,
        "SCH": 11,
        "HP": 384,
        "AP": "£389,893",
        "SPC": "-2.0%"
    },
    {
        "UID": 405,
        "SN": "Southport",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 404,
        "NE": 1255,
        "WB": 593,
        "HC": 144,
        "SCH": 380,
        "HP": 657,
        "AP": "£314,250",
        "SPC": "1.0%"
    },
    {
        "UID": 406,
        "SN": "Redhill (Reigate and Banstead)",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 406,
        "NE": 844,
        "WB": 674,
        "HC": 525,
        "SCH": 885,
        "HP": 103,
        "AP": "£692,550",
        "SPC": "-1.3%"
    },
    {
        "UID": 407,
        "SN": "Rowlands Gill",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 407,
        "NE": 175,
        "WB": 188,
        "HC": 1093,
        "SCH": 1220,
        "HP": 357,
        "AP": "£295,977",
        "SPC": "0.7%"
    },
    {
        "UID": 408,
        "SN": "Nuthall and Watnall",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 408,
        "NE": 1039,
        "WB": 838,
        "HC": 480,
        "SCH": 491,
        "HP": 186,
        "AP": "£417,730",
        "SPC": "-0.2%"
    },
    {
        "UID": 409,
        "SN": "Great Torrington",
        "COU": "Devon",
        "REG": "South West",
        "OR": 408,
        "NE": 210,
        "WB": 166,
        "HC": 601,
        "SCH": 642,
        "HP": 1415,
        "AP": "£441,763",
        "SPC": "11.0%"
    },
    {
        "UID": 410,
        "SN": "Worthing",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 410,
        "NE": 404,
        "WB": 614,
        "HC": 468,
        "SCH": 356,
        "HP": 1194,
        "AP": "£625,036",
        "SPC": "3.1%"
    },
    {
        "UID": 411,
        "SN": "Harrow",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 411,
        "NE": 447,
        "WB": 935,
        "HC": 371,
        "SCH": 230,
        "HP": 1054,
        "AP": "£846,959",
        "SPC": "0.6%"
    },
    {
        "UID": 412,
        "SN": "South Shields",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 412,
        "NE": 107,
        "WB": 1331,
        "HC": 199,
        "SCH": 467,
        "HP": 935,
        "AP": "£237,136",
        "SPC": "1.7%"
    },
    {
        "UID": 413,
        "SN": "Wellesbourne",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 412,
        "NE": 1334,
        "WB": 387,
        "HC": 259,
        "SCH": 865,
        "HP": 194,
        "AP": "£515,057",
        "SPC": "2.7%"
    },
    {
        "UID": 414,
        "SN": "Cirencester",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 414,
        "NE": 735,
        "WB": 28,
        "HC": 785,
        "SCH": 744,
        "HP": 748,
        "AP": "£555,324",
        "SPC": "9.3%"
    },
    {
        "UID": 415,
        "SN": "Penistone",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 415,
        "NE": 620,
        "WB": 66,
        "HC": 917,
        "SCH": 688,
        "HP": 751,
        "AP": "£366,660",
        "SPC": "2.2%"
    },
    {
        "UID": 416,
        "SN": "Heswall",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 415,
        "NE": 269,
        "WB": 183,
        "HC": 939,
        "SCH": 1277,
        "HP": 374,
        "AP": "£469,751",
        "SPC": "3.9%"
    },
    {
        "UID": 417,
        "SN": "Royal Sutton Coldfield",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 417,
        "NE": 756,
        "WB": 997,
        "HC": 404,
        "SCH": 408,
        "HP": 479,
        "AP": "£518,033",
        "SPC": "1.0%"
    },
    {
        "UID": 418,
        "SN": "Bracebridge Heath",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 418,
        "NE": 1044,
        "WB": 132,
        "HC": 892,
        "SCH": 224,
        "HP": 755,
        "AP": "£387,596",
        "SPC": "4.0%"
    },
    {
        "UID": 419,
        "SN": "Battle",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 418,
        "NE": 139,
        "WB": 94,
        "HC": 321,
        "SCH": 1245,
        "HP": 1248,
        "AP": "£579,480",
        "SPC": "2.1%"
    },
    {
        "UID": 420,
        "SN": "Royton",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 420,
        "NE": 310,
        "WB": 1158,
        "HC": 582,
        "SCH": 69,
        "HP": 930,
        "AP": "£341,949",
        "SPC": "0.6%"
    },
    {
        "UID": 421,
        "SN": "Leiston",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 420,
        "NE": 53,
        "WB": 7,
        "HC": 619,
        "SCH": 1382,
        "HP": 988,
        "AP": "£407,940",
        "SPC": "-4.1%"
    },
    {
        "UID": 422,
        "SN": "Cheshunt",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 422,
        "NE": 1288,
        "WB": 835,
        "HC": 537,
        "SCH": 198,
        "HP": 195,
        "AP": "£714,436",
        "SPC": "0.9%"
    },
    {
        "UID": 423,
        "SN": "Durham",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 423,
        "NE": 394,
        "WB": 996,
        "HC": 464,
        "SCH": 651,
        "HP": 549,
        "AP": "£342,496",
        "SPC": "3.6%"
    },
    {
        "UID": 424,
        "SN": "Ilkeston",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 424,
        "NE": 785,
        "WB": 642,
        "HC": 871,
        "SCH": 90,
        "HP": 667,
        "AP": "£305,482",
        "SPC": "-0.3%"
    },
    {
        "UID": 425,
        "SN": "Ryton",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 424,
        "NE": 1278,
        "WB": 645,
        "HC": 104,
        "SCH": 838,
        "HP": 190,
        "AP": "£285,598",
        "SPC": "-2.6%"
    },
    {
        "UID": 426,
        "SN": "Tenterden",
        "COU": "Kent",
        "REG": "South East",
        "OR": 424,
        "NE": 305,
        "WB": 411,
        "HC": 437,
        "SCH": 1070,
        "HP": 832,
        "AP": "£652,001",
        "SPC": "-0.6%"
    },
    {
        "UID": 427,
        "SN": "Prescot",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 427,
        "NE": 596,
        "WB": 729,
        "HC": 752,
        "SCH": 42,
        "HP": 937,
        "AP": "£295,327",
        "SPC": "-0.5%"
    },
    {
        "UID": 428,
        "SN": "Gloucester",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 428,
        "NE": 430,
        "WB": 748,
        "HC": 226,
        "SCH": 298,
        "HP": 1356,
        "AP": "£424,962",
        "SPC": "3.7%"
    },
    {
        "UID": 429,
        "SN": "Littleborough",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 429,
        "NE": 1228,
        "WB": 598,
        "HC": 142,
        "SCH": 28,
        "HP": 1064,
        "AP": "£350,800",
        "SPC": "3.8%"
    },
    {
        "UID": 430,
        "SN": "Devizes",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 430,
        "NE": 117,
        "WB": 444,
        "HC": 658,
        "SCH": 1313,
        "HP": 532,
        "AP": "£454,946",
        "SPC": "-0.8%"
    },
    {
        "UID": 431,
        "SN": "Cromer",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 431,
        "NE": 94,
        "WB": 86,
        "HC": 213,
        "SCH": 1296,
        "HP": 1376,
        "AP": "£472,364",
        "SPC": "3.5%"
    },
    {
        "UID": 432,
        "SN": "Overseal and Castle Gresley",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 432,
        "NE": 968,
        "WB": 244,
        "HC": 575,
        "SCH": 721,
        "HP": 560,
        "AP": "£366,698",
        "SPC": "3.8%"
    },
    {
        "UID": 433,
        "SN": "Hinckley",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 433,
        "NE": 921,
        "WB": 472,
        "HC": 1032,
        "SCH": 323,
        "HP": 321,
        "AP": "£414,736",
        "SPC": "0.2%"
    },
    {
        "UID": 434,
        "SN": "Nailsworth",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 433,
        "NE": 926,
        "WB": 471,
        "HC": 313,
        "SCH": 680,
        "HP": 679,
        "AP": "£580,828",
        "SPC": "5.1%"
    },
    {
        "UID": 435,
        "SN": "Wimborne Minster",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 435,
        "NE": 1130,
        "WB": 353,
        "HC": 311,
        "SCH": 1127,
        "HP": 154,
        "AP": "£619,190",
        "SPC": "-2.5%"
    },
    {
        "UID": 436,
        "SN": "Whitefield",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 436,
        "NE": 554,
        "WB": 1201,
        "HC": 447,
        "SCH": 86,
        "HP": 789,
        "AP": "£402,421",
        "SPC": "6.7%"
    },
    {
        "UID": 437,
        "SN": "Haywards Heath",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 437,
        "NE": 288,
        "WB": 36,
        "HC": 957,
        "SCH": 1217,
        "HP": 581,
        "AP": "£704,525",
        "SPC": "6.9%"
    },
    {
        "UID": 438,
        "SN": "Quorndon",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 437,
        "NE": 1410,
        "WB": 432,
        "HC": 484,
        "SCH": 712,
        "HP": 41,
        "AP": "£512,642",
        "SPC": "-4.5%"
    },
    {
        "UID": 439,
        "SN": "Kingston upon Thames",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 439,
        "NE": 878,
        "WB": 1186,
        "HC": 105,
        "SCH": 502,
        "HP": 414,
        "AP": "£965,842",
        "SPC": "1.0%"
    },
    {
        "UID": 440,
        "SN": "Hessle",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 440,
        "NE": 1360,
        "WB": 760,
        "HC": 534,
        "SCH": 195,
        "HP": 237,
        "AP": "£320,359",
        "SPC": "-4.0%"
    },
    {
        "UID": 441,
        "SN": "Haworth",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 441,
        "NE": 603,
        "WB": 555,
        "HC": 191,
        "SCH": 480,
        "HP": 1259,
        "AP": "£322,982",
        "SPC": "10.8%"
    },
    {
        "UID": 442,
        "SN": "Thornbury",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 442,
        "NE": 733,
        "WB": 990,
        "HC": 1167,
        "SCH": 62,
        "HP": 138,
        "AP": "£541,421",
        "SPC": "-2.6%"
    },
    {
        "UID": 443,
        "SN": "Gravesend",
        "COU": "Kent",
        "REG": "South East",
        "OR": 442,
        "NE": 316,
        "WB": 1380,
        "HC": 402,
        "SCH": 113,
        "HP": 879,
        "AP": "£556,925",
        "SPC": "-2.3%"
    },
    {
        "UID": 444,
        "SN": "Irlam",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 444,
        "NE": 893,
        "WB": 808,
        "HC": 626,
        "SCH": 78,
        "HP": 689,
        "AP": "£370,715",
        "SPC": "1.3%"
    },
    {
        "UID": 445,
        "SN": "Radlett",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 445,
        "NE": 1079,
        "WB": 925,
        "HC": 340,
        "SCH": 479,
        "HP": 276,
        "AP": "£1,005,151",
        "SPC": "-3.2%"
    },
    {
        "UID": 446,
        "SN": "Torquay",
        "COU": "Torbay",
        "REG": "South West",
        "OR": 446,
        "NE": 722,
        "WB": 692,
        "HC": 18,
        "SCH": 264,
        "HP": 1404,
        "AP": "£413,830",
        "SPC": "4.6%"
    },
    {
        "UID": 447,
        "SN": "Strensall",
        "COU": "York",
        "REG": "Yorkshire and The Humber",
        "OR": 446,
        "NE": 1139,
        "WB": 45,
        "HC": 488,
        "SCH": 1067,
        "HP": 361,
        "AP": "£525,729",
        "SPC": "2.4%"
    },
    {
        "UID": 448,
        "SN": "Burgess Hill",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 448,
        "NE": 90,
        "WB": 237,
        "HC": 1272,
        "SCH": 986,
        "HP": 516,
        "AP": "£668,499",
        "SPC": "4.0%"
    },
    {
        "UID": 449,
        "SN": "Beaconsfield",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 448,
        "NE": 182,
        "WB": 851,
        "HC": 504,
        "SCH": 1194,
        "HP": 370,
        "AP": "£1,030,709",
        "SPC": "4.8%"
    },
    {
        "UID": 450,
        "SN": "Blaby and Whetstone",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 450,
        "NE": 1207,
        "WB": 551,
        "HC": 596,
        "SCH": 372,
        "HP": 376,
        "AP": "£456,320",
        "SPC": "2.1%"
    },
    {
        "UID": 451,
        "SN": "Filton",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 451,
        "NE": 701,
        "WB": 1412,
        "HC": 653,
        "SCH": 116,
        "HP": 222,
        "AP": "£524,460",
        "SPC": "-0.8%"
    },
    {
        "UID": 452,
        "SN": "Sandhurst (Bracknell Forest)",
        "COU": "Bracknell Forest",
        "REG": "South East",
        "OR": 452,
        "NE": 936,
        "WB": 589,
        "HC": 792,
        "SCH": 543,
        "HP": 247,
        "AP": "£681,807",
        "SPC": "-1.0%"
    },
    {
        "UID": 453,
        "SN": "Saffron Walden",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 453,
        "NE": 1089,
        "WB": 290,
        "HC": 840,
        "SCH": 785,
        "HP": 105,
        "AP": "£638,414",
        "SPC": "-0.2%"
    },
    {
        "UID": 454,
        "SN": "Amersham",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 454,
        "NE": 787,
        "WB": 510,
        "HC": 604,
        "SCH": 994,
        "HP": 219,
        "AP": "£962,217",
        "SPC": "2.5%"
    },
    {
        "UID": 455,
        "SN": "Hartlepool",
        "COU": "Hartlepool",
        "REG": "North East",
        "OR": 455,
        "NE": 310,
        "WB": 1253,
        "HC": 580,
        "SCH": 332,
        "HP": 641,
        "AP": "£194,619",
        "SPC": "-1.0%"
    },
    {
        "UID": 456,
        "SN": "Newton-le-Willows",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 455,
        "NE": 599,
        "WB": 795,
        "HC": 595,
        "SCH": 348,
        "HP": 779,
        "AP": "£323,635",
        "SPC": "0.7%"
    },
    {
        "UID": 457,
        "SN": "Lewisham",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 457,
        "NE": 824,
        "WB": 1150,
        "HC": 29,
        "SCH": 163,
        "HP": 954,
        "AP": "£891,661",
        "SPC": "0.8%"
    },
    {
        "UID": 458,
        "SN": "Eastwood",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 458,
        "NE": 853,
        "WB": 481,
        "HC": 888,
        "SCH": 206,
        "HP": 696,
        "AP": "£361,186",
        "SPC": "3.3%"
    },
    {
        "UID": 459,
        "SN": "Brackley",
        "COU": "West Northamptonshire",
        "REG": "East Midlands",
        "OR": 458,
        "NE": 558,
        "WB": 654,
        "HC": 1320,
        "SCH": 146,
        "HP": 446,
        "AP": "£539,398",
        "SPC": "6.1%"
    },
    {
        "UID": 460,
        "SN": "Bolton (Bolton)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 460,
        "NE": 639,
        "WB": 1285,
        "HC": 124,
        "SCH": 9,
        "HP": 1071,
        "AP": "£301,367",
        "SPC": "1.6%"
    },
    {
        "UID": 461,
        "SN": "Shelf and Northowram",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 460,
        "NE": 603,
        "WB": 754,
        "HC": 33,
        "SCH": 1207,
        "HP": 531,
        "AP": "£356,621",
        "SPC": "0.9%"
    },
    {
        "UID": 462,
        "SN": "Thatcham",
        "COU": "West Berkshire",
        "REG": "South East",
        "OR": 462,
        "NE": 65,
        "WB": 62,
        "HC": 1268,
        "SCH": 1090,
        "HP": 644,
        "AP": "£612,317",
        "SPC": "3.5%"
    },
    {
        "UID": 463,
        "SN": "South Merstham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 463,
        "NE": 658,
        "WB": 1099,
        "HC": 471,
        "SCH": 500,
        "HP": 404,
        "AP": "£673,576",
        "SPC": "2.9%"
    },
    {
        "UID": 464,
        "SN": "Chertsey",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 464,
        "NE": 1271,
        "WB": 768,
        "HC": 90,
        "SCH": 945,
        "HP": 59,
        "AP": "£731,017",
        "SPC": "-1.6%"
    },
    {
        "UID": 465,
        "SN": "Gildersome",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 464,
        "NE": 675,
        "WB": 1426,
        "HC": 209,
        "SCH": 321,
        "HP": 502,
        "AP": "£386,706",
        "SPC": "4.8%"
    },
    {
        "UID": 466,
        "SN": "Freshwater and Totland",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 466,
        "NE": 254,
        "WB": 97,
        "HC": 502,
        "SCH": 892,
        "HP": 1389,
        "AP": "£514,295",
        "SPC": "3.4%"
    },
    {
        "UID": 467,
        "SN": "Abertridwr and Senghenydd",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 467,
        "NE": 542,
        "WB": 435,
        "HC": 1113,
        "SCH": 202,
        "HP": 845,
        "AP": "£221,283",
        "SPC": "-5.4%"
    },
    {
        "UID": 468,
        "SN": "West End and Chobham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 467,
        "NE": 1215,
        "WB": 246,
        "HC": 171,
        "SCH": 1193,
        "HP": 312,
        "AP": "£874,421",
        "SPC": "7.6%"
    },
    {
        "UID": 469,
        "SN": "Botley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 469,
        "NE": 808,
        "WB": 254,
        "HC": 77,
        "SCH": 850,
        "HP": 1150,
        "AP": "£589,323",
        "SPC": "6.8%"
    },
    {
        "UID": 470,
        "SN": "Shildon",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 470,
        "NE": 106,
        "WB": 649,
        "HC": 1029,
        "SCH": 295,
        "HP": 1061,
        "AP": "£125,626",
        "SPC": "0.4%"
    },
    {
        "UID": 471,
        "SN": "Preston (Preston)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 471,
        "NE": 603,
        "WB": 1373,
        "HC": 75,
        "SCH": 399,
        "HP": 692,
        "AP": "£227,898",
        "SPC": "-4.9%"
    },
    {
        "UID": 472,
        "SN": "Gerrards Cross",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 472,
        "NE": 129,
        "WB": 1046,
        "HC": 855,
        "SCH": 618,
        "HP": 500,
        "AP": "£1,033,651",
        "SPC": "14.1%"
    },
    {
        "UID": 473,
        "SN": "Alcester",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 473,
        "NE": 1245,
        "WB": 69,
        "HC": 903,
        "SCH": 861,
        "HP": 71,
        "AP": "£493,032",
        "SPC": "-0.8%"
    },
    {
        "UID": 474,
        "SN": "Ipswich",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 474,
        "NE": 180,
        "WB": 1062,
        "HC": 158,
        "SCH": 434,
        "HP": 1317,
        "AP": "£414,486",
        "SPC": "1.8%"
    },
    {
        "UID": 475,
        "SN": "Haslingden",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 475,
        "NE": 526,
        "WB": 905,
        "HC": 256,
        "SCH": 360,
        "HP": 1106,
        "AP": "£311,328",
        "SPC": "1.4%"
    },
    {
        "UID": 476,
        "SN": "Verwood",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 476,
        "NE": 36,
        "WB": 325,
        "HC": 1375,
        "SCH": 1066,
        "HP": 354,
        "AP": "£618,082",
        "SPC": "1.2%"
    },
    {
        "UID": 477,
        "SN": "Ampthill",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 477,
        "NE": 302,
        "WB": 889,
        "HC": 801,
        "SCH": 736,
        "HP": 429,
        "AP": "£668,676",
        "SPC": "6.2%"
    },
    {
        "UID": 478,
        "SN": "Wrecclesham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 477,
        "NE": 789,
        "WB": 330,
        "HC": 788,
        "SCH": 1121,
        "HP": 129,
        "AP": "£847,395",
        "SPC": "2.6%"
    },
    {
        "UID": 479,
        "SN": "Hastings",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 479,
        "NE": 249,
        "WB": 641,
        "HC": 24,
        "SCH": 1024,
        "HP": 1220,
        "AP": "£490,795",
        "SPC": "-0.4%"
    },
    {
        "UID": 480,
        "SN": "Bexhill-on-Sea",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 479,
        "NE": 391,
        "WB": 287,
        "HC": 192,
        "SCH": 931,
        "HP": 1357,
        "AP": "£519,020",
        "SPC": "2.6%"
    },
    {
        "UID": 481,
        "SN": "Greasby",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 481,
        "NE": 220,
        "WB": 288,
        "HC": 857,
        "SCH": 1293,
        "HP": 501,
        "AP": "£442,534",
        "SPC": "6.1%"
    },
    {
        "UID": 482,
        "SN": "Blaenavon",
        "COU": "Torfaen",
        "REG": "Wales",
        "OR": 482,
        "NE": 313,
        "WB": 607,
        "HC": 277,
        "SCH": 556,
        "HP": 1407,
        "AP": "£251,280",
        "SPC": "8.8%"
    },
    {
        "UID": 483,
        "SN": "Swanscombe",
        "COU": "Kent",
        "REG": "South East",
        "OR": 483,
        "NE": 866,
        "WB": 1223,
        "HC": 381,
        "SCH": 101,
        "HP": 591,
        "AP": "£579,624",
        "SPC": "-1.0%"
    },
    {
        "UID": 484,
        "SN": "Rochdale",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 483,
        "NE": 397,
        "WB": 1365,
        "HC": 114,
        "SCH": 89,
        "HP": 1197,
        "AP": "£300,155",
        "SPC": "2.7%"
    },
    {
        "UID": 485,
        "SN": "Hethersett",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 483,
        "NE": 325,
        "WB": 231,
        "HC": 341,
        "SCH": 936,
        "HP": 1329,
        "AP": "£511,993",
        "SPC": "8.2%"
    },
    {
        "UID": 486,
        "SN": "Chalfont St Peter",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 486,
        "NE": 618,
        "WB": 213,
        "HC": 1065,
        "SCH": 846,
        "HP": 422,
        "AP": "£972,270",
        "SPC": "6.4%"
    },
    {
        "UID": 487,
        "SN": "Crawley Down",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 487,
        "NE": 87,
        "WB": 222,
        "HC": 868,
        "SCH": 1375,
        "HP": 617,
        "AP": "£684,004",
        "SPC": "6.7%"
    },
    {
        "UID": 488,
        "SN": "Calverton",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 488,
        "NE": 492,
        "WB": 477,
        "HC": 1251,
        "SCH": 254,
        "HP": 700,
        "AP": "£404,366",
        "SPC": "4.6%"
    },
    {
        "UID": 489,
        "SN": "Wallasey",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 489,
        "NE": 1006,
        "WB": 863,
        "HC": 121,
        "SCH": 374,
        "HP": 812,
        "AP": "£262,448",
        "SPC": "1.2%"
    },
    {
        "UID": 490,
        "SN": "Gillingham (Medway)",
        "COU": "Medway",
        "REG": "South East",
        "OR": 490,
        "NE": 455,
        "WB": 1118,
        "HC": 165,
        "SCH": 306,
        "HP": 1134,
        "AP": "£518,069",
        "SPC": "1.2%"
    },
    {
        "UID": 491,
        "SN": "Shirebrook",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 490,
        "NE": 294,
        "WB": 366,
        "HC": 1162,
        "SCH": 219,
        "HP": 1137,
        "AP": "£232,912",
        "SPC": "-7.7%"
    },
    {
        "UID": 492,
        "SN": "Southwater",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 492,
        "NE": 10,
        "WB": 40,
        "HC": 1239,
        "SCH": 1135,
        "HP": 756,
        "AP": "£696,016",
        "SPC": "3.8%"
    },
    {
        "UID": 493,
        "SN": "Dinbych",
        "COU": "Denbighshire",
        "REG": "Wales",
        "OR": 492,
        "NE": 293,
        "WB": 1039,
        "HC": 491,
        "SCH": 563,
        "HP": 794,
        "AP": "£300,774",
        "SPC": "-5.0%"
    },
    {
        "UID": 494,
        "SN": "Ware",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 492,
        "NE": 1186,
        "WB": 663,
        "HC": 339,
        "SCH": 888,
        "HP": 104,
        "AP": "£746,012",
        "SPC": "2.0%"
    },
    {
        "UID": 495,
        "SN": "Middleton (Rochdale)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 495,
        "NE": 558,
        "WB": 1206,
        "HC": 348,
        "SCH": 19,
        "HP": 1050,
        "AP": "£347,898",
        "SPC": "3.4%"
    },
    {
        "UID": 496,
        "SN": "Kippax",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 496,
        "NE": 327,
        "WB": 499,
        "HC": 1293,
        "SCH": 700,
        "HP": 363,
        "AP": "£373,136",
        "SPC": "2.1%"
    },
    {
        "UID": 497,
        "SN": "Porthcawl",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 497,
        "NE": 69,
        "WB": 756,
        "HC": 1274,
        "SCH": 821,
        "HP": 265,
        "AP": "£449,732",
        "SPC": "-0.7%"
    },
    {
        "UID": 498,
        "SN": "Ramsgate",
        "COU": "Kent",
        "REG": "South East",
        "OR": 498,
        "NE": 442,
        "WB": 1407,
        "HC": 15,
        "SCH": 197,
        "HP": 1125,
        "AP": "£457,420",
        "SPC": "-3.8%"
    },
    {
        "UID": 499,
        "SN": "Waltham Abbey",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 499,
        "NE": 1423,
        "WB": 883,
        "HC": 686,
        "SCH": 141,
        "HP": 55,
        "AP": "£663,760",
        "SPC": "-1.0%"
    },
    {
        "UID": 500,
        "SN": "Flitwick",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 499,
        "NE": 205,
        "WB": 883,
        "HC": 1390,
        "SCH": 465,
        "HP": 245,
        "AP": "£590,838",
        "SPC": "0.9%"
    },
    {
        "UID": 501,
        "SN": "Heywood",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 501,
        "NE": 631,
        "WB": 1184,
        "HC": 281,
        "SCH": 33,
        "HP": 1060,
        "AP": "£292,307",
        "SPC": "0.8%"
    },
    {
        "UID": 502,
        "SN": "Evesham",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 502,
        "NE": 796,
        "WB": 417,
        "HC": 846,
        "SCH": 575,
        "HP": 559,
        "AP": "£447,691",
        "SPC": "3.7%"
    },
    {
        "UID": 503,
        "SN": "Chichester",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 503,
        "NE": 280,
        "WB": 800,
        "HC": 164,
        "SCH": 1177,
        "HP": 779,
        "AP": "£623,670",
        "SPC": "0.2%"
    },
    {
        "UID": 504,
        "SN": "Meltham",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 504,
        "NE": 38,
        "WB": 1130,
        "HC": 266,
        "SCH": 880,
        "HP": 892,
        "AP": "£365,821",
        "SPC": "7.6%"
    },
    {
        "UID": 505,
        "SN": "South Ockendon",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 505,
        "NE": 109,
        "WB": 1259,
        "HC": 1088,
        "SCH": 145,
        "HP": 611,
        "AP": "£615,718",
        "SPC": "2.3%"
    },
    {
        "UID": 506,
        "SN": "Buckhurst Hill",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 505,
        "NE": 1335,
        "WB": 833,
        "HC": 727,
        "SCH": 311,
        "HP": 6,
        "AP": "£870,586",
        "SPC": "-3.3%"
    },
    {
        "UID": 507,
        "SN": "Esher",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 505,
        "NE": 1261,
        "WB": 607,
        "HC": 25,
        "SCH": 1099,
        "HP": 220,
        "AP": "£1,097,751",
        "SPC": "6.4%"
    },
    {
        "UID": 508,
        "SN": "Tadley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 508,
        "NE": 54,
        "WB": 84,
        "HC": 1421,
        "SCH": 1393,
        "HP": 262,
        "AP": "£583,227",
        "SPC": "-3.8%"
    },
    {
        "UID": 509,
        "SN": "Romsey",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 509,
        "NE": 1090,
        "WB": 218,
        "HC": 369,
        "SCH": 732,
        "HP": 806,
        "AP": "£633,740",
        "SPC": "4.0%"
    },
    {
        "UID": 510,
        "SN": "Kidsgrove",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 509,
        "NE": 511,
        "WB": 206,
        "HC": 486,
        "SCH": 892,
        "HP": 1120,
        "AP": "£303,611",
        "SPC": "1.5%"
    },
    {
        "UID": 511,
        "SN": "Scarborough",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 511,
        "NE": 282,
        "WB": 604,
        "HC": 179,
        "SCH": 1117,
        "HP": 1034,
        "AP": "£304,869",
        "SPC": "5.6%"
    },
    {
        "UID": 512,
        "SN": "Norton Canes",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 512,
        "NE": 20,
        "WB": 423,
        "HC": 1291,
        "SCH": 868,
        "HP": 616,
        "AP": "£393,920",
        "SPC": "-2.2%"
    },
    {
        "UID": 513,
        "SN": "Huyton with Roby",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 513,
        "NE": 772,
        "WB": 851,
        "HC": 647,
        "SCH": 125,
        "HP": 824,
        "AP": "£287,402",
        "SPC": "-3.7%"
    },
    {
        "UID": 514,
        "SN": "Farnborough",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 514,
        "NE": 404,
        "WB": 1056,
        "HC": 765,
        "SCH": 296,
        "HP": 700,
        "AP": "£615,899",
        "SPC": "-0.8%"
    },
    {
        "UID": 515,
        "SN": "Bolsover",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 515,
        "NE": 388,
        "WB": 89,
        "HC": 296,
        "SCH": 1362,
        "HP": 1087,
        "AP": "£271,335",
        "SPC": "-9.5%"
    },
    {
        "UID": 516,
        "SN": "Poulton-le-Fylde",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 516,
        "NE": 1192,
        "WB": 369,
        "HC": 848,
        "SCH": 290,
        "HP": 527,
        "AP": "£342,458",
        "SPC": "0.2%"
    },
    {
        "UID": 517,
        "SN": "Weybridge",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 517,
        "NE": 1139,
        "WB": 681,
        "HC": 291,
        "SCH": 1082,
        "HP": 34,
        "AP": "£883,940",
        "SPC": "-0.1%"
    },
    {
        "UID": 518,
        "SN": "Oxted",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 517,
        "NE": 620,
        "WB": 572,
        "HC": 814,
        "SCH": 1198,
        "HP": 23,
        "AP": "£776,777",
        "SPC": "-5.0%"
    },
    {
        "UID": 519,
        "SN": "Stockton-on-Tees",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 519,
        "NE": 570,
        "WB": 1302,
        "HC": 452,
        "SCH": 462,
        "HP": 443,
        "AP": "£229,865",
        "SPC": "-0.5%"
    },
    {
        "UID": 520,
        "SN": "Ryde",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 520,
        "NE": 344,
        "WB": 808,
        "HC": 6,
        "SCH": 691,
        "HP": 1381,
        "AP": "£430,394",
        "SPC": "2.1%"
    },
    {
        "UID": 521,
        "SN": "Skipton",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 521,
        "NE": 1014,
        "WB": 474,
        "HC": 631,
        "SCH": 854,
        "HP": 258,
        "AP": "£406,493",
        "SPC": "0.6%"
    },
    {
        "UID": 522,
        "SN": "Churchdown",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 521,
        "NE": 198,
        "WB": 445,
        "HC": 898,
        "SCH": 746,
        "HP": 944,
        "AP": "£498,988",
        "SPC": "4.6%"
    },
    {
        "UID": 523,
        "SN": "Chiswell Green",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 521,
        "NE": 556,
        "WB": 1348,
        "HC": 571,
        "SCH": 474,
        "HP": 282,
        "AP": "£954,677",
        "SPC": "10.0%"
    },
    {
        "UID": 524,
        "SN": "Chorley",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 524,
        "NE": 424,
        "WB": 497,
        "HC": 697,
        "SCH": 382,
        "HP": 1232,
        "AP": "£298,229",
        "SPC": "6.8%"
    },
    {
        "UID": 525,
        "SN": "Groby",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 525,
        "NE": 1121,
        "WB": 1073,
        "HC": 445,
        "SCH": 201,
        "HP": 393,
        "AP": "£503,612",
        "SPC": "3.0%"
    },
    {
        "UID": 526,
        "SN": "Royston (Barnsley)",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 526,
        "NE": 85,
        "WB": 262,
        "HC": 1053,
        "SCH": 1119,
        "HP": 718,
        "AP": "£270,079",
        "SPC": "-7.3%"
    },
    {
        "UID": 527,
        "SN": "Epping",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 526,
        "NE": 980,
        "WB": 1279,
        "HC": 494,
        "SCH": 399,
        "HP": 85,
        "AP": "£863,707",
        "SPC": "1.9%"
    },
    {
        "UID": 528,
        "SN": "Bradford",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 528,
        "NE": 267,
        "WB": 1264,
        "HC": 16,
        "SCH": 584,
        "HP": 1107,
        "AP": "£246,550",
        "SPC": "0.6%"
    },
    {
        "UID": 529,
        "SN": "Alsager",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 528,
        "NE": 342,
        "WB": 883,
        "HC": 930,
        "SCH": 933,
        "HP": 150,
        "AP": "£384,559",
        "SPC": "0.3%"
    },
    {
        "UID": 530,
        "SN": "Heathfield (Wealden)",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 530,
        "NE": 91,
        "WB": 253,
        "HC": 1311,
        "SCH": 755,
        "HP": 829,
        "AP": "£538,240",
        "SPC": "-6.6%"
    },
    {
        "UID": 531,
        "SN": "Brinsworth",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 531,
        "NE": 160,
        "WB": 941,
        "HC": 1039,
        "SCH": 527,
        "HP": 573,
        "AP": "£292,284",
        "SPC": "-3.6%"
    },
    {
        "UID": 532,
        "SN": "Great Bookham and Fetcham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 531,
        "NE": 463,
        "WB": 146,
        "HC": 451,
        "SCH": 1228,
        "HP": 952,
        "AP": "£926,102",
        "SPC": "4.4%"
    },
    {
        "UID": 533,
        "SN": "Crediton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 533,
        "NE": 457,
        "WB": 19,
        "HC": 729,
        "SCH": 781,
        "HP": 1256,
        "AP": "£430,347",
        "SPC": "1.0%"
    },
    {
        "UID": 534,
        "SN": "Hetton-le-Hole",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 533,
        "NE": 337,
        "WB": 313,
        "HC": 618,
        "SCH": 1044,
        "HP": 930,
        "AP": "£179,402",
        "SPC": "-13.9%"
    },
    {
        "UID": 535,
        "SN": "Bridport",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 535,
        "NE": 930,
        "WB": 360,
        "HC": 505,
        "SCH": 928,
        "HP": 523,
        "AP": "£592,449",
        "SPC": "2.7%"
    },
    {
        "UID": 536,
        "SN": "Driffield",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 536,
        "NE": 643,
        "WB": 180,
        "HC": 1187,
        "SCH": 607,
        "HP": 632,
        "AP": "£329,734",
        "SPC": "2.8%"
    },
    {
        "UID": 537,
        "SN": "Great Harwood",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 537,
        "NE": 429,
        "WB": 830,
        "HC": 502,
        "SCH": 318,
        "HP": 1172,
        "AP": "£218,528",
        "SPC": "-0.1%"
    },
    {
        "UID": 538,
        "SN": "Dodworth",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 538,
        "NE": 60,
        "WB": 459,
        "HC": 800,
        "SCH": 1297,
        "HP": 636,
        "AP": "£285,614",
        "SPC": "-11.8%"
    },
    {
        "UID": 539,
        "SN": "Berwick-upon-Tweed",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 539,
        "NE": 415,
        "WB": 805,
        "HC": 703,
        "SCH": 781,
        "HP": 550,
        "AP": "£298,731",
        "SPC": "9.1%"
    },
    {
        "UID": 540,
        "SN": "Farnham Common and Farnham Royal",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 540,
        "NE": 276,
        "WB": 970,
        "HC": 771,
        "SCH": 1191,
        "HP": 47,
        "AP": "£777,013",
        "SPC": "-9.2%"
    },
    {
        "UID": 541,
        "SN": "Kesgrave",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 541,
        "NE": 11,
        "WB": 73,
        "HC": 1056,
        "SCH": 1233,
        "HP": 883,
        "AP": "£508,994",
        "SPC": "-1.2%"
    },
    {
        "UID": 542,
        "SN": "Dalton-in-Furness",
        "COU": "Westmorland and Furness",
        "REG": "North West",
        "OR": 542,
        "NE": 1131,
        "WB": 92,
        "HC": 306,
        "SCH": 1200,
        "HP": 528,
        "AP": "£253,816",
        "SPC": "-7.8%"
    },
    {
        "UID": 543,
        "SN": "Launceston",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 542,
        "NE": 587,
        "WB": 133,
        "HC": 578,
        "SCH": 695,
        "HP": 1264,
        "AP": "£375,389",
        "SPC": "2.2%"
    },
    {
        "UID": 544,
        "SN": "Clifton (Salford)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 544,
        "NE": 937,
        "WB": 1427,
        "HC": 314,
        "SCH": 24,
        "HP": 556,
        "AP": "£357,635",
        "SPC": "-0.7%"
    },
    {
        "UID": 545,
        "SN": "Durrington",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 544,
        "NE": 478,
        "WB": 285,
        "HC": 1376,
        "SCH": 257,
        "HP": 862,
        "AP": "£495,992",
        "SPC": "3.8%"
    },
    {
        "UID": 546,
        "SN": "Huddersfield",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 546,
        "NE": 399,
        "WB": 1234,
        "HC": 10,
        "SCH": 760,
        "HP": 856,
        "AP": "£290,835",
        "SPC": "1.6%"
    },
    {
        "UID": 547,
        "SN": "Swanley",
        "COU": "Kent",
        "REG": "South East",
        "OR": 547,
        "NE": 208,
        "WB": 1379,
        "HC": 1088,
        "SCH": 286,
        "HP": 302,
        "AP": "£654,069",
        "SPC": "1.3%"
    },
    {
        "UID": 548,
        "SN": "Sidmouth",
        "COU": "Devon",
        "REG": "South West",
        "OR": 548,
        "NE": 421,
        "WB": 3,
        "HC": 636,
        "SCH": 1429,
        "HP": 775,
        "AP": "£646,016",
        "SPC": "2.5%"
    },
    {
        "UID": 549,
        "SN": "Oundle",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 549,
        "NE": 1234,
        "WB": 77,
        "HC": 790,
        "SCH": 961,
        "HP": 205,
        "AP": "£487,898",
        "SPC": "-2.7%"
    },
    {
        "UID": 550,
        "SN": "Longbenton",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 550,
        "NE": 1047,
        "WB": 861,
        "HC": 655,
        "SCH": 561,
        "HP": 144,
        "AP": "£312,462",
        "SPC": "0.2%"
    },
    {
        "UID": 551,
        "SN": "Rothwell (Leeds)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 551,
        "NE": 1133,
        "WB": 924,
        "HC": 284,
        "SCH": 631,
        "HP": 298,
        "AP": "£409,820",
        "SPC": "2.6%"
    },
    {
        "UID": 552,
        "SN": "Bedford",
        "COU": "Bedford",
        "REG": "East of England",
        "OR": 552,
        "NE": 715,
        "WB": 938,
        "HC": 434,
        "SCH": 168,
        "HP": 1016,
        "AP": "£491,564",
        "SPC": "-0.5%"
    },
    {
        "UID": 553,
        "SN": "Bexley",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 552,
        "NE": 635,
        "WB": 1230,
        "HC": 396,
        "SCH": 187,
        "HP": 823,
        "AP": "£714,739",
        "SPC": "0.3%"
    },
    {
        "UID": 554,
        "SN": "Burscough",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 554,
        "NE": 1005,
        "WB": 566,
        "HC": 853,
        "SCH": 344,
        "HP": 504,
        "AP": "£362,457",
        "SPC": "2.9%"
    },
    {
        "UID": 555,
        "SN": "Ash and Ash Vale",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 555,
        "NE": 958,
        "WB": 437,
        "HC": 647,
        "SCH": 967,
        "HP": 265,
        "AP": "£672,082",
        "SPC": "0.5%"
    },
    {
        "UID": 556,
        "SN": "Wadebridge",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 556,
        "NE": 1232,
        "WB": 113,
        "HC": 678,
        "SCH": 156,
        "HP": 1096,
        "AP": "£554,199",
        "SPC": "6.2%"
    },
    {
        "UID": 557,
        "SN": "Hockley and Hawkwell",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 556,
        "NE": 1027,
        "WB": 392,
        "HC": 611,
        "SCH": 977,
        "HP": 268,
        "AP": "£669,659",
        "SPC": "3.5%"
    },
    {
        "UID": 558,
        "SN": "Milton Keynes",
        "COU": "Milton Keynes",
        "REG": "South East",
        "OR": 556,
        "NE": 512,
        "WB": 530,
        "HC": 518,
        "SCH": 749,
        "HP": 966,
        "AP": "£520,809",
        "SPC": "0.6%"
    },
    {
        "UID": 559,
        "SN": "Odiham",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 556,
        "NE": 668,
        "WB": 332,
        "HC": 646,
        "SCH": 1414,
        "HP": 215,
        "AP": "£723,837",
        "SPC": "2.7%"
    },
    {
        "UID": 560,
        "SN": "Chipping Sodbury",
        "COU": "South Gloucestershire",
        "REG": "South West",
        "OR": 560,
        "NE": 1016,
        "WB": 340,
        "HC": 1151,
        "SCH": 367,
        "HP": 406,
        "AP": "£580,266",
        "SPC": "3.0%"
    },
    {
        "UID": 561,
        "SN": "Audenshaw",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 561,
        "NE": 584,
        "WB": 1221,
        "HC": 425,
        "SCH": 88,
        "HP": 963,
        "AP": "£393,218",
        "SPC": "4.2%"
    },
    {
        "UID": 562,
        "SN": "Weymouth",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 561,
        "NE": 688,
        "WB": 820,
        "HC": 74,
        "SCH": 895,
        "HP": 804,
        "AP": "£501,404",
        "SPC": "2.9%"
    },
    {
        "UID": 563,
        "SN": "Fleet",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 563,
        "NE": 696,
        "WB": 188,
        "HC": 1011,
        "SCH": 1186,
        "HP": 201,
        "AP": "£674,174",
        "SPC": "1.6%"
    },
    {
        "UID": 564,
        "SN": "Moor Park",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 564,
        "NE": 1122,
        "WB": 790,
        "HC": 346,
        "SCH": 771,
        "HP": 262,
        "AP": "£1,073,500",
        "SPC": "4.4%"
    },
    {
        "UID": 565,
        "SN": "Hornsea",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 565,
        "NE": 607,
        "WB": 103,
        "HC": 1181,
        "SCH": 522,
        "HP": 879,
        "AP": "£310,148",
        "SPC": "4.5%"
    },
    {
        "UID": 566,
        "SN": "Penrith",
        "COU": "Westmorland and Furness",
        "REG": "North West",
        "OR": 566,
        "NE": 635,
        "WB": 346,
        "HC": 708,
        "SCH": 975,
        "HP": 634,
        "AP": "£349,270",
        "SPC": "2.5%"
    },
    {
        "UID": 567,
        "SN": "Poole",
        "COU": "Bournemouth, Christchurch and Poole",
        "REG": "South West",
        "OR": 567,
        "NE": 578,
        "WB": 998,
        "HC": 366,
        "SCH": 911,
        "HP": 449,
        "AP": "£627,636",
        "SPC": "1.1%"
    },
    {
        "UID": 568,
        "SN": "Moreton-in-Marsh",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 568,
        "NE": 608,
        "WB": 4,
        "HC": 1024,
        "SCH": 1142,
        "HP": 525,
        "AP": "£597,991",
        "SPC": "5.4%"
    },
    {
        "UID": 569,
        "SN": "Flackwell Heath and Wooburn Green",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 569,
        "NE": 825,
        "WB": 739,
        "HC": 628,
        "SCH": 902,
        "HP": 211,
        "AP": "£762,072",
        "SPC": "1.1%"
    },
    {
        "UID": 570,
        "SN": "Dartmouth",
        "COU": "Devon",
        "REG": "South West",
        "OR": 569,
        "NE": 1164,
        "WB": 31,
        "HC": 196,
        "SCH": 1170,
        "HP": 744,
        "AP": "£668,228",
        "SPC": "7.3%"
    },
    {
        "UID": 571,
        "SN": "Olney",
        "COU": "Milton Keynes",
        "REG": "South East",
        "OR": 571,
        "NE": 981,
        "WB": 33,
        "HC": 724,
        "SCH": 979,
        "HP": 592,
        "AP": "£613,063",
        "SPC": "-0.5%"
    },
    {
        "UID": 572,
        "SN": "Cas-Gwent",
        "COU": "Monmouthshire",
        "REG": "Wales",
        "OR": 571,
        "NE": 24,
        "WB": 905,
        "HC": 1127,
        "SCH": 992,
        "HP": 261,
        "AP": "£503,258",
        "SPC": "4.1%"
    },
    {
        "UID": 573,
        "SN": "Shiney Row and Penshaw",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 573,
        "NE": 199,
        "WB": 732,
        "HC": 393,
        "SCH": 822,
        "HP": 1166,
        "AP": "£240,142",
        "SPC": "2.9%"
    },
    {
        "UID": 574,
        "SN": "Bromsgrove",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 574,
        "NE": 731,
        "WB": 1048,
        "HC": 829,
        "SCH": 478,
        "HP": 228,
        "AP": "£463,682",
        "SPC": "2.8%"
    },
    {
        "UID": 575,
        "SN": "Conisbrough",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 575,
        "NE": 519,
        "WB": 598,
        "HC": 920,
        "SCH": 87,
        "HP": 1191,
        "AP": "£226,534",
        "SPC": "2.8%"
    },
    {
        "UID": 576,
        "SN": "Bishop's Cleeve",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 575,
        "NE": 912,
        "WB": 260,
        "HC": 589,
        "SCH": 637,
        "HP": 917,
        "AP": "£551,954",
        "SPC": "8.4%"
    },
    {
        "UID": 577,
        "SN": "Sheringham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 577,
        "NE": 16,
        "WB": 138,
        "HC": 836,
        "SCH": 1404,
        "HP": 922,
        "AP": "£507,866",
        "SPC": "-4.2%"
    },
    {
        "UID": 578,
        "SN": "Congleton",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 578,
        "NE": 941,
        "WB": 1056,
        "HC": 671,
        "SCH": 420,
        "HP": 231,
        "AP": "£396,028",
        "SPC": "2.1%"
    },
    {
        "UID": 579,
        "SN": "Brent",
        "COU": "London",
        "REG": "Greater London",
        "OR": 579,
        "NE": 671,
        "WB": 1300,
        "HC": 115,
        "SCH": 222,
        "HP": 1014,
        "AP": "£954,469",
        "SPC": "-0.1%"
    },
    {
        "UID": 580,
        "SN": "Shanklin",
        "COU": "Isle of Wight",
        "REG": "South East",
        "OR": 580,
        "NE": 245,
        "WB": 745,
        "HC": 297,
        "SCH": 641,
        "HP": 1395,
        "AP": "£454,958",
        "SPC": "2.6%"
    },
    {
        "UID": 581,
        "SN": "Egham",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 581,
        "NE": 1277,
        "WB": 1032,
        "HC": 211,
        "SCH": 740,
        "HP": 64,
        "AP": "£755,892",
        "SPC": "-0.8%"
    },
    {
        "UID": 582,
        "SN": "Whitehaven",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 581,
        "NE": 476,
        "WB": 585,
        "HC": 732,
        "SCH": 871,
        "HP": 660,
        "AP": "£231,361",
        "SPC": "-0.3%"
    },
    {
        "UID": 583,
        "SN": "Warmsworth",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 583,
        "NE": 322,
        "WB": 1054,
        "HC": 1250,
        "SCH": 6,
        "HP": 695,
        "AP": "£191,196",
        "SPC": "-6.8%"
    },
    {
        "UID": 584,
        "SN": "Shinfield",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 583,
        "NE": 876,
        "WB": 803,
        "HC": 621,
        "SCH": 920,
        "HP": 107,
        "AP": "£645,951",
        "SPC": "-2.2%"
    },
    {
        "UID": 585,
        "SN": "Nantwich",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 583,
        "NE": 1041,
        "WB": 250,
        "HC": 588,
        "SCH": 1222,
        "HP": 226,
        "AP": "£398,451",
        "SPC": "2.1%"
    },
    {
        "UID": 586,
        "SN": "Hook (Hart)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 586,
        "NE": 483,
        "WB": 216,
        "HC": 1135,
        "SCH": 1179,
        "HP": 316,
        "AP": "£663,786",
        "SPC": "2.7%"
    },
    {
        "UID": 587,
        "SN": "Fakenham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 587,
        "NE": 361,
        "WB": 120,
        "HC": 857,
        "SCH": 610,
        "HP": 1385,
        "AP": "£445,038",
        "SPC": "3.0%"
    },
    {
        "UID": 588,
        "SN": "Partington",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 588,
        "NE": 378,
        "WB": 1184,
        "HC": 1132,
        "SCH": 246,
        "HP": 394,
        "AP": "£367,622",
        "SPC": "3.8%"
    },
    {
        "UID": 589,
        "SN": "Werrington",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 588,
        "NE": 589,
        "WB": 494,
        "HC": 794,
        "SCH": 969,
        "HP": 488,
        "AP": "£360,736",
        "SPC": "1.7%"
    },
    {
        "UID": 590,
        "SN": "Horwich",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 590,
        "NE": 1241,
        "WB": 955,
        "HC": 288,
        "SCH": 160,
        "HP": 691,
        "AP": "£320,819",
        "SPC": "-1.5%"
    },
    {
        "UID": 591,
        "SN": "Lees",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 591,
        "NE": 685,
        "WB": 1144,
        "HC": 108,
        "SCH": 158,
        "HP": 1243,
        "AP": "£353,625",
        "SPC": "5.3%"
    },
    {
        "UID": 592,
        "SN": "Tidworth",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 591,
        "NE": 544,
        "WB": 373,
        "HC": 1416,
        "SCH": 528,
        "HP": 477,
        "AP": "£399,157",
        "SPC": "-9.3%"
    },
    {
        "UID": 593,
        "SN": "Henfield",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 593,
        "NE": 110,
        "WB": 295,
        "HC": 751,
        "SCH": 1305,
        "HP": 879,
        "AP": "£750,670",
        "SPC": "9.3%"
    },
    {
        "UID": 594,
        "SN": "Easington (County Durham)",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 594,
        "NE": 12,
        "WB": 914,
        "HC": 1319,
        "SCH": 358,
        "HP": 742,
        "AP": "£130,784",
        "SPC": "-9.5%"
    },
    {
        "UID": 595,
        "SN": "Wantage",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 595,
        "NE": 611,
        "WB": 709,
        "HC": 1050,
        "SCH": 272,
        "HP": 704,
        "AP": "£518,561",
        "SPC": "0.4%"
    },
    {
        "UID": 596,
        "SN": "Chapeltown and High Green",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 596,
        "NE": 384,
        "WB": 626,
        "HC": 470,
        "SCH": 1070,
        "HP": 797,
        "AP": "£369,632",
        "SPC": "9.2%"
    },
    {
        "UID": 597,
        "SN": "Helsby",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 596,
        "NE": 1112,
        "WB": 111,
        "HC": 1126,
        "SCH": 837,
        "HP": 161,
        "AP": "£424,772",
        "SPC": "1.0%"
    },
    {
        "UID": 598,
        "SN": "Heanor",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 598,
        "NE": 813,
        "WB": 470,
        "HC": 1054,
        "SCH": 179,
        "HP": 837,
        "AP": "£297,285",
        "SPC": "-0.1%"
    },
    {
        "UID": 599,
        "SN": "Ely",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 599,
        "NE": 643,
        "WB": 454,
        "HC": 817,
        "SCH": 541,
        "HP": 899,
        "AP": "£554,463",
        "SPC": "5.3%"
    },
    {
        "UID": 600,
        "SN": "Kirkham",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 600,
        "NE": 959,
        "WB": 310,
        "HC": 828,
        "SCH": 608,
        "HP": 650,
        "AP": "£304,115",
        "SPC": "3.3%"
    },
    {
        "UID": 601,
        "SN": "Yeovil",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 601,
        "NE": 120,
        "WB": 699,
        "HC": 900,
        "SCH": 467,
        "HP": 1177,
        "AP": "£397,130",
        "SPC": "1.0%"
    },
    {
        "UID": 602,
        "SN": "Broadbridge Heath",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 601,
        "NE": 34,
        "WB": 191,
        "HC": 1323,
        "SCH": 1097,
        "HP": 718,
        "AP": "£654,980",
        "SPC": "2.3%"
    },
    {
        "UID": 603,
        "SN": "Cam",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 603,
        "NE": 719,
        "WB": 606,
        "HC": 1217,
        "SCH": 492,
        "HP": 333,
        "AP": "£478,431",
        "SPC": "-4.0%"
    },
    {
        "UID": 604,
        "SN": "Hatfield",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 604,
        "NE": 749,
        "WB": 952,
        "HC": 623,
        "SCH": 707,
        "HP": 340,
        "AP": "£651,389",
        "SPC": "3.1%"
    },
    {
        "UID": 605,
        "SN": "Keyworth",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 605,
        "NE": 1124,
        "WB": 156,
        "HC": 1367,
        "SCH": 363,
        "HP": 366,
        "AP": "£505,459",
        "SPC": "8.7%"
    },
    {
        "UID": 606,
        "SN": "Yarm",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 606,
        "NE": 1194,
        "WB": 328,
        "HC": 780,
        "SCH": 617,
        "HP": 460,
        "AP": "£367,256",
        "SPC": "6.2%"
    },
    {
        "UID": 607,
        "SN": "Faversham",
        "COU": "Kent",
        "REG": "South East",
        "OR": 607,
        "NE": 330,
        "WB": 923,
        "HC": 412,
        "SCH": 724,
        "HP": 991,
        "AP": "£565,514",
        "SPC": "2.0%"
    },
    {
        "UID": 608,
        "SN": "Blackburn (Blackburn with Darwen)",
        "COU": "Blackburn with Darwen",
        "REG": "North West",
        "OR": 608,
        "NE": 382,
        "WB": 1257,
        "HC": 375,
        "SCH": 281,
        "HP": 1088,
        "AP": "£233,149",
        "SPC": "-0.7%"
    },
    {
        "UID": 609,
        "SN": "Marchwood",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 608,
        "NE": 767,
        "WB": 724,
        "HC": 466,
        "SCH": 695,
        "HP": 731,
        "AP": "£583,349",
        "SPC": "-0.1%"
    },
    {
        "UID": 610,
        "SN": "Darlington",
        "COU": "Darlington",
        "REG": "North East",
        "OR": 610,
        "NE": 679,
        "WB": 986,
        "HC": 919,
        "SCH": 13,
        "HP": 792,
        "AP": "£237,080",
        "SPC": "0.3%"
    },
    {
        "UID": 611,
        "SN": "Sandiacre",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 611,
        "NE": 1238,
        "WB": 488,
        "HC": 1159,
        "SCH": 102,
        "HP": 403,
        "AP": "£370,136",
        "SPC": "-0.4%"
    },
    {
        "UID": 612,
        "SN": "Braunton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 611,
        "NE": 541,
        "WB": 17,
        "HC": 476,
        "SCH": 1427,
        "HP": 929,
        "AP": "£619,567",
        "SPC": "2.3%"
    },
    {
        "UID": 613,
        "SN": "Helston",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 613,
        "NE": 815,
        "WB": 493,
        "HC": 778,
        "SCH": 267,
        "HP": 1038,
        "AP": "£484,459",
        "SPC": "2.3%"
    },
    {
        "UID": 614,
        "SN": "Newbury",
        "COU": "West Berkshire",
        "REG": "South East",
        "OR": 613,
        "NE": 869,
        "WB": 180,
        "HC": 712,
        "SCH": 1175,
        "HP": 455,
        "AP": "£576,388",
        "SPC": "0.6%"
    },
    {
        "UID": 615,
        "SN": "Cobham (Elmbridge)",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 613,
        "NE": 1136,
        "WB": 915,
        "HC": 269,
        "SCH": 1058,
        "HP": 13,
        "AP": "£961,305",
        "SPC": "-0.6%"
    },
    {
        "UID": 616,
        "SN": "Ashley Heath",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 616,
        "NE": 539,
        "WB": 130,
        "HC": 1338,
        "SCH": 1283,
        "HP": 102,
        "AP": "£673,932",
        "SPC": "-3.7%"
    },
    {
        "UID": 617,
        "SN": "Dawlish",
        "COU": "Devon",
        "REG": "South West",
        "OR": 617,
        "NE": 552,
        "WB": 119,
        "HC": 305,
        "SCH": 1214,
        "HP": 1204,
        "AP": "£451,193",
        "SPC": "0.6%"
    },
    {
        "UID": 618,
        "SN": "Cottingham",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 618,
        "NE": 1424,
        "WB": 1135,
        "HC": 459,
        "SCH": 124,
        "HP": 253,
        "AP": "£342,646",
        "SPC": "-1.1%"
    },
    {
        "UID": 619,
        "SN": "Teignmouth",
        "COU": "Devon",
        "REG": "South West",
        "OR": 619,
        "NE": 1178,
        "WB": 238,
        "HC": 183,
        "SCH": 452,
        "HP": 1347,
        "AP": "£498,198",
        "SPC": "5.5%"
    },
    {
        "UID": 620,
        "SN": "Queensbury",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 620,
        "NE": 419,
        "WB": 653,
        "HC": 62,
        "SCH": 1014,
        "HP": 1252,
        "AP": "£284,401",
        "SPC": "4.0%"
    },
    {
        "UID": 621,
        "SN": "Mansfield Woodhouse",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 620,
        "NE": 163,
        "WB": 517,
        "HC": 1090,
        "SCH": 251,
        "HP": 1379,
        "AP": "£300,347",
        "SPC": "3.4%"
    },
    {
        "UID": 622,
        "SN": "Shepperton",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 622,
        "NE": 1364,
        "WB": 618,
        "HC": 394,
        "SCH": 969,
        "HP": 57,
        "AP": "£781,316",
        "SPC": "-2.8%"
    },
    {
        "UID": 623,
        "SN": "Worsbrough",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 623,
        "NE": 321,
        "WB": 589,
        "HC": 792,
        "SCH": 451,
        "HP": 1253,
        "AP": "£268,088",
        "SPC": "2.9%"
    },
    {
        "UID": 624,
        "SN": "Southampton",
        "COU": "Southampton",
        "REG": "South East",
        "OR": 624,
        "NE": 226,
        "WB": 1371,
        "HC": 196,
        "SCH": 304,
        "HP": 1311,
        "AP": "£462,084",
        "SPC": "1.0%"
    },
    {
        "UID": 625,
        "SN": "St Helens (St. Helens)",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 625,
        "NE": 627,
        "WB": 1004,
        "HC": 592,
        "SCH": 71,
        "HP": 1115,
        "AP": "£261,513",
        "SPC": "1.3%"
    },
    {
        "UID": 626,
        "SN": "Great Wakering",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 625,
        "NE": 1292,
        "WB": 741,
        "HC": 151,
        "SCH": 703,
        "HP": 522,
        "AP": "£605,169",
        "SPC": "6.7%"
    },
    {
        "UID": 627,
        "SN": "Bishop's Waltham",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 625,
        "NE": 1014,
        "WB": 194,
        "HC": 590,
        "SCH": 1154,
        "HP": 457,
        "AP": "£631,989",
        "SPC": "2.2%"
    },
    {
        "UID": 628,
        "SN": "Budleigh Salterton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 625,
        "NE": 340,
        "WB": 2,
        "HC": 746,
        "SCH": 1183,
        "HP": 1138,
        "AP": "£634,508",
        "SPC": "11.9%"
    },
    {
        "UID": 629,
        "SN": "Lee-on-the-Solent",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 629,
        "NE": 831,
        "WB": 95,
        "HC": 570,
        "SCH": 1249,
        "HP": 665,
        "AP": "£601,944",
        "SPC": "-0.3%"
    },
    {
        "UID": 630,
        "SN": "Boston Spa",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 629,
        "NE": 852,
        "WB": 598,
        "HC": 851,
        "SCH": 990,
        "HP": 119,
        "AP": "£554,941",
        "SPC": "1.1%"
    },
    {
        "UID": 631,
        "SN": "Burnley",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 631,
        "NE": 421,
        "WB": 930,
        "HC": 170,
        "SCH": 915,
        "HP": 975,
        "AP": "£186,146",
        "SPC": "-7.8%"
    },
    {
        "UID": 632,
        "SN": "Pool and Illogan",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 632,
        "NE": 111,
        "WB": 365,
        "HC": 759,
        "SCH": 945,
        "HP": 1233,
        "AP": "£462,313",
        "SPC": "4.1%"
    },
    {
        "UID": 633,
        "SN": "Bideford",
        "COU": "Devon",
        "REG": "South West",
        "OR": 633,
        "NE": 760,
        "WB": 654,
        "HC": 333,
        "SCH": 377,
        "HP": 1290,
        "AP": "£416,559",
        "SPC": "1.4%"
    },
    {
        "UID": 634,
        "SN": "Albrighton",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 633,
        "NE": 355,
        "WB": 358,
        "HC": 1031,
        "SCH": 1257,
        "HP": 413,
        "AP": "£457,521",
        "SPC": "2.3%"
    },
    {
        "UID": 635,
        "SN": "Tewkesbury",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 635,
        "NE": 769,
        "WB": 635,
        "HC": 507,
        "SCH": 813,
        "HP": 692,
        "AP": "£435,176",
        "SPC": "-0.2%"
    },
    {
        "UID": 636,
        "SN": "Mossley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 636,
        "NE": 766,
        "WB": 1218,
        "HC": 48,
        "SCH": 269,
        "HP": 1117,
        "AP": "£356,044",
        "SPC": "4.3%"
    },
    {
        "UID": 637,
        "SN": "West Hallam",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 637,
        "NE": 707,
        "WB": 76,
        "HC": 1116,
        "SCH": 910,
        "HP": 611,
        "AP": "£426,318",
        "SPC": "4.3%"
    },
    {
        "UID": 638,
        "SN": "Arnold",
        "COU": "Nottingham",
        "REG": "East Midlands",
        "OR": 638,
        "NE": 1122,
        "WB": 1009,
        "HC": 748,
        "SCH": 157,
        "HP": 388,
        "AP": "£392,110",
        "SPC": "0.5%"
    },
    {
        "UID": 639,
        "SN": "Horden",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 639,
        "NE": 1,
        "WB": 492,
        "HC": 1305,
        "SCH": 307,
        "HP": 1321,
        "AP": "£102,135",
        "SPC": "4.2%"
    },
    {
        "UID": 640,
        "SN": "Looe",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 640,
        "NE": 1093,
        "WB": 397,
        "HC": 453,
        "SCH": 915,
        "HP": 570,
        "AP": "£488,958",
        "SPC": "-3.7%"
    },
    {
        "UID": 641,
        "SN": "Waterbeach",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 641,
        "NE": 959,
        "WB": 870,
        "HC": 387,
        "SCH": 1120,
        "HP": 96,
        "AP": "£610,562",
        "SPC": "-1.1%"
    },
    {
        "UID": 642,
        "SN": "Taverham and Drayton",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 642,
        "NE": 897,
        "WB": 125,
        "HC": 746,
        "SCH": 667,
        "HP": 999,
        "AP": "£492,437",
        "SPC": "0.2%"
    },
    {
        "UID": 643,
        "SN": "Withernsea",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 643,
        "NE": 104,
        "WB": 967,
        "HC": 1287,
        "SCH": 338,
        "HP": 743,
        "AP": "£216,162",
        "SPC": "-0.3%"
    },
    {
        "UID": 644,
        "SN": "Stafford",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 644,
        "NE": 443,
        "WB": 793,
        "HC": 1003,
        "SCH": 560,
        "HP": 642,
        "AP": "£365,564",
        "SPC": "3.5%"
    },
    {
        "UID": 645,
        "SN": "Long Stratton",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 644,
        "NE": 56,
        "WB": 186,
        "HC": 1129,
        "SCH": 1216,
        "HP": 854,
        "AP": "£430,568",
        "SPC": "-5.1%"
    },
    {
        "UID": 646,
        "SN": "Clay Cross",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 644,
        "NE": 214,
        "WB": 482,
        "HC": 853,
        "SCH": 1292,
        "HP": 600,
        "AP": "£303,840",
        "SPC": "-2.4%"
    },
    {
        "UID": 647,
        "SN": "Aldridge",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 647,
        "NE": 292,
        "WB": 992,
        "HC": 777,
        "SCH": 756,
        "HP": 625,
        "AP": "£426,091",
        "SPC": "-1.5%"
    },
    {
        "UID": 648,
        "SN": "Radcliffe",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 648,
        "NE": 1004,
        "WB": 1350,
        "HC": 218,
        "SCH": 60,
        "HP": 811,
        "AP": "£307,897",
        "SPC": "1.5%"
    },
    {
        "UID": 649,
        "SN": "Whitworth",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 649,
        "NE": 1202,
        "WB": 857,
        "HC": 138,
        "SCH": 135,
        "HP": 1113,
        "AP": "£288,401",
        "SPC": "0.3%"
    },
    {
        "UID": 650,
        "SN": "Worsley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 650,
        "NE": 1377,
        "WB": 1420,
        "HC": 132,
        "SCH": 36,
        "HP": 481,
        "AP": "£478,479",
        "SPC": "1.6%"
    },
    {
        "UID": 651,
        "SN": "Totton",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 651,
        "NE": 506,
        "WB": 1041,
        "HC": 734,
        "SCH": 471,
        "HP": 698,
        "AP": "£561,080",
        "SPC": "-1.3%"
    },
    {
        "UID": 652,
        "SN": "Bridgnorth",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 651,
        "NE": 1075,
        "WB": 379,
        "HC": 608,
        "SCH": 762,
        "HP": 626,
        "AP": "£453,872",
        "SPC": "4.9%"
    },
    {
        "UID": 653,
        "SN": "Birtley",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 651,
        "NE": 166,
        "WB": 1383,
        "HC": 438,
        "SCH": 712,
        "HP": 751,
        "AP": "£239,900",
        "SPC": "2.0%"
    },
    {
        "UID": 654,
        "SN": "Carnforth",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 654,
        "NE": 643,
        "WB": 432,
        "HC": 486,
        "SCH": 633,
        "HP": 1262,
        "AP": "£314,054",
        "SPC": "3.7%"
    },
    {
        "UID": 655,
        "SN": "Cockermouth",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 655,
        "NE": 1259,
        "WB": 235,
        "HC": 821,
        "SCH": 930,
        "HP": 212,
        "AP": "£361,981",
        "SPC": "0.1%"
    },
    {
        "UID": 656,
        "SN": "Sutton in Ashfield",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 656,
        "NE": 113,
        "WB": 964,
        "HC": 1100,
        "SCH": 212,
        "HP": 1070,
        "AP": "£268,070",
        "SPC": "-3.0%"
    },
    {
        "UID": 657,
        "SN": "Oakley (Basingstoke and Deane)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 656,
        "NE": 325,
        "WB": 283,
        "HC": 882,
        "SCH": 1297,
        "HP": 672,
        "AP": "£657,073",
        "SPC": "4.7%"
    },
    {
        "UID": 658,
        "SN": "Brixworth",
        "COU": "West Northamptonshire",
        "REG": "East Midlands",
        "OR": 656,
        "NE": 529,
        "WB": 46,
        "HC": 1177,
        "SCH": 1282,
        "HP": 425,
        "AP": "£466,521",
        "SPC": "3.7%"
    },
    {
        "UID": 659,
        "SN": "Margate",
        "COU": "Kent",
        "REG": "South East",
        "OR": 659,
        "NE": 796,
        "WB": 847,
        "HC": 34,
        "SCH": 392,
        "HP": 1392,
        "AP": "£508,103",
        "SPC": "3.9%"
    },
    {
        "UID": 660,
        "SN": "Tyldesley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 660,
        "NE": 989,
        "WB": 962,
        "HC": 363,
        "SCH": 107,
        "HP": 1041,
        "AP": "£379,312",
        "SPC": "3.2%"
    },
    {
        "UID": 661,
        "SN": "New Haw, West Byfleet and Sheerwater",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 661,
        "NE": 993,
        "WB": 1122,
        "HC": 623,
        "SCH": 633,
        "HP": 92,
        "AP": "£778,836",
        "SPC": "0.3%"
    },
    {
        "UID": 662,
        "SN": "Ellesmere Port",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 662,
        "NE": 550,
        "WB": 1015,
        "HC": 983,
        "SCH": 404,
        "HP": 512,
        "AP": "£319,925",
        "SPC": "1.6%"
    },
    {
        "UID": 663,
        "SN": "Frodsham",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 662,
        "NE": 1119,
        "WB": 491,
        "HC": 908,
        "SCH": 411,
        "HP": 535,
        "AP": "£422,559",
        "SPC": "8.5%"
    },
    {
        "UID": 664,
        "SN": "Luton",
        "COU": "Luton",
        "REG": "East of England",
        "OR": 664,
        "NE": 184,
        "WB": 1315,
        "HC": 866,
        "SCH": 190,
        "HP": 913,
        "AP": "£530,896",
        "SPC": "-0.6%"
    },
    {
        "UID": 665,
        "SN": "Baildon",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 665,
        "NE": 985,
        "WB": 1376,
        "HC": 149,
        "SCH": 350,
        "HP": 611,
        "AP": "£400,194",
        "SPC": "2.1%"
    },
    {
        "UID": 666,
        "SN": "Ingleby Barwick",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 666,
        "NE": 1002,
        "WB": 689,
        "HC": 1107,
        "SCH": 357,
        "HP": 317,
        "AP": "£319,709",
        "SPC": "2.4%"
    },
    {
        "UID": 667,
        "SN": "Corfe Mullen",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 667,
        "NE": 468,
        "WB": 544,
        "HC": 1147,
        "SCH": 1171,
        "HP": 143,
        "AP": "£621,294",
        "SPC": "-2.6%"
    },
    {
        "UID": 668,
        "SN": "Swindon (Swindon)",
        "COU": "Swindon",
        "REG": "South West",
        "OR": 668,
        "NE": 355,
        "WB": 1002,
        "HC": 622,
        "SCH": 540,
        "HP": 957,
        "AP": "£443,277",
        "SPC": "3.5%"
    },
    {
        "UID": 669,
        "SN": "Southam (Stratford-on-Avon)",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 669,
        "NE": 992,
        "WB": 110,
        "HC": 1234,
        "SCH": 843,
        "HP": 303,
        "AP": "£488,083",
        "SPC": "3.9%"
    },
    {
        "UID": 670,
        "SN": "Willerby and Anlaby",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 670,
        "NE": 1396,
        "WB": 774,
        "HC": 636,
        "SCH": 436,
        "HP": 241,
        "AP": "£357,637",
        "SPC": "-0.4%"
    },
    {
        "UID": 671,
        "SN": "Chesterfield",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 670,
        "NE": 416,
        "WB": 411,
        "HC": 448,
        "SCH": 1169,
        "HP": 1039,
        "AP": "£344,134",
        "SPC": "1.0%"
    },
    {
        "UID": 672,
        "SN": "Chippenham (Wiltshire)",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 672,
        "NE": 373,
        "WB": 166,
        "HC": 1009,
        "SCH": 1260,
        "HP": 676,
        "AP": "£500,890",
        "SPC": "2.2%"
    },
    {
        "UID": 673,
        "SN": "Sherborne",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 673,
        "NE": 565,
        "WB": 405,
        "HC": 318,
        "SCH": 1288,
        "HP": 909,
        "AP": "£534,607",
        "SPC": "6.2%"
    },
    {
        "UID": 674,
        "SN": "Ravenshead",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 673,
        "NE": 1107,
        "WB": 390,
        "HC": 1354,
        "SCH": 48,
        "HP": 586,
        "AP": "£482,498",
        "SPC": "7.5%"
    },
    {
        "UID": 675,
        "SN": "Newham",
        "COU": "Inner London",
        "REG": "Greater London",
        "OR": 675,
        "NE": 1019,
        "WB": 1164,
        "HC": 72,
        "SCH": 51,
        "HP": 1181,
        "AP": "£790,580",
        "SPC": "-0.0%"
    },
    {
        "UID": 676,
        "SN": "Derby",
        "COU": "Derby",
        "REG": "East Midlands",
        "OR": 676,
        "NE": 928,
        "WB": 1024,
        "HC": 243,
        "SCH": 406,
        "HP": 887,
        "AP": "£357,729",
        "SPC": "3.1%"
    },
    {
        "UID": 677,
        "SN": "Bourne End",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 677,
        "NE": 1137,
        "WB": 520,
        "HC": 354,
        "SCH": 982,
        "HP": 497,
        "AP": "£897,775",
        "SPC": "8.9%"
    },
    {
        "UID": 678,
        "SN": "Farnworth",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 678,
        "NE": 404,
        "WB": 1401,
        "HC": 383,
        "SCH": 3,
        "HP": 1303,
        "AP": "£265,154",
        "SPC": "3.2%"
    },
    {
        "UID": 679,
        "SN": "Southend-on-Sea",
        "COU": "Southend-on-Sea",
        "REG": "East of England",
        "OR": 679,
        "NE": 889,
        "WB": 1276,
        "HC": 754,
        "SCH": 320,
        "HP": 256,
        "AP": "£580,053",
        "SPC": "-0.0%"
    },
    {
        "UID": 680,
        "SN": "Mansfield",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 680,
        "NE": 412,
        "WB": 848,
        "HC": 969,
        "SCH": 192,
        "HP": 1076,
        "AP": "£278,795",
        "SPC": "-4.7%"
    },
    {
        "UID": 681,
        "SN": "Wool",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 681,
        "NE": 595,
        "WB": 162,
        "HC": 1183,
        "SCH": 1349,
        "HP": 210,
        "AP": "£532,083",
        "SPC": "-6.7%"
    },
    {
        "UID": 682,
        "SN": "Clevedon",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 682,
        "NE": 994,
        "WB": 453,
        "HC": 707,
        "SCH": 795,
        "HP": 553,
        "AP": "£608,942",
        "SPC": "6.6%"
    },
    {
        "UID": 683,
        "SN": "Cranleigh",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 683,
        "NE": 677,
        "WB": 297,
        "HC": 1246,
        "SCH": 1128,
        "HP": 155,
        "AP": "£729,759",
        "SPC": "1.8%"
    },
    {
        "UID": 684,
        "SN": "Enfield",
        "COU": "London",
        "REG": "Greater London",
        "OR": 684,
        "NE": 950,
        "WB": 1169,
        "HC": 182,
        "SCH": 111,
        "HP": 1092,
        "AP": "£789,916",
        "SPC": "-1.2%"
    },
    {
        "UID": 685,
        "SN": "Croesoswallt",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 685,
        "NE": 549,
        "WB": 248,
        "HC": 830,
        "SCH": 1115,
        "HP": 763,
        "AP": "£346,515",
        "SPC": "1.8%"
    },
    {
        "UID": 686,
        "SN": "Cil-y-coed",
        "COU": "Monmouthshire",
        "REG": "Wales",
        "OR": 686,
        "NE": 99,
        "WB": 748,
        "HC": 1411,
        "SCH": 1180,
        "HP": 70,
        "AP": "£443,774",
        "SPC": "-0.5%"
    },
    {
        "UID": 687,
        "SN": "Dewsbury",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 687,
        "NE": 914,
        "WB": 1035,
        "HC": 96,
        "SCH": 832,
        "HP": 636,
        "AP": "£275,912",
        "SPC": "-1.6%"
    },
    {
        "UID": 688,
        "SN": "Richmond",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 687,
        "NE": 1195,
        "WB": 26,
        "HC": 560,
        "SCH": 1192,
        "HP": 540,
        "AP": "£384,199",
        "SPC": "3.4%"
    },
    {
        "UID": 689,
        "SN": "AberdÃ¢r",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 687,
        "NE": 553,
        "WB": 815,
        "HC": 560,
        "SCH": 421,
        "HP": 1164,
        "AP": "£238,134",
        "SPC": "1.9%"
    },
    {
        "UID": 690,
        "SN": "Alfreton",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 687,
        "NE": 184,
        "WB": 761,
        "HC": 945,
        "SCH": 741,
        "HP": 882,
        "AP": "£280,432",
        "SPC": "-0.0%"
    },
    {
        "UID": 691,
        "SN": "Hawkinge",
        "COU": "Kent",
        "REG": "South East",
        "OR": 687,
        "NE": 74,
        "WB": 47,
        "HC": 1296,
        "SCH": 731,
        "HP": 1365,
        "AP": "£570,207",
        "SPC": "6.4%"
    },
    {
        "UID": 692,
        "SN": "Shiremoor",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 692,
        "NE": 567,
        "WB": 1288,
        "HC": 773,
        "SCH": 805,
        "HP": 82,
        "AP": "£281,332",
        "SPC": "-6.6%"
    },
    {
        "UID": 693,
        "SN": "Maghull",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 693,
        "NE": 1171,
        "WB": 220,
        "HC": 1336,
        "SCH": 172,
        "HP": 623,
        "AP": "£354,321",
        "SPC": "2.5%"
    },
    {
        "UID": 694,
        "SN": "East Boldon and West Boldon",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 693,
        "NE": 428,
        "WB": 916,
        "HC": 229,
        "SCH": 1199,
        "HP": 750,
        "AP": "£329,451",
        "SPC": "4.3%"
    },
    {
        "UID": 695,
        "SN": "Caister-on-Sea",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 695,
        "NE": 858,
        "WB": 306,
        "HC": 872,
        "SCH": 339,
        "HP": 1150,
        "AP": "£450,818",
        "SPC": "-0.9%"
    },
    {
        "UID": 696,
        "SN": "Hoddesdon",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 695,
        "NE": 1338,
        "WB": 1153,
        "HC": 317,
        "SCH": 204,
        "HP": 513,
        "AP": "£693,630",
        "SPC": "4.9%"
    },
    {
        "UID": 697,
        "SN": "Huntington (York)",
        "COU": "York",
        "REG": "Yorkshire and The Humber",
        "OR": 697,
        "NE": 782,
        "WB": 548,
        "HC": 365,
        "SCH": 1276,
        "HP": 555,
        "AP": "£525,301",
        "SPC": "5.5%"
    },
    {
        "UID": 698,
        "SN": "Batley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 698,
        "NE": 864,
        "WB": 1109,
        "HC": 88,
        "SCH": 847,
        "HP": 623,
        "AP": "£278,801",
        "SPC": "-1.6%"
    },
    {
        "UID": 699,
        "SN": "Blyth (Northumberland)",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 698,
        "NE": 551,
        "WB": 1280,
        "HC": 1097,
        "SCH": 346,
        "HP": 257,
        "AP": "£230,367",
        "SPC": "-2.5%"
    },
    {
        "UID": 700,
        "SN": "Throckley",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 700,
        "NE": 589,
        "WB": 801,
        "HC": 1114,
        "SCH": 878,
        "HP": 151,
        "AP": "£259,629",
        "SPC": "-12.0%"
    },
    {
        "UID": 701,
        "SN": "Wrecsam",
        "COU": "Wrexham",
        "REG": "Wales",
        "OR": 701,
        "NE": 108,
        "WB": 798,
        "HC": 816,
        "SCH": 886,
        "HP": 927,
        "AP": "£308,998",
        "SPC": "1.8%"
    },
    {
        "UID": 702,
        "SN": "Hadleigh",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 702,
        "NE": 30,
        "WB": 66,
        "HC": 957,
        "SCH": 1290,
        "HP": 1195,
        "AP": "£515,730",
        "SPC": "1.3%"
    },
    {
        "UID": 703,
        "SN": "Ashington (Northumberland)",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 703,
        "NE": 25,
        "WB": 518,
        "HC": 1178,
        "SCH": 976,
        "HP": 843,
        "AP": "£197,729",
        "SPC": "2.6%"
    },
    {
        "UID": 704,
        "SN": "Redbridge",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 704,
        "NE": 818,
        "WB": 1225,
        "HC": 300,
        "SCH": 103,
        "HP": 1097,
        "AP": "£781,673",
        "SPC": "0.1%"
    },
    {
        "UID": 705,
        "SN": "Heckmondwike",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 705,
        "NE": 234,
        "WB": 984,
        "HC": 293,
        "SCH": 905,
        "HP": 1128,
        "AP": "£283,666",
        "SPC": "4.1%"
    },
    {
        "UID": 706,
        "SN": "Waltham Forest",
        "COU": "London",
        "REG": "Greater London",
        "OR": 706,
        "NE": 871,
        "WB": 1408,
        "HC": 84,
        "SCH": 74,
        "HP": 1109,
        "AP": "£959,383",
        "SPC": "1.4%"
    },
    {
        "UID": 707,
        "SN": "Oakdale",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 706,
        "NE": 278,
        "WB": 1241,
        "HC": 953,
        "SCH": 613,
        "HP": 461,
        "AP": "£316,632",
        "SPC": "-6.4%"
    },
    {
        "UID": 708,
        "SN": "West Mersea",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 708,
        "NE": 1233,
        "WB": 54,
        "HC": 1212,
        "SCH": 840,
        "HP": 208,
        "AP": "£611,141",
        "SPC": "-9.1%"
    },
    {
        "UID": 709,
        "SN": "Tiptree",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 709,
        "NE": 614,
        "WB": 342,
        "HC": 1278,
        "SCH": 945,
        "HP": 369,
        "AP": "£559,101",
        "SPC": "-5.0%"
    },
    {
        "UID": 710,
        "SN": "Ferndown",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 710,
        "NE": 28,
        "WB": 724,
        "HC": 1122,
        "SCH": 1361,
        "HP": 315,
        "AP": "£593,826",
        "SPC": "0.3%"
    },
    {
        "UID": 711,
        "SN": "Cramlington",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 711,
        "NE": 449,
        "WB": 570,
        "HC": 1335,
        "SCH": 1081,
        "HP": 118,
        "AP": "£306,409",
        "SPC": "0.2%"
    },
    {
        "UID": 712,
        "SN": "Bamber Bridge",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 712,
        "NE": 1084,
        "WB": 697,
        "HC": 560,
        "SCH": 391,
        "HP": 822,
        "AP": "£325,840",
        "SPC": "1.8%"
    },
    {
        "UID": 713,
        "SN": "Ripon",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 712,
        "NE": 523,
        "WB": 522,
        "HC": 893,
        "SCH": 1409,
        "HP": 207,
        "AP": "£411,854",
        "SPC": "0.2%"
    },
    {
        "UID": 714,
        "SN": "Hoylake",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 714,
        "NE": 855,
        "WB": 147,
        "HC": 1065,
        "SCH": 1369,
        "HP": 120,
        "AP": "£376,359",
        "SPC": "-3.5%"
    },
    {
        "UID": 715,
        "SN": "Fareham",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 715,
        "NE": 369,
        "WB": 1214,
        "HC": 287,
        "SCH": 655,
        "HP": 1036,
        "AP": "£516,134",
        "SPC": "1.3%"
    },
    {
        "UID": 716,
        "SN": "Potton",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 716,
        "NE": 1288,
        "WB": 262,
        "HC": 987,
        "SCH": 630,
        "HP": 396,
        "AP": "£540,318",
        "SPC": "1.4%"
    },
    {
        "UID": 717,
        "SN": "Sunbury-on-Thames",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 716,
        "NE": 1201,
        "WB": 1299,
        "HC": 227,
        "SCH": 628,
        "HP": 208,
        "AP": "£774,848",
        "SPC": "2.0%"
    },
    {
        "UID": 718,
        "SN": "Midsomer Norton",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 718,
        "NE": 227,
        "WB": 636,
        "HC": 1086,
        "SCH": 1234,
        "HP": 381,
        "AP": "£498,335",
        "SPC": "1.4%"
    },
    {
        "UID": 719,
        "SN": "Banbury",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 719,
        "NE": 578,
        "WB": 707,
        "HC": 1044,
        "SCH": 180,
        "HP": 1056,
        "AP": "£483,397",
        "SPC": "2.0%"
    },
    {
        "UID": 720,
        "SN": "Waltham",
        "COU": "North East Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 720,
        "NE": 31,
        "WB": 262,
        "HC": 1205,
        "SCH": 1347,
        "HP": 721,
        "AP": "£323,498",
        "SPC": "-3.3%"
    },
    {
        "UID": 721,
        "SN": "Formby",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 721,
        "NE": 955,
        "WB": 366,
        "HC": 1308,
        "SCH": 402,
        "HP": 540,
        "AP": "£446,972",
        "SPC": "4.9%"
    },
    {
        "UID": 722,
        "SN": "Studley",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 722,
        "NE": 1280,
        "WB": 661,
        "HC": 865,
        "SCH": 425,
        "HP": 342,
        "AP": "£438,810",
        "SPC": "2.8%"
    },
    {
        "UID": 723,
        "SN": "Ivybridge",
        "COU": "Devon",
        "REG": "South West",
        "OR": 723,
        "NE": 615,
        "WB": 703,
        "HC": 1399,
        "SCH": 232,
        "HP": 628,
        "AP": "£485,543",
        "SPC": "0.0%"
    },
    {
        "UID": 724,
        "SN": "Barnton",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 724,
        "NE": 776,
        "WB": 159,
        "HC": 1099,
        "SCH": 866,
        "HP": 678,
        "AP": "£353,732",
        "SPC": "5.5%"
    },
    {
        "UID": 725,
        "SN": "Pelsall",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 725,
        "NE": 536,
        "WB": 232,
        "HC": 975,
        "SCH": 599,
        "HP": 1241,
        "AP": "£376,479",
        "SPC": "3.3%"
    },
    {
        "UID": 726,
        "SN": "Sittingbourne",
        "COU": "Kent",
        "REG": "South East",
        "OR": 726,
        "NE": 686,
        "WB": 1145,
        "HC": 536,
        "SCH": 310,
        "HP": 907,
        "AP": "£517,701",
        "SPC": "-0.1%"
    },
    {
        "UID": 727,
        "SN": "Hythe",
        "COU": "Kent",
        "REG": "South East",
        "OR": 727,
        "NE": 979,
        "WB": 24,
        "HC": 402,
        "SCH": 1018,
        "HP": 1164,
        "AP": "£613,646",
        "SPC": "2.6%"
    },
    {
        "UID": 728,
        "SN": "Linthwaite and Slaithwaite",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 728,
        "NE": 589,
        "WB": 932,
        "HC": 98,
        "SCH": 1036,
        "HP": 933,
        "AP": "£339,009",
        "SPC": "5.5%"
    },
    {
        "UID": 729,
        "SN": "Bishop's Stortford",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 729,
        "NE": 1311,
        "WB": 595,
        "HC": 941,
        "SCH": 722,
        "HP": 20,
        "AP": "£711,028",
        "SPC": "-1.7%"
    },
    {
        "UID": 730,
        "SN": "Axminster",
        "COU": "Devon",
        "REG": "South West",
        "OR": 730,
        "NE": 184,
        "WB": 549,
        "HC": 485,
        "SCH": 1428,
        "HP": 945,
        "AP": "£435,341",
        "SPC": "-1.9%"
    },
    {
        "UID": 731,
        "SN": "Mountsorrel",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 731,
        "NE": 1337,
        "WB": 1231,
        "HC": 128,
        "SCH": 787,
        "HP": 113,
        "AP": "£455,174",
        "SPC": "-1.1%"
    },
    {
        "UID": 732,
        "SN": "Chatham",
        "COU": "Medway",
        "REG": "South East",
        "OR": 732,
        "NE": 835,
        "WB": 1403,
        "HC": 204,
        "SCH": 133,
        "HP": 1023,
        "AP": "£511,987",
        "SPC": "0.1%"
    },
    {
        "UID": 733,
        "SN": "Calne",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 733,
        "NE": 145,
        "WB": 709,
        "HC": 671,
        "SCH": 1230,
        "HP": 844,
        "AP": "£463,363",
        "SPC": "2.4%"
    },
    {
        "UID": 734,
        "SN": "Histon and Impington",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 733,
        "NE": 1385,
        "WB": 776,
        "HC": 329,
        "SCH": 859,
        "HP": 250,
        "AP": "£739,364",
        "SPC": "4.3%"
    },
    {
        "UID": 735,
        "SN": "Herne Bay",
        "COU": "Kent",
        "REG": "South East",
        "OR": 735,
        "NE": 1227,
        "WB": 454,
        "HC": 439,
        "SCH": 626,
        "HP": 854,
        "AP": "£549,859",
        "SPC": "-2.5%"
    },
    {
        "UID": 736,
        "SN": "Maldon",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 736,
        "NE": 1184,
        "WB": 208,
        "HC": 508,
        "SCH": 1381,
        "HP": 320,
        "AP": "£603,341",
        "SPC": "-0.3%"
    },
    {
        "UID": 737,
        "SN": "Northampton",
        "COU": "West Northamptonshire",
        "REG": "East Midlands",
        "OR": 737,
        "NE": 963,
        "WB": 1206,
        "HC": 417,
        "SCH": 822,
        "HP": 200,
        "AP": "£424,685",
        "SPC": "-0.3%"
    },
    {
        "UID": 738,
        "SN": "Trecceln",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 738,
        "NE": 649,
        "WB": 1049,
        "HC": 327,
        "SCH": 770,
        "HP": 814,
        "AP": "£252,281",
        "SPC": "-3.6%"
    },
    {
        "UID": 739,
        "SN": "Barnoldswick",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 738,
        "NE": 95,
        "WB": 667,
        "HC": 794,
        "SCH": 699,
        "HP": 1354,
        "AP": "£260,262",
        "SPC": "1.8%"
    },
    {
        "UID": 740,
        "SN": "Harwich",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 740,
        "NE": 470,
        "WB": 865,
        "HC": 329,
        "SCH": 640,
        "HP": 1308,
        "AP": "£405,008",
        "SPC": "1.4%"
    },
    {
        "UID": 741,
        "SN": "Bidford-on-Avon",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 741,
        "NE": 1210,
        "WB": 496,
        "HC": 1216,
        "SCH": 652,
        "HP": 39,
        "AP": "£456,302",
        "SPC": "-6.4%"
    },
    {
        "UID": 742,
        "SN": "Welwyn Garden City",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 742,
        "NE": 496,
        "WB": 1035,
        "HC": 1055,
        "SCH": 790,
        "HP": 239,
        "AP": "£733,416",
        "SPC": "3.0%"
    },
    {
        "UID": 743,
        "SN": "Eccles (Salford)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 743,
        "NE": 1190,
        "WB": 1372,
        "HC": 112,
        "SCH": 16,
        "HP": 926,
        "AP": "£376,589",
        "SPC": "3.9%"
    },
    {
        "UID": 744,
        "SN": "St Blazey",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 743,
        "NE": 827,
        "WB": 657,
        "HC": 861,
        "SCH": 351,
        "HP": 920,
        "AP": "£388,548",
        "SPC": "-2.3%"
    },
    {
        "UID": 745,
        "SN": "Hedge End",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 745,
        "NE": 616,
        "WB": 362,
        "HC": 920,
        "SCH": 966,
        "HP": 753,
        "AP": "£559,724",
        "SPC": "0.4%"
    },
    {
        "UID": 746,
        "SN": "Biggleswade",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 745,
        "NE": 367,
        "WB": 640,
        "HC": 1217,
        "SCH": 992,
        "HP": 401,
        "AP": "£567,849",
        "SPC": "2.2%"
    },
    {
        "UID": 747,
        "SN": "Wingerworth",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 747,
        "NE": 373,
        "WB": 125,
        "HC": 1230,
        "SCH": 1425,
        "HP": 467,
        "AP": "£398,262",
        "SPC": "1.0%"
    },
    {
        "UID": 748,
        "SN": "Mirfield",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 748,
        "NE": 705,
        "WB": 702,
        "HC": 274,
        "SCH": 1134,
        "HP": 806,
        "AP": "£354,127",
        "SPC": "4.3%"
    },
    {
        "UID": 749,
        "SN": "Egremont",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 748,
        "NE": 806,
        "WB": 273,
        "HC": 1027,
        "SCH": 1074,
        "HP": 441,
        "AP": "£188,304",
        "SPC": "-12.5%"
    },
    {
        "UID": 750,
        "SN": "Market Weighton",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 750,
        "NE": 1175,
        "WB": 343,
        "HC": 1349,
        "SCH": 563,
        "HP": 193,
        "AP": "£342,336",
        "SPC": "-2.6%"
    },
    {
        "UID": 751,
        "SN": "Potters Bar",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 750,
        "NE": 864,
        "WB": 1158,
        "HC": 616,
        "SCH": 238,
        "HP": 747,
        "AP": "£849,928",
        "SPC": "2.9%"
    },
    {
        "UID": 752,
        "SN": "Northfleet",
        "COU": "Kent",
        "REG": "South East",
        "OR": 752,
        "NE": 274,
        "WB": 1397,
        "HC": 725,
        "SCH": 138,
        "HP": 1090,
        "AP": "£559,305",
        "SPC": "0.6%"
    },
    {
        "UID": 753,
        "SN": "Brightlingsea",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 753,
        "NE": 1057,
        "WB": 123,
        "HC": 547,
        "SCH": 728,
        "HP": 1173,
        "AP": "£471,032",
        "SPC": "0.6%"
    },
    {
        "UID": 754,
        "SN": "Higham Ferrers",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 754,
        "NE": 841,
        "WB": 1108,
        "HC": 498,
        "SCH": 588,
        "HP": 596,
        "AP": "£428,844",
        "SPC": "1.5%"
    },
    {
        "UID": 755,
        "SN": "Ashbourne",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 755,
        "NE": 1235,
        "WB": 226,
        "HC": 894,
        "SCH": 1095,
        "HP": 184,
        "AP": "£438,027",
        "SPC": "1.8%"
    },
    {
        "UID": 756,
        "SN": "Aberpennar",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 756,
        "NE": 809,
        "WB": 543,
        "HC": 515,
        "SCH": 548,
        "HP": 1221,
        "AP": "£194,226",
        "SPC": "2.1%"
    },
    {
        "UID": 757,
        "SN": "Nelson (Pendle)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 757,
        "NE": 52,
        "WB": 1143,
        "HC": 498,
        "SCH": 779,
        "HP": 1167,
        "AP": "£148,173",
        "SPC": "-6.3%"
    },
    {
        "UID": 758,
        "SN": "Brighouse",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 758,
        "NE": 661,
        "WB": 1168,
        "HC": 19,
        "SCH": 1031,
        "HP": 761,
        "AP": "£330,567",
        "SPC": "1.9%"
    },
    {
        "UID": 759,
        "SN": "Polesworth and Dordon",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 759,
        "NE": 1267,
        "WB": 331,
        "HC": 1361,
        "SCH": 485,
        "HP": 197,
        "AP": "£386,247",
        "SPC": "-0.7%"
    },
    {
        "UID": 760,
        "SN": "Thurmaston",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 760,
        "NE": 1335,
        "WB": 910,
        "HC": 715,
        "SCH": 109,
        "HP": 576,
        "AP": "£485,595",
        "SPC": "10.0%"
    },
    {
        "UID": 761,
        "SN": "Seaford",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 761,
        "NE": 538,
        "WB": 186,
        "HC": 986,
        "SCH": 1262,
        "HP": 675,
        "AP": "£606,459",
        "SPC": "-1.6%"
    },
    {
        "UID": 762,
        "SN": "Ossett",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 762,
        "NE": 666,
        "WB": 978,
        "HC": 573,
        "SCH": 726,
        "HP": 705,
        "AP": "£348,089",
        "SPC": "-0.2%"
    },
    {
        "UID": 763,
        "SN": "Hucknall",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 763,
        "NE": 1003,
        "WB": 658,
        "HC": 608,
        "SCH": 210,
        "HP": 1173,
        "AP": "£358,061",
        "SPC": "2.5%"
    },
    {
        "UID": 764,
        "SN": "Kiveton Park",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 764,
        "NE": 608,
        "WB": 325,
        "HC": 1252,
        "SCH": 895,
        "HP": 573,
        "AP": "£300,352",
        "SPC": "-2.6%"
    },
    {
        "UID": 765,
        "SN": "Padiham",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 764,
        "NE": 386,
        "WB": 320,
        "HC": 280,
        "SCH": 1320,
        "HP": 1347,
        "AP": "£190,761",
        "SPC": "2.4%"
    },
    {
        "UID": 766,
        "SN": "Bungay",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 766,
        "NE": 486,
        "WB": 813,
        "HC": 345,
        "SCH": 1076,
        "HP": 939,
        "AP": "£414,829",
        "SPC": "-6.5%"
    },
    {
        "UID": 767,
        "SN": "Coventry",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 767,
        "NE": 903,
        "WB": 1180,
        "HC": 572,
        "SCH": 429,
        "HP": 576,
        "AP": "£384,665",
        "SPC": "2.2%"
    },
    {
        "UID": 768,
        "SN": "Aintree",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 768,
        "NE": 744,
        "WB": 1377,
        "HC": 788,
        "SCH": 25,
        "HP": 729,
        "AP": "£322,925",
        "SPC": "2.2%"
    },
    {
        "UID": 769,
        "SN": "Bury St Edmunds",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 769,
        "NE": 789,
        "WB": 990,
        "HC": 462,
        "SCH": 498,
        "HP": 927,
        "AP": "£507,107",
        "SPC": "-0.4%"
    },
    {
        "UID": 770,
        "SN": "Seaton (East Devon)",
        "COU": "Devon",
        "REG": "South West",
        "OR": 769,
        "NE": 668,
        "WB": 21,
        "HC": 1208,
        "SCH": 1092,
        "HP": 677,
        "AP": "£494,108",
        "SPC": "-4.1%"
    },
    {
        "UID": 771,
        "SN": "Virginia Water",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 771,
        "NE": 1211,
        "WB": 932,
        "HC": 534,
        "SCH": 983,
        "HP": 7,
        "AP": "£997,388",
        "SPC": "-2.4%"
    },
    {
        "UID": 772,
        "SN": "Crewe",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 772,
        "NE": 966,
        "WB": 771,
        "HC": 692,
        "SCH": 926,
        "HP": 313,
        "AP": "£280,243",
        "SPC": "-3.5%"
    },
    {
        "UID": 773,
        "SN": "Bayston Hill",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 772,
        "NE": 350,
        "WB": 587,
        "HC": 1361,
        "SCH": 816,
        "HP": 554,
        "AP": "£446,070",
        "SPC": "3.7%"
    },
    {
        "UID": 774,
        "SN": "Tonbridge",
        "COU": "Kent",
        "REG": "South East",
        "OR": 774,
        "NE": 1203,
        "WB": 879,
        "HC": 209,
        "SCH": 817,
        "HP": 562,
        "AP": "£689,546",
        "SPC": "2.2%"
    },
    {
        "UID": 775,
        "SN": "Basildon",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 775,
        "NE": 542,
        "WB": 1157,
        "HC": 1059,
        "SCH": 325,
        "HP": 588,
        "AP": "£563,298",
        "SPC": "1.2%"
    },
    {
        "UID": 776,
        "SN": "Featherstone (South Staffordshire)",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 776,
        "NE": 496,
        "WB": 863,
        "HC": 1021,
        "SCH": 972,
        "HP": 321,
        "AP": "£381,815",
        "SPC": "0.9%"
    },
    {
        "UID": 777,
        "SN": "Aberystwyth",
        "COU": "Ceredigion",
        "REG": "Wales",
        "OR": 777,
        "NE": 1145,
        "WB": 1004,
        "HC": 328,
        "SCH": 765,
        "HP": 434,
        "AP": "£328,421",
        "SPC": "-5.8%"
    },
    {
        "UID": 778,
        "SN": "Church",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 778,
        "NE": 740,
        "WB": 1410,
        "HC": 242,
        "SCH": 209,
        "HP": 1076,
        "AP": "£191,544",
        "SPC": "-2.2%"
    },
    {
        "UID": 779,
        "SN": "Morpeth",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 778,
        "NE": 1318,
        "WB": 211,
        "HC": 1171,
        "SCH": 959,
        "HP": 18,
        "AP": "£343,075",
        "SPC": "-4.5%"
    },
    {
        "UID": 780,
        "SN": "Wolverhampton",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 780,
        "NE": 500,
        "WB": 1242,
        "HC": 272,
        "SCH": 675,
        "HP": 996,
        "AP": "£331,562",
        "SPC": "-2.6%"
    },
    {
        "UID": 781,
        "SN": "Bourne",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 780,
        "NE": 899,
        "WB": 83,
        "HC": 1254,
        "SCH": 644,
        "HP": 805,
        "AP": "£387,904",
        "SPC": "2.2%"
    },
    {
        "UID": 782,
        "SN": "Spennymoor",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 782,
        "NE": 149,
        "WB": 1012,
        "HC": 944,
        "SCH": 915,
        "HP": 672,
        "AP": "£201,452",
        "SPC": "-3.8%"
    },
    {
        "UID": 783,
        "SN": "Lowestoft",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 783,
        "NE": 224,
        "WB": 922,
        "HC": 350,
        "SCH": 988,
        "HP": 1211,
        "AP": "£381,085",
        "SPC": "0.1%"
    },
    {
        "UID": 784,
        "SN": "Bargoed",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 784,
        "NE": 39,
        "WB": 868,
        "HC": 1082,
        "SCH": 307,
        "HP": 1400,
        "AP": "£236,206",
        "SPC": "17.3%"
    },
    {
        "UID": 785,
        "SN": "Halstead (Braintree)",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 785,
        "NE": 578,
        "WB": 115,
        "HC": 635,
        "SCH": 1424,
        "HP": 946,
        "AP": "£517,092",
        "SPC": "3.3%"
    },
    {
        "UID": 786,
        "SN": "Worcester",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 786,
        "NE": 681,
        "WB": 1198,
        "HC": 321,
        "SCH": 669,
        "HP": 838,
        "AP": "£434,420",
        "SPC": "3.4%"
    },
    {
        "UID": 787,
        "SN": "Seaton Delaval",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 787,
        "NE": 365,
        "WB": 1152,
        "HC": 738,
        "SCH": 852,
        "HP": 601,
        "AP": "£282,949",
        "SPC": "8.2%"
    },
    {
        "UID": 788,
        "SN": "Kingsbridge",
        "COU": "Devon",
        "REG": "South West",
        "OR": 788,
        "NE": 930,
        "WB": 227,
        "HC": 781,
        "SCH": 1280,
        "HP": 491,
        "AP": "£548,955",
        "SPC": "0.5%"
    },
    {
        "UID": 789,
        "SN": "Wixams",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 789,
        "NE": 262,
        "WB": 975,
        "HC": 1333,
        "SCH": 862,
        "HP": 278,
        "AP": "£508,353",
        "SPC": "-1.3%"
    },
    {
        "UID": 790,
        "SN": "Dartford",
        "COU": "Kent",
        "REG": "South East",
        "OR": 790,
        "NE": 1041,
        "WB": 1419,
        "HC": 469,
        "SCH": 169,
        "HP": 614,
        "AP": "£642,135",
        "SPC": "1.0%"
    },
    {
        "UID": 791,
        "SN": "Old Windsor and Wraysbury",
        "COU": "Windsor and Maidenhead",
        "REG": "South East",
        "OR": 791,
        "NE": 1403,
        "WB": 1053,
        "HC": 410,
        "SCH": 805,
        "HP": 42,
        "AP": "£772,142",
        "SPC": "-3.0%"
    },
    {
        "UID": 792,
        "SN": "Buntingford",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 792,
        "NE": 1211,
        "WB": 172,
        "HC": 1069,
        "SCH": 1246,
        "HP": 17,
        "AP": "£645,226",
        "SPC": "-6.0%"
    },
    {
        "UID": 793,
        "SN": "Birstall",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 793,
        "NE": 664,
        "WB": 1312,
        "HC": 692,
        "SCH": 566,
        "HP": 482,
        "AP": "£464,286",
        "SPC": "5.1%"
    },
    {
        "UID": 794,
        "SN": "Llanharan and Brynna",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 794,
        "NE": 1096,
        "WB": 246,
        "HC": 1332,
        "SCH": 665,
        "HP": 382,
        "AP": "£356,034",
        "SPC": "-1.4%"
    },
    {
        "UID": 795,
        "SN": "Hattersley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 795,
        "NE": 101,
        "WB": 1375,
        "HC": 1221,
        "SCH": 176,
        "HP": 849,
        "AP": "£307,902",
        "SPC": "-1.1%"
    },
    {
        "UID": 796,
        "SN": "Wombwell",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 796,
        "NE": 940,
        "WB": 673,
        "HC": 748,
        "SCH": 535,
        "HP": 828,
        "AP": "£238,494",
        "SPC": "-6.9%"
    },
    {
        "UID": 797,
        "SN": "Shrewsbury",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 797,
        "NE": 881,
        "WB": 769,
        "HC": 625,
        "SCH": 1042,
        "HP": 410,
        "AP": "£432,603",
        "SPC": "1.5%"
    },
    {
        "UID": 798,
        "SN": "Ferryhill",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 798,
        "NE": 299,
        "WB": 830,
        "HC": 1192,
        "SCH": 343,
        "HP": 1067,
        "AP": "£118,384",
        "SPC": "0.5%"
    },
    {
        "UID": 799,
        "SN": "Ashingdon",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 799,
        "NE": 1307,
        "WB": 290,
        "HC": 882,
        "SCH": 1088,
        "HP": 168,
        "AP": "£632,795",
        "SPC": "1.3%"
    },
    {
        "UID": 800,
        "SN": "Ashley (New Forest)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 800,
        "NE": 29,
        "WB": 978,
        "HC": 1220,
        "SCH": 1070,
        "HP": 439,
        "AP": "£634,324",
        "SPC": "-3.0%"
    },
    {
        "UID": 801,
        "SN": "Rothwell (North Northamptonshire)",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 801,
        "NE": 454,
        "WB": 691,
        "HC": 541,
        "SCH": 1253,
        "HP": 799,
        "AP": "£401,901",
        "SPC": "2.4%"
    },
    {
        "UID": 802,
        "SN": "Rhisga",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 802,
        "NE": 999,
        "WB": 780,
        "HC": 152,
        "SCH": 518,
        "HP": 1290,
        "AP": "£293,007",
        "SPC": "6.5%"
    },
    {
        "UID": 803,
        "SN": "Bwcle",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 802,
        "NE": 42,
        "WB": 1136,
        "HC": 1355,
        "SCH": 387,
        "HP": 819,
        "AP": "£350,475",
        "SPC": "4.9%"
    },
    {
        "UID": 804,
        "SN": "Coxheath",
        "COU": "Kent",
        "REG": "South East",
        "OR": 802,
        "NE": 629,
        "WB": 620,
        "HC": 379,
        "SCH": 826,
        "HP": 1285,
        "AP": "£601,799",
        "SPC": "3.7%"
    },
    {
        "UID": 805,
        "SN": "Rishton",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 805,
        "NE": 753,
        "WB": 588,
        "HC": 642,
        "SCH": 408,
        "HP": 1352,
        "AP": "£209,440",
        "SPC": "2.7%"
    },
    {
        "UID": 806,
        "SN": "Shrivenham and Watchfield",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 805,
        "NE": 140,
        "WB": 178,
        "HC": 990,
        "SCH": 1340,
        "HP": 1095,
        "AP": "£524,844",
        "SPC": "4.8%"
    },
    {
        "UID": 807,
        "SN": "Platt Bridge and Abram",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 807,
        "NE": 891,
        "WB": 512,
        "HC": 819,
        "SCH": 436,
        "HP": 1086,
        "AP": "£234,248",
        "SPC": "-4.6%"
    },
    {
        "UID": 808,
        "SN": "Ashford (Ashford)",
        "COU": "Kent",
        "REG": "South East",
        "OR": 807,
        "NE": 395,
        "WB": 643,
        "HC": 1058,
        "SCH": 297,
        "HP": 1351,
        "AP": "£514,805",
        "SPC": "2.6%"
    },
    {
        "UID": 809,
        "SN": "Ushaw Moor and Bearpark",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 807,
        "NE": 451,
        "WB": 164,
        "HC": 1198,
        "SCH": 605,
        "HP": 1326,
        "AP": "£210,507",
        "SPC": "14.1%"
    },
    {
        "UID": 810,
        "SN": "Crowborough",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 807,
        "NE": 184,
        "WB": 157,
        "HC": 1287,
        "SCH": 1264,
        "HP": 852,
        "AP": "£616,524",
        "SPC": "-0.2%"
    },
    {
        "UID": 811,
        "SN": "Trefynwy",
        "COU": "Monmouthshire",
        "REG": "Wales",
        "OR": 811,
        "NE": 475,
        "WB": 821,
        "HC": 669,
        "SCH": 1400,
        "HP": 380,
        "AP": "£460,133",
        "SPC": "6.3%"
    },
    {
        "UID": 812,
        "SN": "Beccles",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 812,
        "NE": 508,
        "WB": 822,
        "HC": 325,
        "SCH": 940,
        "HP": 1152,
        "AP": "£456,636",
        "SPC": "0.5%"
    },
    {
        "UID": 813,
        "SN": "Poringland",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 812,
        "NE": 304,
        "WB": 216,
        "HC": 553,
        "SCH": 1350,
        "HP": 1324,
        "AP": "£479,973",
        "SPC": "5.1%"
    },
    {
        "UID": 814,
        "SN": "Brandon (County Durham)",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 814,
        "NE": 539,
        "WB": 569,
        "HC": 1261,
        "SCH": 890,
        "HP": 490,
        "AP": "£221,512",
        "SPC": "-6.6%"
    },
    {
        "UID": 815,
        "SN": "Syston",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 815,
        "NE": 1376,
        "WB": 1146,
        "HC": 248,
        "SCH": 561,
        "HP": 419,
        "AP": "£437,515",
        "SPC": "3.0%"
    },
    {
        "UID": 816,
        "SN": "Lightwater",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 816,
        "NE": 1254,
        "WB": 652,
        "HC": 971,
        "SCH": 776,
        "HP": 98,
        "AP": "£732,526",
        "SPC": "0.3%"
    },
    {
        "UID": 817,
        "SN": "Bingley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 817,
        "NE": 874,
        "WB": 900,
        "HC": 86,
        "SCH": 1092,
        "HP": 801,
        "AP": "£347,510",
        "SPC": "2.0%"
    },
    {
        "UID": 818,
        "SN": "Whitehill (East Hampshire)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 818,
        "NE": 328,
        "WB": 212,
        "HC": 1304,
        "SCH": 923,
        "HP": 987,
        "AP": "£671,353",
        "SPC": "12.0%"
    },
    {
        "UID": 819,
        "SN": "Ottery St Mary",
        "COU": "Devon",
        "REG": "South West",
        "OR": 819,
        "NE": 843,
        "WB": 312,
        "HC": 423,
        "SCH": 1025,
        "HP": 1154,
        "AP": "£511,548",
        "SPC": "3.3%"
    },
    {
        "UID": 820,
        "SN": "Little Hulton",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 820,
        "NE": 793,
        "WB": 1358,
        "HC": 768,
        "SCH": 8,
        "HP": 831,
        "AP": "£306,550",
        "SPC": "-0.5%"
    },
    {
        "UID": 821,
        "SN": "Blackwater (Hart)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 820,
        "NE": 1354,
        "WB": 516,
        "HC": 1033,
        "SCH": 536,
        "HP": 319,
        "AP": "£617,211",
        "SPC": "1.8%"
    },
    {
        "UID": 822,
        "SN": "North Walsham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 822,
        "NE": 18,
        "WB": 252,
        "HC": 1060,
        "SCH": 1108,
        "HP": 1324,
        "AP": "£459,019",
        "SPC": "1.6%"
    },
    {
        "UID": 823,
        "SN": "Bedwas",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 823,
        "NE": 818,
        "WB": 745,
        "HC": 939,
        "SCH": 193,
        "HP": 1071,
        "AP": "£349,400",
        "SPC": "6.3%"
    },
    {
        "UID": 824,
        "SN": "Redruth",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 823,
        "NE": 758,
        "WB": 353,
        "HC": 667,
        "SCH": 728,
        "HP": 1260,
        "AP": "£414,896",
        "SPC": "2.8%"
    },
    {
        "UID": 825,
        "SN": "Stourbridge",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 825,
        "NE": 574,
        "WB": 860,
        "HC": 522,
        "SCH": 903,
        "HP": 908,
        "AP": "£418,234",
        "SPC": "2.6%"
    },
    {
        "UID": 826,
        "SN": "Stourport-on-Severn",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 826,
        "NE": 382,
        "WB": 883,
        "HC": 668,
        "SCH": 684,
        "HP": 1153,
        "AP": "£399,573",
        "SPC": "4.1%"
    },
    {
        "UID": 827,
        "SN": "Stalybridge",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 827,
        "NE": 1110,
        "WB": 1205,
        "HC": 148,
        "SCH": 178,
        "HP": 1131,
        "AP": "£357,255",
        "SPC": "4.6%"
    },
    {
        "UID": 828,
        "SN": "West End (Eastleigh)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 828,
        "NE": 215,
        "WB": 904,
        "HC": 819,
        "SCH": 811,
        "HP": 1024,
        "AP": "£577,733",
        "SPC": "3.8%"
    },
    {
        "UID": 829,
        "SN": "Wigan",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 829,
        "NE": 996,
        "WB": 1069,
        "HC": 377,
        "SCH": 66,
        "HP": 1266,
        "AP": "£263,181",
        "SPC": "0.9%"
    },
    {
        "UID": 830,
        "SN": "Orrell",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 829,
        "NE": 863,
        "WB": 1061,
        "HC": 343,
        "SCH": 294,
        "HP": 1213,
        "AP": "£315,329",
        "SPC": "2.4%"
    },
    {
        "UID": 831,
        "SN": "Kidderminster",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 829,
        "NE": 496,
        "WB": 1191,
        "HC": 603,
        "SCH": 510,
        "HP": 974,
        "AP": "£359,694",
        "SPC": "0.4%"
    },
    {
        "UID": 832,
        "SN": "Canterbury",
        "COU": "Kent",
        "REG": "South East",
        "OR": 832,
        "NE": 501,
        "WB": 1072,
        "HC": 93,
        "SCH": 1162,
        "HP": 950,
        "AP": "£541,665",
        "SPC": "-1.0%"
    },
    {
        "UID": 833,
        "SN": "Marlborough",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 833,
        "NE": 1045,
        "WB": 120,
        "HC": 863,
        "SCH": 1214,
        "HP": 537,
        "AP": "£598,563",
        "SPC": "3.5%"
    },
    {
        "UID": 834,
        "SN": "Barton-upon-Humber",
        "COU": "North Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 834,
        "NE": 1164,
        "WB": 630,
        "HC": 106,
        "SCH": 1242,
        "HP": 645,
        "AP": "£286,913",
        "SPC": "-5.1%"
    },
    {
        "UID": 835,
        "SN": "Lancing and Sompting",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 835,
        "NE": 1186,
        "WB": 591,
        "HC": 860,
        "SCH": 160,
        "HP": 996,
        "AP": "£630,362",
        "SPC": "0.7%"
    },
    {
        "UID": 836,
        "SN": "Maryport",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 835,
        "NE": 850,
        "WB": 513,
        "HC": 412,
        "SCH": 757,
        "HP": 1261,
        "AP": "£204,275",
        "SPC": "11.3%"
    },
    {
        "UID": 837,
        "SN": "Blackrod",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 837,
        "NE": 1082,
        "WB": 744,
        "HC": 754,
        "SCH": 4,
        "HP": 1210,
        "AP": "£351,515",
        "SPC": "8.5%"
    },
    {
        "UID": 838,
        "SN": "Newark-on-Trent",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 838,
        "NE": 1299,
        "WB": 1280,
        "HC": 290,
        "SCH": 455,
        "HP": 478,
        "AP": "£319,405",
        "SPC": "-0.5%"
    },
    {
        "UID": 839,
        "SN": "Bae Colwyn",
        "COU": "Conwy",
        "REG": "Wales",
        "OR": 839,
        "NE": 176,
        "WB": 1206,
        "HC": 251,
        "SCH": 1103,
        "HP": 1067,
        "AP": "£326,527",
        "SPC": "5.5%"
    },
    {
        "UID": 840,
        "SN": "Millom",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 840,
        "NE": 560,
        "WB": 9,
        "HC": 1165,
        "SCH": 795,
        "HP": 1275,
        "AP": "£194,009",
        "SPC": "13.8%"
    },
    {
        "UID": 841,
        "SN": "Lutterworth",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 841,
        "NE": 1031,
        "WB": 152,
        "HC": 1327,
        "SCH": 1056,
        "HP": 240,
        "AP": "£459,500",
        "SPC": "2.3%"
    },
    {
        "UID": 842,
        "SN": "Newent",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 842,
        "NE": 876,
        "WB": 384,
        "HC": 1014,
        "SCH": 1184,
        "HP": 349,
        "AP": "£426,645",
        "SPC": "-1.7%"
    },
    {
        "UID": 843,
        "SN": "Gosport",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 843,
        "NE": 361,
        "WB": 928,
        "HC": 140,
        "SCH": 1010,
        "HP": 1369,
        "AP": "£440,191",
        "SPC": "2.0%"
    },
    {
        "UID": 844,
        "SN": "Sleaford",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 844,
        "NE": 1267,
        "WB": 871,
        "HC": 960,
        "SCH": 255,
        "HP": 456,
        "AP": "£338,304",
        "SPC": "-1.7%"
    },
    {
        "UID": 845,
        "SN": "Bicester",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 844,
        "NE": 918,
        "WB": 108,
        "HC": 1341,
        "SCH": 358,
        "HP": 1084,
        "AP": "£599,862",
        "SPC": "5.9%"
    },
    {
        "UID": 846,
        "SN": "Slough",
        "COU": "Slough",
        "REG": "South East",
        "OR": 846,
        "NE": 872,
        "WB": 1255,
        "HC": 711,
        "SCH": 371,
        "HP": 601,
        "AP": "£681,922",
        "SPC": "0.2%"
    },
    {
        "UID": 847,
        "SN": "Rochford",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 846,
        "NE": 1339,
        "WB": 848,
        "HC": 229,
        "SCH": 977,
        "HP": 417,
        "AP": "£556,941",
        "SPC": "2.6%"
    },
    {
        "UID": 848,
        "SN": "Hounslow",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 848,
        "NE": 952,
        "WB": 1154,
        "HC": 85,
        "SCH": 441,
        "HP": 1179,
        "AP": "£897,411",
        "SPC": "1.5%"
    },
    {
        "UID": 849,
        "SN": "Cleethorpes",
        "COU": "North East Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 849,
        "NE": 690,
        "WB": 747,
        "HC": 597,
        "SCH": 616,
        "HP": 1162,
        "AP": "£222,392",
        "SPC": "-1.8%"
    },
    {
        "UID": 850,
        "SN": "Cinderford",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 849,
        "NE": 915,
        "WB": 111,
        "HC": 1072,
        "SCH": 1307,
        "HP": 407,
        "AP": "£360,400",
        "SPC": "-3.0%"
    },
    {
        "UID": 851,
        "SN": "Aylesbury",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 851,
        "NE": 815,
        "WB": 916,
        "HC": 1001,
        "SCH": 407,
        "HP": 674,
        "AP": "£576,518",
        "SPC": "2.2%"
    },
    {
        "UID": 852,
        "SN": "Longton",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 852,
        "NE": 1283,
        "WB": 52,
        "HC": 551,
        "SCH": 1019,
        "HP": 909,
        "AP": "£403,960",
        "SPC": "10.0%"
    },
    {
        "UID": 853,
        "SN": "Eckington (North East Derbyshire)",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 853,
        "NE": 887,
        "WB": 41,
        "HC": 580,
        "SCH": 1190,
        "HP": 1118,
        "AP": "£348,645",
        "SPC": "7.4%"
    },
    {
        "UID": 854,
        "SN": "Wythenshawe",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 854,
        "NE": 1135,
        "WB": 1405,
        "HC": 643,
        "SCH": 54,
        "HP": 580,
        "AP": "£442,071",
        "SPC": "2.9%"
    },
    {
        "UID": 855,
        "SN": "Culcheth",
        "COU": "Warrington",
        "REG": "North West",
        "OR": 855,
        "NE": 1314,
        "WB": 240,
        "HC": 1272,
        "SCH": 457,
        "HP": 536,
        "AP": "£529,716",
        "SPC": "11.1%"
    },
    {
        "UID": 856,
        "SN": "Keighley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 856,
        "NE": 913,
        "WB": 1174,
        "HC": 177,
        "SCH": 352,
        "HP": 1204,
        "AP": "£240,755",
        "SPC": "1.7%"
    },
    {
        "UID": 857,
        "SN": "Denmead",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 857,
        "NE": 906,
        "WB": 42,
        "HC": 1346,
        "SCH": 1325,
        "HP": 204,
        "AP": "£612,325",
        "SPC": "-1.9%"
    },
    {
        "UID": 858,
        "SN": "Tamworth",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 858,
        "NE": 935,
        "WB": 1155,
        "HC": 1050,
        "SCH": 397,
        "HP": 288,
        "AP": "£405,443",
        "SPC": "-0.4%"
    },
    {
        "UID": 859,
        "SN": "Berechurch",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 859,
        "NE": 589,
        "WB": 1271,
        "HC": 1123,
        "SCH": 77,
        "HP": 768,
        "AP": "£489,310",
        "SPC": "-0.1%"
    },
    {
        "UID": 860,
        "SN": "Rotherham",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 859,
        "NE": 332,
        "WB": 1309,
        "HC": 449,
        "SCH": 466,
        "HP": 1272,
        "AP": "£254,459",
        "SPC": "3.9%"
    },
    {
        "UID": 861,
        "SN": "Barugh Green and Redbrook",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 859,
        "NE": 482,
        "WB": 584,
        "HC": 1173,
        "SCH": 544,
        "HP": 1045,
        "AP": "£362,192",
        "SPC": "6.2%"
    },
    {
        "UID": 862,
        "SN": "Taunton",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 859,
        "NE": 440,
        "WB": 868,
        "HC": 384,
        "SCH": 1157,
        "HP": 979,
        "AP": "£427,470",
        "SPC": "-0.6%"
    },
    {
        "UID": 863,
        "SN": "Selston",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 863,
        "NE": 424,
        "WB": 1218,
        "HC": 1223,
        "SCH": 67,
        "HP": 901,
        "AP": "£334,135",
        "SPC": "-2.2%"
    },
    {
        "UID": 864,
        "SN": "Middlesbrough",
        "COU": "Middlesbrough",
        "REG": "North East",
        "OR": 864,
        "NE": 654,
        "WB": 1387,
        "HC": 442,
        "SCH": 505,
        "HP": 846,
        "AP": "£208,043",
        "SPC": "-6.7%"
    },
    {
        "UID": 865,
        "SN": "Shifnal",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 865,
        "NE": 899,
        "WB": 1021,
        "HC": 593,
        "SCH": 752,
        "HP": 571,
        "AP": "£409,516",
        "SPC": "2.4%"
    },
    {
        "UID": 866,
        "SN": "Barrow-in-Furness",
        "COU": "Westmorland and Furness",
        "REG": "North West",
        "OR": 865,
        "NE": 641,
        "WB": 777,
        "HC": 886,
        "SCH": 877,
        "HP": 655,
        "AP": "£236,887",
        "SPC": "-3.4%"
    },
    {
        "UID": 867,
        "SN": "Horley (Reigate and Banstead)",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 867,
        "NE": 1259,
        "WB": 897,
        "HC": 700,
        "SCH": 661,
        "HP": 324,
        "AP": "£671,368",
        "SPC": "2.0%"
    },
    {
        "UID": 868,
        "SN": "Chester-le-Street",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 867,
        "NE": 492,
        "WB": 1187,
        "HC": 925,
        "SCH": 953,
        "HP": 284,
        "AP": "£259,611",
        "SPC": "-6.6%"
    },
    {
        "UID": 869,
        "SN": "Dinas Powys",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 867,
        "NE": 1351,
        "WB": 721,
        "HC": 429,
        "SCH": 881,
        "HP": 459,
        "AP": "£485,520",
        "SPC": "5.9%"
    },
    {
        "UID": 870,
        "SN": "Leicester Forest East and Kirby Muxloe",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 870,
        "NE": 711,
        "WB": 1059,
        "HC": 558,
        "SCH": 1100,
        "HP": 416,
        "AP": "£475,219",
        "SPC": "2.9%"
    },
    {
        "UID": 871,
        "SN": "Eastbourne",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 871,
        "NE": 443,
        "WB": 795,
        "HC": 263,
        "SCH": 1122,
        "HP": 1223,
        "AP": "£518,353",
        "SPC": "3.2%"
    },
    {
        "UID": 872,
        "SN": "Wymondham (South Norfolk)",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 872,
        "NE": 512,
        "WB": 172,
        "HC": 1047,
        "SCH": 803,
        "HP": 1315,
        "AP": "£481,662",
        "SPC": "4.8%"
    },
    {
        "UID": 873,
        "SN": "Wells",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 873,
        "NE": 430,
        "WB": 428,
        "HC": 479,
        "SCH": 1410,
        "HP": 1103,
        "AP": "£514,120",
        "SPC": "3.4%"
    },
    {
        "UID": 874,
        "SN": "Upton (Dorset)",
        "COU": "Bournemouth, Christchurch and Poole",
        "REG": "South West",
        "OR": 874,
        "NE": 155,
        "WB": 717,
        "HC": 1108,
        "SCH": 1055,
        "HP": 817,
        "AP": "£602,037",
        "SPC": "8.9%"
    },
    {
        "UID": 875,
        "SN": "Four Marks",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 874,
        "NE": 265,
        "WB": 305,
        "HC": 1407,
        "SCH": 1408,
        "HP": 467,
        "AP": "£599,998",
        "SPC": "-0.9%"
    },
    {
        "UID": 876,
        "SN": "Edenbridge",
        "COU": "Kent",
        "REG": "South East",
        "OR": 876,
        "NE": 699,
        "WB": 871,
        "HC": 846,
        "SCH": 1281,
        "HP": 156,
        "AP": "£590,349",
        "SPC": "-6.6%"
    },
    {
        "UID": 877,
        "SN": "Consett",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 877,
        "NE": 469,
        "WB": 408,
        "HC": 1104,
        "SCH": 980,
        "HP": 895,
        "AP": "£215,675",
        "SPC": "1.0%"
    },
    {
        "UID": 878,
        "SN": "Hullbridge",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 877,
        "NE": 975,
        "WB": 402,
        "HC": 1270,
        "SCH": 766,
        "HP": 443,
        "AP": "£672,197",
        "SPC": "8.9%"
    },
    {
        "UID": 879,
        "SN": "Rhosllannerchrugog",
        "COU": "Wrexham",
        "REG": "Wales",
        "OR": 879,
        "NE": 179,
        "WB": 724,
        "HC": 524,
        "SCH": 1149,
        "HP": 1284,
        "AP": "£281,205",
        "SPC": "4.8%"
    },
    {
        "UID": 880,
        "SN": "Crook",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 880,
        "NE": 889,
        "WB": 337,
        "HC": 1317,
        "SCH": 603,
        "HP": 715,
        "AP": "£180,725",
        "SPC": "-5.2%"
    },
    {
        "UID": 881,
        "SN": "Deeping St James",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 880,
        "NE": 857,
        "WB": 170,
        "HC": 1312,
        "SCH": 928,
        "HP": 594,
        "AP": "£414,712",
        "SPC": "1.3%"
    },
    {
        "UID": 882,
        "SN": "Codsall",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 880,
        "NE": 611,
        "WB": 334,
        "HC": 1224,
        "SCH": 1387,
        "HP": 305,
        "AP": "£476,548",
        "SPC": "4.1%"
    },
    {
        "UID": 883,
        "SN": "Cleator Moor",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 883,
        "NE": 436,
        "WB": 104,
        "HC": 722,
        "SCH": 1337,
        "HP": 1265,
        "AP": "£202,403",
        "SPC": "13.0%"
    },
    {
        "UID": 884,
        "SN": "Dover",
        "COU": "Kent",
        "REG": "South East",
        "OR": 884,
        "NE": 730,
        "WB": 1287,
        "HC": 416,
        "SCH": 336,
        "HP": 1099,
        "AP": "£390,982",
        "SPC": "-1.7%"
    },
    {
        "UID": 885,
        "SN": "Y Coed Duon",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 884,
        "NE": 432,
        "WB": 983,
        "HC": 1337,
        "SCH": 518,
        "HP": 598,
        "AP": "£304,964",
        "SPC": "-2.9%"
    },
    {
        "UID": 886,
        "SN": "Minehead",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 886,
        "NE": 643,
        "WB": 415,
        "HC": 401,
        "SCH": 1392,
        "HP": 1020,
        "AP": "£428,817",
        "SPC": "-0.0%"
    },
    {
        "UID": 887,
        "SN": "Doc Penfro",
        "COU": "Pembrokeshire",
        "REG": "Wales",
        "OR": 887,
        "NE": 62,
        "WB": 1423,
        "HC": 308,
        "SCH": 1345,
        "HP": 739,
        "AP": "£211,640",
        "SPC": "-8.7%"
    },
    {
        "UID": 888,
        "SN": "Hertford",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 888,
        "NE": 1405,
        "WB": 1359,
        "HC": 147,
        "SCH": 924,
        "HP": 43,
        "AP": "£769,832",
        "SPC": "0.2%"
    },
    {
        "UID": 889,
        "SN": "Barnsley",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 889,
        "NE": 715,
        "WB": 1176,
        "HC": 461,
        "SCH": 386,
        "HP": 1141,
        "AP": "£245,983",
        "SPC": "0.7%"
    },
    {
        "UID": 890,
        "SN": "Coalville",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 889,
        "NE": 651,
        "WB": 714,
        "HC": 1147,
        "SCH": 520,
        "HP": 847,
        "AP": "£371,047",
        "SPC": "7.8%"
    },
    {
        "UID": 891,
        "SN": "Catshill",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 891,
        "NE": 1330,
        "WB": 612,
        "HC": 1358,
        "SCH": 417,
        "HP": 164,
        "AP": "£462,926",
        "SPC": "1.9%"
    },
    {
        "UID": 892,
        "SN": "Beddau",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 891,
        "NE": 474,
        "WB": 558,
        "HC": 1340,
        "SCH": 524,
        "HP": 985,
        "AP": "£372,372",
        "SPC": "8.6%"
    },
    {
        "UID": 893,
        "SN": "Mexborough",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 893,
        "NE": 827,
        "WB": 984,
        "HC": 973,
        "SCH": 369,
        "HP": 731,
        "AP": "£181,327",
        "SPC": "-5.0%"
    },
    {
        "UID": 894,
        "SN": "Winnersh",
        "COU": "Wokingham",
        "REG": "South East",
        "OR": 893,
        "NE": 1323,
        "WB": 964,
        "HC": 843,
        "SCH": 552,
        "HP": 202,
        "AP": "£685,598",
        "SPC": "1.4%"
    },
    {
        "UID": 895,
        "SN": "Stansted Mountfitchet",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 893,
        "NE": 1264,
        "WB": 679,
        "HC": 551,
        "SCH": 1332,
        "HP": 58,
        "AP": "£639,262",
        "SPC": "-2.8%"
    },
    {
        "UID": 896,
        "SN": "Wakefield",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 896,
        "NE": 860,
        "WB": 1142,
        "HC": 349,
        "SCH": 694,
        "HP": 840,
        "AP": "£334,198",
        "SPC": "0.4%"
    },
    {
        "UID": 897,
        "SN": "Harlow",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 896,
        "NE": 834,
        "WB": 591,
        "HC": 776,
        "SCH": 808,
        "HP": 876,
        "AP": "£581,072",
        "SPC": "-0.3%"
    },
    {
        "UID": 898,
        "SN": "Liversedge",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 898,
        "NE": 1262,
        "WB": 892,
        "HC": 185,
        "SCH": 595,
        "HP": 958,
        "AP": "£322,066",
        "SPC": "4.5%"
    },
    {
        "UID": 899,
        "SN": "Adlington (Chorley)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 898,
        "NE": 1016,
        "WB": 813,
        "HC": 585,
        "SCH": 869,
        "HP": 609,
        "AP": "£341,018",
        "SPC": "0.8%"
    },
    {
        "UID": 900,
        "SN": "Leighton Buzzard",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 898,
        "NE": 1027,
        "WB": 664,
        "HC": 811,
        "SCH": 958,
        "HP": 432,
        "AP": "£589,983",
        "SPC": "3.2%"
    },
    {
        "UID": 901,
        "SN": "Bridlington",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 898,
        "NE": 157,
        "WB": 958,
        "HC": 761,
        "SCH": 1004,
        "HP": 1012,
        "AP": "£310,450",
        "SPC": "8.7%"
    },
    {
        "UID": 902,
        "SN": "Locks Heath",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 902,
        "NE": 697,
        "WB": 648,
        "HC": 343,
        "SCH": 1091,
        "HP": 1114,
        "AP": "£599,329",
        "SPC": "4.4%"
    },
    {
        "UID": 903,
        "SN": "Ross-on-Wye",
        "COU": "Herefordshire, County of",
        "REG": "West Midlands",
        "OR": 902,
        "NE": 518,
        "WB": 251,
        "HC": 632,
        "SCH": 1388,
        "HP": 1104,
        "AP": "£435,996",
        "SPC": "6.2%"
    },
    {
        "UID": 904,
        "SN": "Earls Barton",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 904,
        "NE": 965,
        "WB": 681,
        "HC": 370,
        "SCH": 1148,
        "HP": 730,
        "AP": "£460,147",
        "SPC": "3.7%"
    },
    {
        "UID": 905,
        "SN": "Lincoln",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 905,
        "NE": 1154,
        "WB": 1249,
        "HC": 228,
        "SCH": 303,
        "HP": 961,
        "AP": "£326,829",
        "SPC": "0.3%"
    },
    {
        "UID": 906,
        "SN": "Trowbridge",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 905,
        "NE": 413,
        "WB": 948,
        "HC": 607,
        "SCH": 1118,
        "HP": 809,
        "AP": "£447,277",
        "SPC": "1.6%"
    },
    {
        "UID": 907,
        "SN": "Allerton Bywater",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 905,
        "NE": 1358,
        "WB": 256,
        "HC": 1244,
        "SCH": 262,
        "HP": 775,
        "AP": "£338,190",
        "SPC": "6.4%"
    },
    {
        "UID": 908,
        "SN": "Norton-on-Derwent",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 905,
        "NE": 589,
        "WB": 574,
        "HC": 1128,
        "SCH": 1423,
        "HP": 181,
        "AP": "£355,030",
        "SPC": "-4.6%"
    },
    {
        "UID": 909,
        "SN": "Somercotes and Swanwick",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 909,
        "NE": 351,
        "WB": 347,
        "HC": 778,
        "SCH": 1217,
        "HP": 1206,
        "AP": "£326,527",
        "SPC": "6.0%"
    },
    {
        "UID": 910,
        "SN": "Weston-super-Mare",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 910,
        "NE": 774,
        "WB": 945,
        "HC": 473,
        "SCH": 935,
        "HP": 773,
        "AP": "£435,771",
        "SPC": "2.3%"
    },
    {
        "UID": 911,
        "SN": "Cheadle (Staffordshire Moorlands)",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 910,
        "NE": 660,
        "WB": 478,
        "HC": 1143,
        "SCH": 1110,
        "HP": 509,
        "AP": "£343,686",
        "SPC": "1.1%"
    },
    {
        "UID": 912,
        "SN": "Pont-y-pÅµl",
        "COU": "Torfaen",
        "REG": "Wales",
        "OR": 912,
        "NE": 709,
        "WB": 1011,
        "HC": 517,
        "SCH": 943,
        "HP": 723,
        "AP": "£291,147",
        "SPC": "-6.0%"
    },
    {
        "UID": 913,
        "SN": "Askern",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 913,
        "NE": 1087,
        "WB": 265,
        "HC": 1423,
        "SCH": 449,
        "HP": 685,
        "AP": "£195,641",
        "SPC": "-8.1%"
    },
    {
        "UID": 914,
        "SN": "Staines-upon-Thames",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 914,
        "NE": 1357,
        "WB": 1126,
        "HC": 326,
        "SCH": 689,
        "HP": 412,
        "AP": "£826,707",
        "SPC": "13.2%"
    },
    {
        "UID": 915,
        "SN": "Whitwick",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 915,
        "NE": 1352,
        "WB": 538,
        "HC": 1182,
        "SCH": 324,
        "HP": 517,
        "AP": "£380,775",
        "SPC": "2.7%"
    },
    {
        "UID": 916,
        "SN": "Crewkerne",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 916,
        "NE": 480,
        "WB": 472,
        "HC": 682,
        "SCH": 1315,
        "HP": 965,
        "AP": "£406,419",
        "SPC": "-1.6%"
    },
    {
        "UID": 917,
        "SN": "Leicester",
        "COU": "Leicester",
        "REG": "East Midlands",
        "OR": 917,
        "NE": 1159,
        "WB": 1236,
        "HC": 107,
        "SCH": 244,
        "HP": 1169,
        "AP": "£403,283",
        "SPC": "3.3%"
    },
    {
        "UID": 918,
        "SN": "Hexham",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 918,
        "NE": 850,
        "WB": 1128,
        "HC": 805,
        "SCH": 1012,
        "HP": 124,
        "AP": "£360,692",
        "SPC": "1.6%"
    },
    {
        "UID": 919,
        "SN": "Petersfield",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 919,
        "NE": 460,
        "WB": 535,
        "HC": 992,
        "SCH": 1164,
        "HP": 769,
        "AP": "£714,494",
        "SPC": "5.9%"
    },
    {
        "UID": 920,
        "SN": "Gorleston-on-Sea",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 920,
        "NE": 465,
        "WB": 1283,
        "HC": 324,
        "SCH": 454,
        "HP": 1397,
        "AP": "£362,506",
        "SPC": "2.9%"
    },
    {
        "UID": 921,
        "SN": "Halifax",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 921,
        "NE": 398,
        "WB": 1131,
        "HC": 23,
        "SCH": 1085,
        "HP": 1288,
        "AP": "£251,371",
        "SPC": "4.5%"
    },
    {
        "UID": 922,
        "SN": "Ingatestone",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 922,
        "NE": 1367,
        "WB": 714,
        "HC": 424,
        "SCH": 1420,
        "HP": 4,
        "AP": "£758,934",
        "SPC": "-5.4%"
    },
    {
        "UID": 923,
        "SN": "Downham Market",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 923,
        "NE": 504,
        "WB": 272,
        "HC": 1313,
        "SCH": 424,
        "HP": 1417,
        "AP": "£451,642",
        "SPC": "7.5%"
    },
    {
        "UID": 924,
        "SN": "Milnrow",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 924,
        "NE": 1077,
        "WB": 1177,
        "HC": 214,
        "SCH": 280,
        "HP": 1183,
        "AP": "£323,246",
        "SPC": "3.9%"
    },
    {
        "UID": 925,
        "SN": "Rainworth",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 924,
        "NE": 1246,
        "WB": 460,
        "HC": 1417,
        "SCH": 200,
        "HP": 608,
        "AP": "£308,512",
        "SPC": "0.4%"
    },
    {
        "UID": 926,
        "SN": "Eston",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 926,
        "NE": 22,
        "WB": 1045,
        "HC": 950,
        "SCH": 620,
        "HP": 1296,
        "AP": "£207,011",
        "SPC": "4.0%"
    },
    {
        "UID": 927,
        "SN": "Soham",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 926,
        "NE": 1180,
        "WB": 50,
        "HC": 875,
        "SCH": 1295,
        "HP": 533,
        "AP": "£438,149",
        "SPC": "-3.9%"
    },
    {
        "UID": 928,
        "SN": "Darfield",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 928,
        "NE": 471,
        "WB": 403,
        "HC": 748,
        "SCH": 943,
        "HP": 1371,
        "AP": "£266,774",
        "SPC": "8.2%"
    },
    {
        "UID": 929,
        "SN": "Malton",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 928,
        "NE": 598,
        "WB": 497,
        "HC": 757,
        "SCH": 1421,
        "HP": 663,
        "AP": "£446,129",
        "SPC": "9.8%"
    },
    {
        "UID": 930,
        "SN": "Nottingham",
        "COU": "Nottingham",
        "REG": "East Midlands",
        "OR": 930,
        "NE": 1029,
        "WB": 1360,
        "HC": 99,
        "SCH": 93,
        "HP": 1358,
        "AP": "£345,127",
        "SPC": "4.5%"
    },
    {
        "UID": 931,
        "SN": "Countesthorpe",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 930,
        "NE": 1175,
        "WB": 447,
        "HC": 644,
        "SCH": 1002,
        "HP": 671,
        "AP": "£477,416",
        "SPC": "8.4%"
    },
    {
        "UID": 932,
        "SN": "Danbury",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 932,
        "NE": 1058,
        "WB": 416,
        "HC": 358,
        "SCH": 1418,
        "HP": 699,
        "AP": "£710,871",
        "SPC": "5.2%"
    },
    {
        "UID": 933,
        "SN": "Harleston",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 933,
        "NE": 230,
        "WB": 376,
        "HC": 937,
        "SCH": 1370,
        "HP": 1046,
        "AP": "£431,497",
        "SPC": "-0.3%"
    },
    {
        "UID": 934,
        "SN": "Standish",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 934,
        "NE": 673,
        "WB": 1024,
        "HC": 872,
        "SCH": 234,
        "HP": 1157,
        "AP": "£360,480",
        "SPC": "3.9%"
    },
    {
        "UID": 935,
        "SN": "Pickering",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 935,
        "NE": 717,
        "WB": 358,
        "HC": 839,
        "SCH": 1338,
        "HP": 709,
        "AP": "£429,790",
        "SPC": "12.5%"
    },
    {
        "UID": 936,
        "SN": "Hillingdon",
        "COU": "London",
        "REG": "Greater London",
        "OR": 936,
        "NE": 702,
        "WB": 1120,
        "HC": 346,
        "SCH": 714,
        "HP": 1081,
        "AP": "£840,478",
        "SPC": "1.5%"
    },
    {
        "UID": 937,
        "SN": "Shotton",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 936,
        "NE": 76,
        "WB": 759,
        "HC": 1253,
        "SCH": 573,
        "HP": 1302,
        "AP": "£261,191",
        "SPC": "13.6%"
    },
    {
        "UID": 938,
        "SN": "Creswell",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 936,
        "NE": 483,
        "WB": 18,
        "HC": 951,
        "SCH": 1384,
        "HP": 1127,
        "AP": "£241,457",
        "SPC": "-8.5%"
    },
    {
        "UID": 939,
        "SN": "Bewdley",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 939,
        "NE": 1345,
        "WB": 389,
        "HC": 208,
        "SCH": 1064,
        "HP": 960,
        "AP": "£462,506",
        "SPC": "4.2%"
    },
    {
        "UID": 940,
        "SN": "Oakham",
        "COU": "Rutland",
        "REG": "East Midlands",
        "OR": 940,
        "NE": 1061,
        "WB": 145,
        "HC": 1023,
        "SCH": 1327,
        "HP": 411,
        "AP": "£454,211",
        "SPC": "6.9%"
    },
    {
        "UID": 941,
        "SN": "Carlton (Gedling)",
        "COU": "Nottingham",
        "REG": "East Midlands",
        "OR": 941,
        "NE": 1399,
        "WB": 1065,
        "HC": 500,
        "SCH": 226,
        "HP": 782,
        "AP": "£383,466",
        "SPC": "4.6%"
    },
    {
        "UID": 942,
        "SN": "Meols",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 941,
        "NE": 1167,
        "WB": 11,
        "HC": 1289,
        "SCH": 1256,
        "HP": 249,
        "AP": "£442,865",
        "SPC": "1.9%"
    },
    {
        "UID": 943,
        "SN": "Daventry",
        "COU": "West Northamptonshire",
        "REG": "East Midlands",
        "OR": 943,
        "NE": 718,
        "WB": 478,
        "HC": 1366,
        "SCH": 1145,
        "HP": 267,
        "AP": "£413,986",
        "SPC": "0.1%"
    },
    {
        "UID": 944,
        "SN": "Bursledon",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 944,
        "NE": 778,
        "WB": 993,
        "HC": 336,
        "SCH": 1131,
        "HP": 738,
        "AP": "£551,620",
        "SPC": "-0.0%"
    },
    {
        "UID": 945,
        "SN": "Dereham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 945,
        "NE": 861,
        "WB": 176,
        "HC": 1138,
        "SCH": 615,
        "HP": 1188,
        "AP": "£418,789",
        "SPC": "-1.2%"
    },
    {
        "UID": 946,
        "SN": "Great Wyrley and Cheslyn Hay",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 945,
        "NE": 544,
        "WB": 1026,
        "HC": 1057,
        "SCH": 1105,
        "HP": 246,
        "AP": "£396,015",
        "SPC": "0.5%"
    },
    {
        "UID": 947,
        "SN": "Wootton (Bedford)",
        "COU": "Bedford",
        "REG": "East of England",
        "OR": 945,
        "NE": 544,
        "WB": 812,
        "HC": 797,
        "SCH": 508,
        "HP": 1317,
        "AP": "£578,163",
        "SPC": "15.0%"
    },
    {
        "UID": 948,
        "SN": "Maidstone",
        "COU": "Kent",
        "REG": "South East",
        "OR": 948,
        "NE": 742,
        "WB": 1190,
        "HC": 433,
        "SCH": 361,
        "HP": 1253,
        "AP": "£550,434",
        "SPC": "1.8%"
    },
    {
        "UID": 949,
        "SN": "Haslington",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 948,
        "NE": 1168,
        "WB": 513,
        "HC": 809,
        "SCH": 1309,
        "HP": 180,
        "AP": "£372,113",
        "SPC": "0.5%"
    },
    {
        "UID": 950,
        "SN": "East Wittering",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 950,
        "NE": 722,
        "WB": 106,
        "HC": 1414,
        "SCH": 1407,
        "HP": 331,
        "AP": "£697,484",
        "SPC": "-12.9%"
    },
    {
        "UID": 951,
        "SN": "Aveley",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 951,
        "NE": 1050,
        "WB": 1411,
        "HC": 884,
        "SCH": 72,
        "HP": 564,
        "AP": "£634,901",
        "SPC": "2.2%"
    },
    {
        "UID": 952,
        "SN": "King's Lynn",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 952,
        "NE": 566,
        "WB": 1315,
        "HC": 459,
        "SCH": 216,
        "HP": 1427,
        "AP": "£377,290",
        "SPC": "6.9%"
    },
    {
        "UID": 953,
        "SN": "Weaverham",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 953,
        "NE": 670,
        "WB": 332,
        "HC": 1196,
        "SCH": 1132,
        "HP": 656,
        "AP": "£356,244",
        "SPC": "5.2%"
    },
    {
        "UID": 954,
        "SN": "Merthyr Tudful",
        "COU": "Merthyr Tydfil",
        "REG": "Wales",
        "OR": 954,
        "NE": 678,
        "WB": 1147,
        "HC": 512,
        "SCH": 250,
        "HP": 1401,
        "AP": "£241,648",
        "SPC": "4.3%"
    },
    {
        "UID": 955,
        "SN": "Widnes",
        "COU": "Halton",
        "REG": "North West",
        "OR": 955,
        "NE": 633,
        "WB": 826,
        "HC": 825,
        "SCH": 856,
        "HP": 851,
        "AP": "£300,487",
        "SPC": "1.8%"
    },
    {
        "UID": 956,
        "SN": "Little Lever",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 956,
        "NE": 901,
        "WB": 1211,
        "HC": 781,
        "SCH": 50,
        "HP": 1051,
        "AP": "£324,050",
        "SPC": "2.5%"
    },
    {
        "UID": 957,
        "SN": "Hollywood",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 957,
        "NE": 1149,
        "WB": 982,
        "HC": 981,
        "SCH": 860,
        "HP": 29,
        "AP": "£525,743",
        "SPC": "-1.1%"
    },
    {
        "UID": 958,
        "SN": "Brough (East Riding of Yorkshire)",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 958,
        "NE": 1416,
        "WB": 594,
        "HC": 1265,
        "SCH": 583,
        "HP": 144,
        "AP": "£352,113",
        "SPC": "-4.5%"
    },
    {
        "UID": 959,
        "SN": "Halesowen",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 959,
        "NE": 610,
        "WB": 1081,
        "HC": 497,
        "SCH": 654,
        "HP": 1162,
        "AP": "£395,401",
        "SPC": "4.8%"
    },
    {
        "UID": 960,
        "SN": "Swaffham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 960,
        "NE": 665,
        "WB": 610,
        "HC": 901,
        "SCH": 416,
        "HP": 1414,
        "AP": "£417,428",
        "SPC": "4.6%"
    },
    {
        "UID": 961,
        "SN": "Caerfyrddin",
        "COU": "Carmarthenshire",
        "REG": "Wales",
        "OR": 961,
        "NE": 1025,
        "WB": 1022,
        "HC": 223,
        "SCH": 900,
        "HP": 842,
        "AP": "£294,983",
        "SPC": "3.1%"
    },
    {
        "UID": 962,
        "SN": "Perton",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 962,
        "NE": 859,
        "WB": 546,
        "HC": 1381,
        "SCH": 960,
        "HP": 269,
        "AP": "£460,314",
        "SPC": "2.9%"
    },
    {
        "UID": 963,
        "SN": "Fremington",
        "COU": "Devon",
        "REG": "South West",
        "OR": 963,
        "NE": 526,
        "WB": 238,
        "HC": 682,
        "SCH": 1412,
        "HP": 1160,
        "AP": "£551,175",
        "SPC": "3.1%"
    },
    {
        "UID": 964,
        "SN": "Paddock Wood",
        "COU": "Kent",
        "REG": "South East",
        "OR": 964,
        "NE": 703,
        "WB": 48,
        "HC": 1260,
        "SCH": 1289,
        "HP": 725,
        "AP": "£681,545",
        "SPC": "2.4%"
    },
    {
        "UID": 965,
        "SN": "Whitstable",
        "COU": "Kent",
        "REG": "South East",
        "OR": 965,
        "NE": 1209,
        "WB": 500,
        "HC": 162,
        "SCH": 1159,
        "HP": 998,
        "AP": "£725,146",
        "SPC": "4.3%"
    },
    {
        "UID": 966,
        "SN": "Honiton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 966,
        "NE": 666,
        "WB": 339,
        "HC": 956,
        "SCH": 890,
        "HP": 1182,
        "AP": "£500,639",
        "SPC": "3.3%"
    },
    {
        "UID": 967,
        "SN": "Shefford",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 967,
        "NE": 875,
        "WB": 792,
        "HC": 1091,
        "SCH": 1128,
        "HP": 149,
        "AP": "£564,695",
        "SPC": "-1.9%"
    },
    {
        "UID": 968,
        "SN": "Gillingham (Dorset)",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 968,
        "NE": 981,
        "WB": 430,
        "HC": 1065,
        "SCH": 638,
        "HP": 924,
        "AP": "£472,399",
        "SPC": "3.2%"
    },
    {
        "UID": 969,
        "SN": "Chandler's Ford",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 969,
        "NE": 1160,
        "WB": 763,
        "HC": 864,
        "SCH": 828,
        "HP": 424,
        "AP": "£634,692",
        "SPC": "-1.2%"
    },
    {
        "UID": 970,
        "SN": "Newport Pagnell",
        "COU": "Milton Keynes",
        "REG": "South East",
        "OR": 970,
        "NE": 1118,
        "WB": 695,
        "HC": 276,
        "SCH": 974,
        "HP": 977,
        "AP": "£570,161",
        "SPC": "2.0%"
    },
    {
        "UID": 971,
        "SN": "Littlehampton",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 970,
        "NE": 533,
        "WB": 538,
        "HC": 514,
        "SCH": 1332,
        "HP": 1123,
        "AP": "£512,357",
        "SPC": "-2.1%"
    },
    {
        "UID": 972,
        "SN": "Sandbach",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 972,
        "NE": 838,
        "WB": 949,
        "HC": 615,
        "SCH": 1304,
        "HP": 336,
        "AP": "£408,670",
        "SPC": "3.7%"
    },
    {
        "UID": 973,
        "SN": "Basingstoke",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 973,
        "NE": 75,
        "WB": 892,
        "HC": 1289,
        "SCH": 1147,
        "HP": 640,
        "AP": "£558,607",
        "SPC": "1.5%"
    },
    {
        "UID": 974,
        "SN": "Ilfracombe",
        "COU": "Devon",
        "REG": "South West",
        "OR": 974,
        "NE": 489,
        "WB": 854,
        "HC": 301,
        "SCH": 1268,
        "HP": 1134,
        "AP": "£382,071",
        "SPC": "-3.5%"
    },
    {
        "UID": 975,
        "SN": "Frome",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 975,
        "NE": 488,
        "WB": 993,
        "HC": 450,
        "SCH": 984,
        "HP": 1133,
        "AP": "£552,085",
        "SPC": "5.7%"
    },
    {
        "UID": 976,
        "SN": "Caerffili",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 976,
        "NE": 1070,
        "WB": 1121,
        "HC": 1162,
        "SCH": 182,
        "HP": 514,
        "AP": "£380,806",
        "SPC": "0.8%"
    },
    {
        "UID": 977,
        "SN": "Portsmouth",
        "COU": "Portsmouth",
        "REG": "South East",
        "OR": 976,
        "NE": 626,
        "WB": 1349,
        "HC": 36,
        "SCH": 697,
        "HP": 1341,
        "AP": "£463,994",
        "SPC": "1.4%"
    },
    {
        "UID": 978,
        "SN": "Staplehurst",
        "COU": "Kent",
        "REG": "South East",
        "OR": 978,
        "NE": 1019,
        "WB": 158,
        "HC": 762,
        "SCH": 1111,
        "HP": 1000,
        "AP": "£590,767",
        "SPC": "-0.2%"
    },
    {
        "UID": 979,
        "SN": "Colne",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 978,
        "NE": 581,
        "WB": 789,
        "HC": 385,
        "SCH": 1107,
        "HP": 1188,
        "AP": "£225,740",
        "SPC": "-3.1%"
    },
    {
        "UID": 980,
        "SN": "Storrington",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 980,
        "NE": 803,
        "WB": 462,
        "HC": 1154,
        "SCH": 1201,
        "HP": 431,
        "AP": "£663,997",
        "SPC": "-0.4%"
    },
    {
        "UID": 981,
        "SN": "Irthlingborough",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 981,
        "NE": 1291,
        "WB": 377,
        "HC": 553,
        "SCH": 1197,
        "HP": 634,
        "AP": "£390,460",
        "SPC": "0.4%"
    },
    {
        "UID": 982,
        "SN": "Horncastle",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 982,
        "NE": 780,
        "WB": 364,
        "HC": 548,
        "SCH": 999,
        "HP": 1362,
        "AP": "£350,239",
        "SPC": "8.7%"
    },
    {
        "UID": 983,
        "SN": "Northwich",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 983,
        "NE": 1085,
        "WB": 1091,
        "HC": 587,
        "SCH": 957,
        "HP": 334,
        "AP": "£314,271",
        "SPC": "-0.9%"
    },
    {
        "UID": 984,
        "SN": "Hemsworth",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 983,
        "NE": 147,
        "WB": 806,
        "HC": 1377,
        "SCH": 753,
        "HP": 971,
        "AP": "£243,213",
        "SPC": "-4.5%"
    },
    {
        "UID": 985,
        "SN": "Euxton",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 985,
        "NE": 1105,
        "WB": 1047,
        "HC": 1094,
        "SCH": 361,
        "HP": 449,
        "AP": "£341,104",
        "SPC": "-1.0%"
    },
    {
        "UID": 986,
        "SN": "Whitchurch (Basingstoke and Deane)",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 986,
        "NE": 1054,
        "WB": 141,
        "HC": 997,
        "SCH": 1182,
        "HP": 688,
        "AP": "£620,943",
        "SPC": "3.8%"
    },
    {
        "UID": 987,
        "SN": "Brimington",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 986,
        "NE": 512,
        "WB": 397,
        "HC": 629,
        "SCH": 1211,
        "HP": 1313,
        "AP": "£327,811",
        "SPC": "4.3%"
    },
    {
        "UID": 988,
        "SN": "Skelmersdale",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 988,
        "NE": 880,
        "WB": 839,
        "HC": 1168,
        "SCH": 512,
        "HP": 664,
        "AP": "£220,895",
        "SPC": "-1.2%"
    },
    {
        "UID": 989,
        "SN": "Doncaster",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 989,
        "NE": 1154,
        "WB": 1418,
        "HC": 726,
        "SCH": 73,
        "HP": 697,
        "AP": "£246,793",
        "SPC": "-3.0%"
    },
    {
        "UID": 990,
        "SN": "Peacehaven",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 990,
        "NE": 232,
        "WB": 686,
        "HC": 1262,
        "SCH": 925,
        "HP": 967,
        "AP": "£601,341",
        "SPC": "1.6%"
    },
    {
        "UID": 991,
        "SN": "Woodville",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 991,
        "NE": 856,
        "WB": 771,
        "HC": 813,
        "SCH": 817,
        "HP": 817,
        "AP": "£343,777",
        "SPC": "6.2%"
    },
    {
        "UID": 992,
        "SN": "Dudley (Dudley)",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 992,
        "NE": 722,
        "WB": 1111,
        "HC": 236,
        "SCH": 734,
        "HP": 1277,
        "AP": "£324,431",
        "SPC": "3.0%"
    },
    {
        "UID": 993,
        "SN": "Leominster",
        "COU": "Herefordshire, County of",
        "REG": "West Midlands",
        "OR": 992,
        "NE": 1205,
        "WB": 184,
        "HC": 804,
        "SCH": 1227,
        "HP": 660,
        "AP": "£368,951",
        "SPC": "-3.5%"
    },
    {
        "UID": 994,
        "SN": "Caernarfon",
        "COU": "Gwynedd",
        "REG": "Wales",
        "OR": 994,
        "NE": 802,
        "WB": 1044,
        "HC": 137,
        "SCH": 907,
        "HP": 1191,
        "AP": "£293,959",
        "SPC": "2.5%"
    },
    {
        "UID": 995,
        "SN": "Tadcaster",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 995,
        "NE": 1128,
        "WB": 612,
        "HC": 1109,
        "SCH": 981,
        "HP": 252,
        "AP": "£423,005",
        "SPC": "0.8%"
    },
    {
        "UID": 996,
        "SN": "Tarleton and Hesketh Bank",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 996,
        "NE": 1302,
        "WB": 279,
        "HC": 928,
        "SCH": 897,
        "HP": 683,
        "AP": "£380,813",
        "SPC": "7.3%"
    },
    {
        "UID": 997,
        "SN": "Addlestone",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 997,
        "NE": 1071,
        "WB": 1370,
        "HC": 397,
        "SCH": 961,
        "HP": 291,
        "AP": "£698,990",
        "SPC": "2.8%"
    },
    {
        "UID": 998,
        "SN": "Runwell",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 998,
        "NE": 1393,
        "WB": 396,
        "HC": 1082,
        "SCH": 401,
        "HP": 820,
        "AP": "£643,062",
        "SPC": "5.2%"
    },
    {
        "UID": 999,
        "SN": "Wombourne",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 998,
        "NE": 1152,
        "WB": 229,
        "HC": 910,
        "SCH": 1406,
        "HP": 395,
        "AP": "£490,669",
        "SPC": "6.7%"
    },
    {
        "UID": 1000,
        "SN": "Woodbridge",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1000,
        "NE": 1066,
        "WB": 155,
        "HC": 539,
        "SCH": 1266,
        "HP": 1067,
        "AP": "£660,416",
        "SPC": "6.0%"
    },
    {
        "UID": 1001,
        "SN": "Selby",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1001,
        "NE": 1312,
        "WB": 515,
        "HC": 1199,
        "SCH": 610,
        "HP": 463,
        "AP": "£324,553",
        "SPC": "0.1%"
    },
    {
        "UID": 1002,
        "SN": "Waltham Cross",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 1001,
        "NE": 1422,
        "WB": 1039,
        "HC": 634,
        "SCH": 439,
        "HP": 565,
        "AP": "£684,979",
        "SPC": "6.0%"
    },
    {
        "UID": 1003,
        "SN": "Seaham",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1003,
        "NE": 26,
        "WB": 944,
        "HC": 1124,
        "SCH": 938,
        "HP": 1071,
        "AP": "£223,213",
        "SPC": "3.3%"
    },
    {
        "UID": 1004,
        "SN": "Fulwood",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1004,
        "NE": 882,
        "WB": 1323,
        "HC": 953,
        "SCH": 442,
        "HP": 505,
        "AP": "£306,488",
        "SPC": "-2.1%"
    },
    {
        "UID": 1005,
        "SN": "Wellingborough",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1004,
        "NE": 675,
        "WB": 1248,
        "HC": 492,
        "SCH": 1060,
        "HP": 630,
        "AP": "£395,881",
        "SPC": "0.6%"
    },
    {
        "UID": 1006,
        "SN": "Billingham",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 1006,
        "NE": 1031,
        "WB": 848,
        "HC": 1080,
        "SCH": 208,
        "HP": 939,
        "AP": "£242,462",
        "SPC": "6.9%"
    },
    {
        "UID": 1007,
        "SN": "Washington",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 1007,
        "NE": 132,
        "WB": 1134,
        "HC": 684,
        "SCH": 1006,
        "HP": 1157,
        "AP": "£231,983",
        "SPC": "2.3%"
    },
    {
        "UID": 1008,
        "SN": "Treffynnon",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1008,
        "NE": 171,
        "WB": 1311,
        "HC": 1008,
        "SCH": 892,
        "HP": 736,
        "AP": "£290,371",
        "SPC": "0.9%"
    },
    {
        "UID": 1009,
        "SN": "North Baddesley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1009,
        "NE": 1101,
        "WB": 565,
        "HC": 1082,
        "SCH": 1027,
        "HP": 344,
        "AP": "£572,973",
        "SPC": "-6.8%"
    },
    {
        "UID": 1010,
        "SN": "Droitwich Spa",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 1010,
        "NE": 697,
        "WB": 748,
        "HC": 1013,
        "SCH": 1174,
        "HP": 489,
        "AP": "£432,693",
        "SPC": "2.4%"
    },
    {
        "UID": 1011,
        "SN": "Church Village",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1011,
        "NE": 153,
        "WB": 1218,
        "HC": 1372,
        "SCH": 521,
        "HP": 859,
        "AP": "£404,646",
        "SPC": "7.3%"
    },
    {
        "UID": 1012,
        "SN": "Louth",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1012,
        "NE": 916,
        "WB": 632,
        "HC": 528,
        "SCH": 668,
        "HP": 1380,
        "AP": "£333,084",
        "SPC": "7.9%"
    },
    {
        "UID": 1013,
        "SN": "Wellington (Somerset West and Taunton)",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1013,
        "NE": 79,
        "WB": 534,
        "HC": 845,
        "SCH": 1390,
        "HP": 1278,
        "AP": "£450,412",
        "SPC": "3.7%"
    },
    {
        "UID": 1014,
        "SN": "Ashton-in-Makerfield",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1014,
        "NE": 1166,
        "WB": 841,
        "HC": 575,
        "SCH": 265,
        "HP": 1282,
        "AP": "£296,301",
        "SPC": "2.4%"
    },
    {
        "UID": 1015,
        "SN": "Rushall and Shelfield",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1015,
        "NE": 725,
        "WB": 735,
        "HC": 1035,
        "SCH": 739,
        "HP": 899,
        "AP": "£346,074",
        "SPC": "-2.9%"
    },
    {
        "UID": 1016,
        "SN": "Treherbert",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1016,
        "NE": 1142,
        "WB": 536,
        "HC": 1155,
        "SCH": 500,
        "HP": 801,
        "AP": "£161,524",
        "SPC": "-6.8%"
    },
    {
        "UID": 1017,
        "SN": "Blackfield and Langley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1016,
        "NE": 845,
        "WB": 78,
        "HC": 1359,
        "SCH": 1206,
        "HP": 646,
        "AP": "£570,493",
        "SPC": "-2.0%"
    },
    {
        "UID": 1018,
        "SN": "Rugby",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1018,
        "NE": 1160,
        "WB": 1325,
        "HC": 894,
        "SCH": 629,
        "HP": 131,
        "AP": "£418,940",
        "SPC": "-0.7%"
    },
    {
        "UID": 1019,
        "SN": "Stevenage",
        "COU": "Hertfordshire",
        "REG": "East of England",
        "OR": 1018,
        "NE": 167,
        "WB": 937,
        "HC": 996,
        "SCH": 1005,
        "HP": 1034,
        "AP": "£584,344",
        "SPC": "2.4%"
    },
    {
        "UID": 1020,
        "SN": "Ludgershall (Wiltshire)",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 1020,
        "NE": 203,
        "WB": 324,
        "HC": 1283,
        "SCH": 1278,
        "HP": 1054,
        "AP": "£473,227",
        "SPC": "6.3%"
    },
    {
        "UID": 1021,
        "SN": "Brynteg (Wrexham)",
        "COU": "Wrexham",
        "REG": "Wales",
        "OR": 1021,
        "NE": 885,
        "WB": 568,
        "HC": 671,
        "SCH": 1083,
        "HP": 938,
        "AP": "£295,839",
        "SPC": "1.1%"
    },
    {
        "UID": 1022,
        "SN": "Portishead",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 1021,
        "NE": 1384,
        "WB": 605,
        "HC": 1294,
        "SCH": 398,
        "HP": 464,
        "AP": "£622,514",
        "SPC": "4.8%"
    },
    {
        "UID": 1023,
        "SN": "Broughton Astley",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1021,
        "NE": 1348,
        "WB": 317,
        "HC": 1402,
        "SCH": 920,
        "HP": 158,
        "AP": "£455,861",
        "SPC": "0.9%"
    },
    {
        "UID": 1024,
        "SN": "Shipley (Bradford)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1024,
        "NE": 1098,
        "WB": 1243,
        "HC": 35,
        "SCH": 559,
        "HP": 1213,
        "AP": "£319,694",
        "SPC": "6.4%"
    },
    {
        "UID": 1025,
        "SN": "Bodmin",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 1025,
        "NE": 838,
        "WB": 773,
        "HC": 640,
        "SCH": 725,
        "HP": 1176,
        "AP": "£381,656",
        "SPC": "1.2%"
    },
    {
        "UID": 1026,
        "SN": "Bedlington",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1026,
        "NE": 561,
        "WB": 753,
        "HC": 1233,
        "SCH": 954,
        "HP": 653,
        "AP": "£250,961",
        "SPC": "4.5%"
    },
    {
        "UID": 1027,
        "SN": "Wigston",
        "COU": "Leicester",
        "REG": "East Midlands",
        "OR": 1027,
        "NE": 1010,
        "WB": 858,
        "HC": 611,
        "SCH": 578,
        "HP": 1098,
        "AP": "£447,404",
        "SPC": "4.9%"
    },
    {
        "UID": 1028,
        "SN": "Tiverton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1028,
        "NE": 1284,
        "WB": 234,
        "HC": 790,
        "SCH": 805,
        "HP": 1043,
        "AP": "£437,437",
        "SPC": "-1.8%"
    },
    {
        "UID": 1029,
        "SN": "Cleckheaton",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1029,
        "NE": 1346,
        "WB": 1236,
        "HC": 44,
        "SCH": 658,
        "HP": 873,
        "AP": "£300,096",
        "SPC": "2.1%"
    },
    {
        "UID": 1030,
        "SN": "Market Warsop",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1029,
        "NE": 652,
        "WB": 437,
        "HC": 1258,
        "SCH": 705,
        "HP": 1105,
        "AP": "£266,526",
        "SPC": "-4.6%"
    },
    {
        "UID": 1031,
        "SN": "Okehampton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1031,
        "NE": 333,
        "WB": 327,
        "HC": 1049,
        "SCH": 1051,
        "HP": 1402,
        "AP": "£440,688",
        "SPC": "6.6%"
    },
    {
        "UID": 1032,
        "SN": "Rustington",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1032,
        "NE": 647,
        "WB": 293,
        "HC": 640,
        "SCH": 1405,
        "HP": 1179,
        "AP": "£660,120",
        "SPC": "3.0%"
    },
    {
        "UID": 1033,
        "SN": "Bearsted",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1033,
        "NE": 719,
        "WB": 876,
        "HC": 705,
        "SCH": 789,
        "HP": 1076,
        "AP": "£682,415",
        "SPC": "2.8%"
    },
    {
        "UID": 1034,
        "SN": "Kingston upon Hull",
        "COU": "Kingston upon Hull, City of, City of",
        "REG": "Yorkshire and The Humber",
        "OR": 1034,
        "NE": 1251,
        "WB": 1421,
        "HC": 229,
        "SCH": 159,
        "HP": 1111,
        "AP": "£227,545",
        "SPC": "-3.2%"
    },
    {
        "UID": 1035,
        "SN": "Darlaston",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1034,
        "NE": 926,
        "WB": 1125,
        "HC": 336,
        "SCH": 364,
        "HP": 1420,
        "AP": "£307,842",
        "SPC": "9.5%"
    },
    {
        "UID": 1036,
        "SN": "Whitchurch (Shropshire)",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 1036,
        "NE": 999,
        "WB": 140,
        "HC": 918,
        "SCH": 1232,
        "HP": 884,
        "AP": "£347,140",
        "SPC": "2.8%"
    },
    {
        "UID": 1037,
        "SN": "Rugeley",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1036,
        "NE": 505,
        "WB": 452,
        "HC": 1222,
        "SCH": 746,
        "HP": 1248,
        "AP": "£360,935",
        "SPC": "4.0%"
    },
    {
        "UID": 1038,
        "SN": "Whitfield (Dover)",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1036,
        "NE": 282,
        "WB": 667,
        "HC": 1413,
        "SCH": 913,
        "HP": 898,
        "AP": "£529,223",
        "SPC": "-2.2%"
    },
    {
        "UID": 1039,
        "SN": "Camborne",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 1039,
        "NE": 149,
        "WB": 845,
        "HC": 980,
        "SCH": 839,
        "HP": 1366,
        "AP": "£384,727",
        "SPC": "5.6%"
    },
    {
        "UID": 1040,
        "SN": "Houghton Regis",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 1040,
        "NE": 400,
        "WB": 1399,
        "HC": 1104,
        "SCH": 701,
        "HP": 583,
        "AP": "£551,773",
        "SPC": "4.0%"
    },
    {
        "UID": 1041,
        "SN": "Darton",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1041,
        "NE": 946,
        "WB": 629,
        "HC": 633,
        "SCH": 753,
        "HP": 1227,
        "AP": "£329,106",
        "SPC": "7.8%"
    },
    {
        "UID": 1042,
        "SN": "Hagley",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 1041,
        "NE": 1213,
        "WB": 460,
        "HC": 787,
        "SCH": 1398,
        "HP": 330,
        "AP": "£550,536",
        "SPC": "7.7%"
    },
    {
        "UID": 1043,
        "SN": "South Normanton and Pinxton",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1043,
        "NE": 661,
        "WB": 413,
        "HC": 1231,
        "SCH": 598,
        "HP": 1289,
        "AP": "£305,507",
        "SPC": "0.7%"
    },
    {
        "UID": 1044,
        "SN": "Brentwood",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1044,
        "NE": 1053,
        "WB": 1164,
        "HC": 541,
        "SCH": 1348,
        "HP": 90,
        "AP": "£772,613",
        "SPC": "1.9%"
    },
    {
        "UID": 1045,
        "SN": "Clayton-le-Moors",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1045,
        "NE": 191,
        "WB": 1310,
        "HC": 373,
        "SCH": 919,
        "HP": 1404,
        "AP": "£221,693",
        "SPC": "6.0%"
    },
    {
        "UID": 1046,
        "SN": "Tredegar",
        "COU": "Blaenau Gwent",
        "REG": "Wales",
        "OR": 1046,
        "NE": 705,
        "WB": 1273,
        "HC": 560,
        "SCH": 555,
        "HP": 1108,
        "AP": "£219,701",
        "SPC": "-2.9%"
    },
    {
        "UID": 1047,
        "SN": "Thornaby-on-Tees",
        "COU": "Stockton-on-Tees",
        "REG": "North East",
        "OR": 1047,
        "NE": 770,
        "WB": 981,
        "HC": 1036,
        "SCH": 239,
        "HP": 1177,
        "AP": "£204,861",
        "SPC": "7.5%"
    },
    {
        "UID": 1048,
        "SN": "Uckfield",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1048,
        "NE": 564,
        "WB": 232,
        "HC": 1120,
        "SCH": 1287,
        "HP": 1001,
        "AP": "£588,660",
        "SPC": "0.6%"
    },
    {
        "UID": 1049,
        "SN": "Catterick Garrison",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1049,
        "NE": 641,
        "WB": 5,
        "HC": 1401,
        "SCH": 1415,
        "HP": 744,
        "AP": "£293,714",
        "SPC": "1.3%"
    },
    {
        "UID": 1050,
        "SN": "Leyland",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1050,
        "NE": 1265,
        "WB": 1333,
        "HC": 586,
        "SCH": 450,
        "HP": 573,
        "AP": "£316,596",
        "SPC": "-1.1%"
    },
    {
        "UID": 1051,
        "SN": "Herne",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1050,
        "NE": 1012,
        "WB": 731,
        "HC": 406,
        "SCH": 841,
        "HP": 1217,
        "AP": "£611,799",
        "SPC": "4.4%"
    },
    {
        "UID": 1052,
        "SN": "Bude",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 1052,
        "NE": 743,
        "WB": 117,
        "HC": 1161,
        "SCH": 1049,
        "HP": 1140,
        "AP": "£572,529",
        "SPC": "10.9%"
    },
    {
        "UID": 1053,
        "SN": "Bulkington",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1053,
        "NE": 794,
        "WB": 671,
        "HC": 1101,
        "SCH": 1026,
        "HP": 619,
        "AP": "£405,096",
        "SPC": "-4.8%"
    },
    {
        "UID": 1054,
        "SN": "Deepcar",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1053,
        "NE": 659,
        "WB": 1395,
        "HC": 1079,
        "SCH": 899,
        "HP": 179,
        "AP": "£337,190",
        "SPC": "-6.4%"
    },
    {
        "UID": 1055,
        "SN": "Chard",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1055,
        "NE": 49,
        "WB": 465,
        "HC": 1000,
        "SCH": 1354,
        "HP": 1345,
        "AP": "£434,789",
        "SPC": "5.2%"
    },
    {
        "UID": 1056,
        "SN": "Annfield Plain",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1056,
        "NE": 381,
        "WB": 978,
        "HC": 1019,
        "SCH": 1103,
        "HP": 735,
        "AP": "£154,598",
        "SPC": "-7.8%"
    },
    {
        "UID": 1057,
        "SN": "Walsall",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1057,
        "NE": 764,
        "WB": 1314,
        "HC": 59,
        "SCH": 996,
        "HP": 1084,
        "AP": "£315,892",
        "SPC": "-1.2%"
    },
    {
        "UID": 1058,
        "SN": "Great Yarmouth",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1058,
        "NE": 783,
        "WB": 1356,
        "HC": 70,
        "SCH": 594,
        "HP": 1418,
        "AP": "£262,054",
        "SPC": "4.1%"
    },
    {
        "UID": 1059,
        "SN": "Long Eaton",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1059,
        "NE": 1220,
        "WB": 1051,
        "HC": 835,
        "SCH": 249,
        "HP": 868,
        "AP": "£383,719",
        "SPC": "5.9%"
    },
    {
        "UID": 1060,
        "SN": "Pontllanfraith",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 1060,
        "NE": 622,
        "WB": 1031,
        "HC": 1121,
        "SCH": 691,
        "HP": 759,
        "AP": "£318,754",
        "SPC": "0.5%"
    },
    {
        "UID": 1061,
        "SN": "Burwell",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1060,
        "NE": 1281,
        "WB": 255,
        "HC": 627,
        "SCH": 1321,
        "HP": 740,
        "AP": "£529,731",
        "SPC": "2.3%"
    },
    {
        "UID": 1062,
        "SN": "Amble",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1062,
        "NE": 649,
        "WB": 779,
        "HC": 1215,
        "SCH": 1113,
        "HP": 471,
        "AP": "£345,705",
        "SPC": "15.9%"
    },
    {
        "UID": 1063,
        "SN": "Hartford",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 1063,
        "NE": 818,
        "WB": 526,
        "HC": 1292,
        "SCH": 1302,
        "HP": 290,
        "AP": "£454,244",
        "SPC": "3.4%"
    },
    {
        "UID": 1064,
        "SN": "Loughborough",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1064,
        "NE": 1275,
        "WB": 1225,
        "HC": 857,
        "SCH": 464,
        "HP": 409,
        "AP": "£400,976",
        "SPC": "1.6%"
    },
    {
        "UID": 1065,
        "SN": "Pheasey",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1065,
        "NE": 837,
        "WB": 1307,
        "HC": 697,
        "SCH": 166,
        "HP": 1224,
        "AP": "£421,623",
        "SPC": "5.8%"
    },
    {
        "UID": 1066,
        "SN": "Wednesbury",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1065,
        "NE": 499,
        "WB": 1352,
        "HC": 467,
        "SCH": 586,
        "HP": 1327,
        "AP": "£329,365",
        "SPC": "2.5%"
    },
    {
        "UID": 1067,
        "SN": "Ilminster",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1067,
        "NE": 1163,
        "WB": 144,
        "HC": 602,
        "SCH": 986,
        "HP": 1337,
        "AP": "£443,121",
        "SPC": "5.3%"
    },
    {
        "UID": 1068,
        "SN": "Wickford",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1068,
        "NE": 1392,
        "WB": 939,
        "HC": 1249,
        "SCH": 429,
        "HP": 233,
        "AP": "£647,588",
        "SPC": "-1.0%"
    },
    {
        "UID": 1069,
        "SN": "Maesteg",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 1069,
        "NE": 906,
        "WB": 394,
        "HC": 932,
        "SCH": 647,
        "HP": 1370,
        "AP": "£209,430",
        "SPC": "5.6%"
    },
    {
        "UID": 1070,
        "SN": "Stone Cross",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1069,
        "NE": 377,
        "WB": 310,
        "HC": 899,
        "SCH": 1383,
        "HP": 1280,
        "AP": "£593,616",
        "SPC": "4.3%"
    },
    {
        "UID": 1071,
        "SN": "Stakeford",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1071,
        "NE": 934,
        "WB": 271,
        "HC": 1386,
        "SCH": 655,
        "HP": 1004,
        "AP": "£224,767",
        "SPC": "11.2%"
    },
    {
        "UID": 1072,
        "SN": "Garstang",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1072,
        "NE": 1091,
        "WB": 209,
        "HC": 1383,
        "SCH": 705,
        "HP": 864,
        "AP": "£394,292",
        "SPC": "7.5%"
    },
    {
        "UID": 1073,
        "SN": "Bletchley",
        "COU": "Milton Keynes",
        "REG": "South East",
        "OR": 1073,
        "NE": 823,
        "WB": 1022,
        "HC": 676,
        "SCH": 718,
        "HP": 1015,
        "AP": "£498,581",
        "SPC": "0.8%"
    },
    {
        "UID": 1074,
        "SN": "Tonypandy",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1074,
        "NE": 1066,
        "WB": 883,
        "HC": 771,
        "SCH": 525,
        "HP": 1010,
        "AP": "£186,767",
        "SPC": "-0.4%"
    },
    {
        "UID": 1075,
        "SN": "Larkfield",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1074,
        "NE": 822,
        "WB": 1347,
        "HC": 674,
        "SCH": 482,
        "HP": 930,
        "AP": "£631,578",
        "SPC": "4.7%"
    },
    {
        "UID": 1076,
        "SN": "Swallownest and Aston",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1074,
        "NE": 602,
        "WB": 1240,
        "HC": 1164,
        "SCH": 460,
        "HP": 789,
        "AP": "£344,347",
        "SPC": "2.5%"
    },
    {
        "UID": 1077,
        "SN": "Kirkby-in-Ashfield",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1077,
        "NE": 192,
        "WB": 916,
        "HC": 1165,
        "SCH": 567,
        "HP": 1419,
        "AP": "£302,269",
        "SPC": "11.7%"
    },
    {
        "UID": 1078,
        "SN": "Ponteland",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1078,
        "NE": 1412,
        "WB": 297,
        "HC": 1214,
        "SCH": 1231,
        "HP": 106,
        "AP": "£477,749",
        "SPC": "1.5%"
    },
    {
        "UID": 1079,
        "SN": "Emsworth",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1079,
        "NE": 624,
        "WB": 1093,
        "HC": 532,
        "SCH": 1318,
        "HP": 702,
        "AP": "£642,955",
        "SPC": "-4.0%"
    },
    {
        "UID": 1080,
        "SN": "Grays",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1080,
        "NE": 1256,
        "WB": 1128,
        "HC": 1062,
        "SCH": 83,
        "HP": 753,
        "AP": "£641,122",
        "SPC": "4.5%"
    },
    {
        "UID": 1081,
        "SN": "Westbury (Wiltshire)",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 1081,
        "NE": 910,
        "WB": 634,
        "HC": 654,
        "SCH": 1021,
        "HP": 1066,
        "AP": "£472,719",
        "SPC": "6.6%"
    },
    {
        "UID": 1082,
        "SN": "Aberdaugleddau",
        "COU": "Pembrokeshire",
        "REG": "Wales",
        "OR": 1082,
        "NE": 43,
        "WB": 1424,
        "HC": 549,
        "SCH": 1401,
        "HP": 869,
        "AP": "£244,392",
        "SPC": "-1.1%"
    },
    {
        "UID": 1083,
        "SN": "Castell-nedd",
        "COU": "Neath Port Talbot",
        "REG": "Wales",
        "OR": 1083,
        "NE": 1072,
        "WB": 971,
        "HC": 262,
        "SCH": 772,
        "HP": 1216,
        "AP": "£267,351",
        "SPC": "5.2%"
    },
    {
        "UID": 1084,
        "SN": "Radstock",
        "COU": "Bath and North East Somerset",
        "REG": "South West",
        "OR": 1083,
        "NE": 836,
        "WB": 700,
        "HC": 1141,
        "SCH": 1273,
        "HP": 343,
        "AP": "£469,499",
        "SPC": "-0.1%"
    },
    {
        "UID": 1085,
        "SN": "Redcar",
        "COU": "Redcar and Cleveland",
        "REG": "North East",
        "OR": 1085,
        "NE": 714,
        "WB": 1354,
        "HC": 891,
        "SCH": 276,
        "HP": 1059,
        "AP": "£244,737",
        "SPC": "3.3%"
    },
    {
        "UID": 1086,
        "SN": "Castle Donington",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1085,
        "NE": 1421,
        "WB": 550,
        "HC": 972,
        "SCH": 1212,
        "HP": 139,
        "AP": "£409,504",
        "SPC": "-1.3%"
    },
    {
        "UID": 1087,
        "SN": "Abersychan",
        "COU": "Torfaen",
        "REG": "Wales",
        "OR": 1087,
        "NE": 1040,
        "WB": 420,
        "HC": 805,
        "SCH": 878,
        "HP": 1155,
        "AP": "£245,834",
        "SPC": "0.2%"
    },
    {
        "UID": 1088,
        "SN": "Atherton",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1088,
        "NE": 1221,
        "WB": 1345,
        "HC": 443,
        "SCH": 12,
        "HP": 1280,
        "AP": "£305,871",
        "SPC": "2.8%"
    },
    {
        "UID": 1089,
        "SN": "PenarlÃ¢g",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1089,
        "NE": 1097,
        "WB": 1343,
        "HC": 406,
        "SCH": 1139,
        "HP": 323,
        "AP": "£356,109",
        "SPC": "-0.3%"
    },
    {
        "UID": 1090,
        "SN": "Abertyleri",
        "COU": "Blaenau Gwent",
        "REG": "Wales",
        "OR": 1090,
        "NE": 379,
        "WB": 1105,
        "HC": 811,
        "SCH": 590,
        "HP": 1426,
        "AP": "£195,910",
        "SPC": "7.9%"
    },
    {
        "UID": 1091,
        "SN": "Stocksbridge",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1091,
        "NE": 289,
        "WB": 1261,
        "HC": 1378,
        "SCH": 949,
        "HP": 440,
        "AP": "£313,573",
        "SPC": "-0.3%"
    },
    {
        "UID": 1092,
        "SN": "Galleywood",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1091,
        "NE": 1102,
        "WB": 404,
        "HC": 1142,
        "SCH": 1376,
        "HP": 293,
        "AP": "£630,443",
        "SPC": "-1.3%"
    },
    {
        "UID": 1093,
        "SN": "Diss",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1093,
        "NE": 748,
        "WB": 379,
        "HC": 897,
        "SCH": 1124,
        "HP": 1170,
        "AP": "£457,709",
        "SPC": "1.6%"
    },
    {
        "UID": 1094,
        "SN": "Sudbury",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1094,
        "NE": 464,
        "WB": 649,
        "HC": 886,
        "SCH": 988,
        "HP": 1334,
        "AP": "£490,828",
        "SPC": "2.7%"
    },
    {
        "UID": 1095,
        "SN": "Kettering",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1095,
        "NE": 999,
        "WB": 1097,
        "HC": 509,
        "SCH": 1034,
        "HP": 684,
        "AP": "£391,143",
        "SPC": "0.9%"
    },
    {
        "UID": 1096,
        "SN": "Rushden",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1096,
        "NE": 776,
        "WB": 1317,
        "HC": 797,
        "SCH": 652,
        "HP": 786,
        "AP": "£402,972",
        "SPC": "2.3%"
    },
    {
        "UID": 1097,
        "SN": "Hebden Bridge",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1096,
        "NE": 1321,
        "WB": 717,
        "HC": 200,
        "SCH": 1313,
        "HP": 777,
        "AP": "£367,494",
        "SPC": "3.9%"
    },
    {
        "UID": 1098,
        "SN": "Clifton (Nottingham)",
        "COU": "Nottingham",
        "REG": "East Midlands",
        "OR": 1098,
        "NE": 726,
        "WB": 1381,
        "HC": 745,
        "SCH": 95,
        "HP": 1382,
        "AP": "£329,868",
        "SPC": "4.7%"
    },
    {
        "UID": 1099,
        "SN": "Barrow upon Soar",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1098,
        "NE": 1327,
        "WB": 931,
        "HC": 629,
        "SCH": 1027,
        "HP": 415,
        "AP": "£450,617",
        "SPC": "3.3%"
    },
    {
        "UID": 1100,
        "SN": "Sileby",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1100,
        "NE": 1186,
        "WB": 896,
        "HC": 817,
        "SCH": 1115,
        "HP": 318,
        "AP": "£414,208",
        "SPC": "1.1%"
    },
    {
        "UID": 1101,
        "SN": "Havering",
        "COU": "London",
        "REG": "Greater London",
        "OR": 1101,
        "NE": 1178,
        "WB": 1137,
        "HC": 688,
        "SCH": 186,
        "HP": 1146,
        "AP": "£719,188",
        "SPC": "1.4%"
    },
    {
        "UID": 1102,
        "SN": "North Hykeham",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1102,
        "NE": 1257,
        "WB": 986,
        "HC": 1248,
        "SCH": 497,
        "HP": 353,
        "AP": "£377,395",
        "SPC": "-1.1%"
    },
    {
        "UID": 1103,
        "SN": "North Wingfield and Holmewood",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1103,
        "NE": 446,
        "WB": 174,
        "HC": 1147,
        "SCH": 1363,
        "HP": 1212,
        "AP": "£331,690",
        "SPC": "9.6%"
    },
    {
        "UID": 1104,
        "SN": "Tonyrefail",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1104,
        "NE": 576,
        "WB": 1151,
        "HC": 1176,
        "SCH": 798,
        "HP": 643,
        "AP": "£270,108",
        "SPC": "-5.7%"
    },
    {
        "UID": 1105,
        "SN": "Coleshill (North Warwickshire)",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1104,
        "NE": 1391,
        "WB": 1294,
        "HC": 675,
        "SCH": 600,
        "HP": 384,
        "AP": "£468,894",
        "SPC": "4.8%"
    },
    {
        "UID": 1106,
        "SN": "Kearsley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1106,
        "NE": 1316,
        "WB": 1385,
        "HC": 253,
        "SCH": 84,
        "HP": 1307,
        "AP": "£312,851",
        "SPC": "7.5%"
    },
    {
        "UID": 1107,
        "SN": "Wath upon Dearne",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1106,
        "NE": 988,
        "WB": 743,
        "HC": 722,
        "SCH": 996,
        "HP": 896,
        "AP": "£252,238",
        "SPC": "-0.6%"
    },
    {
        "UID": 1108,
        "SN": "Darwen",
        "COU": "Blackburn with Darwen",
        "REG": "North West",
        "OR": 1108,
        "NE": 1244,
        "WB": 1262,
        "HC": 476,
        "SCH": 313,
        "HP": 1052,
        "AP": "£213,148",
        "SPC": "-1.5%"
    },
    {
        "UID": 1109,
        "SN": "Pontypridd",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1109,
        "NE": 1038,
        "WB": 1387,
        "HC": 335,
        "SCH": 341,
        "HP": 1250,
        "AP": "£254,374",
        "SPC": "3.5%"
    },
    {
        "UID": 1110,
        "SN": "Byfleet",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 1109,
        "NE": 1333,
        "WB": 1194,
        "HC": 516,
        "SCH": 1123,
        "HP": 185,
        "AP": "£858,775",
        "SPC": "4.2%"
    },
    {
        "UID": 1111,
        "SN": "Morecambe",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1111,
        "NE": 1073,
        "WB": 1298,
        "HC": 518,
        "SCH": 171,
        "HP": 1295,
        "AP": "£299,162",
        "SPC": "3.4%"
    },
    {
        "UID": 1112,
        "SN": "Sherburn in Elmet",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1111,
        "NE": 1326,
        "WB": 169,
        "HC": 1420,
        "SCH": 1269,
        "HP": 171,
        "AP": "£360,647",
        "SPC": "-4.3%"
    },
    {
        "UID": 1113,
        "SN": "Broad Blunsdon",
        "COU": "Swindon",
        "REG": "South West",
        "OR": 1113,
        "NE": 692,
        "WB": 1272,
        "HC": 765,
        "SCH": 1271,
        "HP": 360,
        "AP": "£505,456",
        "SPC": "-0.7%"
    },
    {
        "UID": 1114,
        "SN": "Bovey Tracey",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1114,
        "NE": 1276,
        "WB": 90,
        "HC": 774,
        "SCH": 1210,
        "HP": 1011,
        "AP": "£527,469",
        "SPC": "0.9%"
    },
    {
        "UID": 1115,
        "SN": "Coleford (Forest of Dean)",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 1115,
        "NE": 901,
        "WB": 754,
        "HC": 907,
        "SCH": 1275,
        "HP": 525,
        "AP": "£419,211",
        "SPC": "0.7%"
    },
    {
        "UID": 1116,
        "SN": "Gorseinon",
        "COU": "Swansea",
        "REG": "Wales",
        "OR": 1116,
        "NE": 530,
        "WB": 1017,
        "HC": 657,
        "SCH": 1213,
        "HP": 948,
        "AP": "£291,285",
        "SPC": "2.1%"
    },
    {
        "UID": 1117,
        "SN": "Adwick le Street",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1117,
        "NE": 1226,
        "WB": 1074,
        "HC": 1076,
        "SCH": 313,
        "HP": 681,
        "AP": "£226,249",
        "SPC": "-6.2%"
    },
    {
        "UID": 1118,
        "SN": "Hoo St Werburgh",
        "COU": "Medway",
        "REG": "South East",
        "OR": 1118,
        "NE": 1144,
        "WB": 301,
        "HC": 901,
        "SCH": 1008,
        "HP": 1018,
        "AP": "£550,334",
        "SPC": "0.9%"
    },
    {
        "UID": 1119,
        "SN": "Lower Willingdon",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1119,
        "NE": 516,
        "WB": 503,
        "HC": 718,
        "SCH": 1394,
        "HP": 1242,
        "AP": "£663,872",
        "SPC": "6.9%"
    },
    {
        "UID": 1120,
        "SN": "Burnham-on-Crouch",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1120,
        "NE": 1414,
        "WB": 303,
        "HC": 1004,
        "SCH": 1351,
        "HP": 304,
        "AP": "£605,318",
        "SPC": "-0.4%"
    },
    {
        "UID": 1121,
        "SN": "Thornton (Bradford)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1121,
        "NE": 756,
        "WB": 1357,
        "HC": 7,
        "SCH": 901,
        "HP": 1360,
        "AP": "£265,951",
        "SPC": "6.9%"
    },
    {
        "UID": 1122,
        "SN": "Andover",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1122,
        "NE": 401,
        "WB": 1075,
        "HC": 1241,
        "SCH": 682,
        "HP": 988,
        "AP": "£491,255",
        "SPC": "2.3%"
    },
    {
        "UID": 1123,
        "SN": "Gainsborough",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1123,
        "NE": 1237,
        "WB": 968,
        "HC": 1011,
        "SCH": 626,
        "HP": 547,
        "AP": "£201,127",
        "SPC": "-5.2%"
    },
    {
        "UID": 1124,
        "SN": "Haydock",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 1124,
        "NE": 1297,
        "WB": 709,
        "HC": 713,
        "SCH": 472,
        "HP": 1207,
        "AP": "£268,395",
        "SPC": "2.6%"
    },
    {
        "UID": 1125,
        "SN": "Newhaven",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1125,
        "NE": 1149,
        "WB": 1344,
        "HC": 386,
        "SCH": 239,
        "HP": 1283,
        "AP": "£495,596",
        "SPC": "2.6%"
    },
    {
        "UID": 1126,
        "SN": "Nuneaton",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1126,
        "NE": 967,
        "WB": 636,
        "HC": 1210,
        "SCH": 569,
        "HP": 1025,
        "AP": "£368,326",
        "SPC": "0.4%"
    },
    {
        "UID": 1127,
        "SN": "Huthwaite",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1127,
        "NE": 893,
        "WB": 817,
        "HC": 1034,
        "SCH": 622,
        "HP": 1043,
        "AP": "£277,866",
        "SPC": "-3.1%"
    },
    {
        "UID": 1128,
        "SN": "Carlton in Lindrick",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1128,
        "NE": 460,
        "WB": 131,
        "HC": 1037,
        "SCH": 1380,
        "HP": 1403,
        "AP": "£317,703",
        "SPC": "5.6%"
    },
    {
        "UID": 1129,
        "SN": "Annesley Woodhouse",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1129,
        "NE": 804,
        "WB": 703,
        "HC": 1070,
        "SCH": 452,
        "HP": 1383,
        "AP": "£333,827",
        "SPC": "7.7%"
    },
    {
        "UID": 1130,
        "SN": "Wigton",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 1130,
        "NE": 1142,
        "WB": 483,
        "HC": 976,
        "SCH": 711,
        "HP": 1101,
        "AP": "£273,506",
        "SPC": "7.1%"
    },
    {
        "UID": 1131,
        "SN": "Somerton",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1131,
        "NE": 502,
        "WB": 703,
        "HC": 582,
        "SCH": 1358,
        "HP": 1270,
        "AP": "£519,209",
        "SPC": "8.9%"
    },
    {
        "UID": 1132,
        "SN": "Kirkby",
        "COU": "Merseyside",
        "REG": "North West",
        "OR": 1132,
        "NE": 1182,
        "WB": 908,
        "HC": 872,
        "SCH": 183,
        "HP": 1273,
        "AP": "£252,707",
        "SPC": "1.8%"
    },
    {
        "UID": 1133,
        "SN": "East Leake",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1132,
        "NE": 1393,
        "WB": 946,
        "HC": 1190,
        "SCH": 730,
        "HP": 159,
        "AP": "£434,329",
        "SPC": "1.6%"
    },
    {
        "UID": 1134,
        "SN": "Blackpool",
        "COU": "Blackpool",
        "REG": "North West",
        "OR": 1134,
        "NE": 947,
        "WB": 1301,
        "HC": 598,
        "SCH": 353,
        "HP": 1224,
        "AP": "£224,543",
        "SPC": "-1.7%"
    },
    {
        "UID": 1135,
        "SN": "Barnham (Arun)",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1134,
        "NE": 1184,
        "WB": 503,
        "HC": 266,
        "SCH": 1378,
        "HP": 1092,
        "AP": "£568,024",
        "SPC": "-0.4%"
    },
    {
        "UID": 1136,
        "SN": "Hilton (South Derbyshire)",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1134,
        "NE": 1350,
        "WB": 96,
        "HC": 1393,
        "SCH": 1343,
        "HP": 241,
        "AP": "£372,235",
        "SPC": "0.2%"
    },
    {
        "UID": 1137,
        "SN": "Bognor Regis",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1137,
        "NE": 813,
        "WB": 478,
        "HC": 544,
        "SCH": 1334,
        "HP": 1255,
        "AP": "£541,627",
        "SPC": "1.0%"
    },
    {
        "UID": 1138,
        "SN": "Balderton",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1138,
        "NE": 1347,
        "WB": 1200,
        "HC": 1266,
        "SCH": 237,
        "HP": 375,
        "AP": "£346,624",
        "SPC": "-0.8%"
    },
    {
        "UID": 1139,
        "SN": "Ringwood",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1138,
        "NE": 601,
        "WB": 665,
        "HC": 704,
        "SCH": 1329,
        "HP": 1126,
        "AP": "£634,628",
        "SPC": "6.3%"
    },
    {
        "UID": 1140,
        "SN": "Stone (Stafford)",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1140,
        "NE": 1208,
        "WB": 740,
        "HC": 1203,
        "SCH": 813,
        "HP": 465,
        "AP": "£399,753",
        "SPC": "3.1%"
    },
    {
        "UID": 1141,
        "SN": "Barking and Dagenham",
        "COU": "Outer London",
        "REG": "Greater London",
        "OR": 1141,
        "NE": 866,
        "WB": 1262,
        "HC": 713,
        "SCH": 221,
        "HP": 1377,
        "AP": "£673,317",
        "SPC": "2.0%"
    },
    {
        "UID": 1142,
        "SN": "Brynmawr",
        "COU": "Blaenau Gwent",
        "REG": "Wales",
        "OR": 1142,
        "NE": 123,
        "WB": 757,
        "HC": 948,
        "SCH": 1188,
        "HP": 1424,
        "AP": "£253,741",
        "SPC": "17.4%"
    },
    {
        "UID": 1143,
        "SN": "New Milton",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1143,
        "NE": 624,
        "WB": 826,
        "HC": 1170,
        "SCH": 1240,
        "HP": 582,
        "AP": "£590,848",
        "SPC": "-1.9%"
    },
    {
        "UID": 1144,
        "SN": "Kingsteignton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1144,
        "NE": 1246,
        "WB": 381,
        "HC": 928,
        "SCH": 666,
        "HP": 1226,
        "AP": "£503,490",
        "SPC": "2.7%"
    },
    {
        "UID": 1145,
        "SN": "Llangefni",
        "COU": "Isle of Anglesey",
        "REG": "Wales",
        "OR": 1145,
        "NE": 752,
        "WB": 913,
        "HC": 1174,
        "SCH": 1194,
        "HP": 417,
        "AP": "£292,807",
        "SPC": "-6.5%"
    },
    {
        "UID": 1146,
        "SN": "Staveley (Chesterfield)",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1146,
        "NE": 998,
        "WB": 205,
        "HC": 1045,
        "SCH": 1294,
        "HP": 909,
        "AP": "£304,405",
        "SPC": "-3.1%"
    },
    {
        "UID": 1147,
        "SN": "Hoyland",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1147,
        "NE": 827,
        "WB": 1201,
        "HC": 364,
        "SCH": 722,
        "HP": 1340,
        "AP": "£268,652",
        "SPC": "5.3%"
    },
    {
        "UID": 1148,
        "SN": "Pocklington",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1147,
        "NE": 1304,
        "WB": 199,
        "HC": 1404,
        "SCH": 949,
        "HP": 598,
        "AP": "£439,696",
        "SPC": "13.9%"
    },
    {
        "UID": 1149,
        "SN": "Midhurst",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1149,
        "NE": 799,
        "WB": 302,
        "HC": 947,
        "SCH": 1209,
        "HP": 1200,
        "AP": "£637,078",
        "SPC": "6.2%"
    },
    {
        "UID": 1150,
        "SN": "Edwinstowe",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1149,
        "NE": 1069,
        "WB": 560,
        "HC": 1373,
        "SCH": 622,
        "HP": 833,
        "AP": "£376,105",
        "SPC": "7.0%"
    },
    {
        "UID": 1151,
        "SN": "Corby",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1151,
        "NE": 1304,
        "WB": 891,
        "HC": 1295,
        "SCH": 284,
        "HP": 686,
        "AP": "£368,880",
        "SPC": "0.1%"
    },
    {
        "UID": 1152,
        "SN": "Market Deeping",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1152,
        "NE": 991,
        "WB": 244,
        "HC": 1242,
        "SCH": 1138,
        "HP": 849,
        "AP": "£444,645",
        "SPC": "5.2%"
    },
    {
        "UID": 1153,
        "SN": "Ashford (Spelthorne)",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 1153,
        "NE": 1358,
        "WB": 1149,
        "HC": 762,
        "SCH": 590,
        "HP": 610,
        "AP": "£717,053",
        "SPC": "8.6%"
    },
    {
        "UID": 1154,
        "SN": "Cei Connah",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1154,
        "NE": 684,
        "WB": 1098,
        "HC": 1371,
        "SCH": 342,
        "HP": 975,
        "AP": "£325,025",
        "SPC": "6.2%"
    },
    {
        "UID": 1155,
        "SN": "Newton Abbot",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1155,
        "NE": 1206,
        "WB": 1093,
        "HC": 88,
        "SCH": 798,
        "HP": 1286,
        "AP": "£439,706",
        "SPC": "1.5%"
    },
    {
        "UID": 1156,
        "SN": "Golborne",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1156,
        "NE": 1223,
        "WB": 1000,
        "HC": 1017,
        "SCH": 456,
        "HP": 779,
        "AP": "£331,117",
        "SPC": "-2.0%"
    },
    {
        "UID": 1157,
        "SN": "Great Dunmow",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1156,
        "NE": 1196,
        "WB": 654,
        "HC": 904,
        "SCH": 1426,
        "HP": 295,
        "AP": "£625,733",
        "SPC": "2.8%"
    },
    {
        "UID": 1158,
        "SN": "Shevington",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1158,
        "NE": 987,
        "WB": 573,
        "HC": 1297,
        "SCH": 426,
        "HP": 1195,
        "AP": "£361,138",
        "SPC": "4.7%"
    },
    {
        "UID": 1159,
        "SN": "Cudworth and Shafton",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1159,
        "NE": 1051,
        "WB": 1002,
        "HC": 1115,
        "SCH": 492,
        "HP": 821,
        "AP": "£252,342",
        "SPC": "-5.0%"
    },
    {
        "UID": 1160,
        "SN": "Cuddington (Cheshire West and Chester)",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 1159,
        "NE": 1285,
        "WB": 381,
        "HC": 1237,
        "SCH": 1155,
        "HP": 423,
        "AP": "£444,929",
        "SPC": "5.9%"
    },
    {
        "UID": 1161,
        "SN": "Holmes Chapel",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 1161,
        "NE": 572,
        "WB": 932,
        "HC": 1360,
        "SCH": 1246,
        "HP": 372,
        "AP": "£476,729",
        "SPC": "6.7%"
    },
    {
        "UID": 1162,
        "SN": "Highworth",
        "COU": "Swindon",
        "REG": "South West",
        "OR": 1162,
        "NE": 738,
        "WB": 424,
        "HC": 1117,
        "SCH": 1225,
        "HP": 983,
        "AP": "£506,252",
        "SPC": "9.9%"
    },
    {
        "UID": 1163,
        "SN": "Abercarn",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 1163,
        "NE": 1115,
        "WB": 1096,
        "HC": 518,
        "SCH": 766,
        "HP": 994,
        "AP": "£268,327",
        "SPC": "0.4%"
    },
    {
        "UID": 1164,
        "SN": "Breaston and Draycott",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1164,
        "NE": 1411,
        "WB": 435,
        "HC": 757,
        "SCH": 1172,
        "HP": 716,
        "AP": "£453,822",
        "SPC": "10.6%"
    },
    {
        "UID": 1165,
        "SN": "Brownhills",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1165,
        "NE": 105,
        "WB": 1111,
        "HC": 965,
        "SCH": 1141,
        "HP": 1171,
        "AP": "£359,470",
        "SPC": "1.7%"
    },
    {
        "UID": 1166,
        "SN": "Y Pil",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 1166,
        "NE": 235,
        "WB": 1077,
        "HC": 1267,
        "SCH": 1001,
        "HP": 916,
        "AP": "£282,124",
        "SPC": "0.3%"
    },
    {
        "UID": 1167,
        "SN": "Yatton",
        "COU": "North Somerset",
        "REG": "South West",
        "OR": 1167,
        "NE": 1058,
        "WB": 837,
        "HC": 888,
        "SCH": 1181,
        "HP": 533,
        "AP": "£553,100",
        "SPC": "3.6%"
    },
    {
        "UID": 1168,
        "SN": "Chafford Hundred and West Thurrock",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1168,
        "NE": 1307,
        "WB": 1355,
        "HC": 915,
        "SCH": 128,
        "HP": 796,
        "AP": "£672,131",
        "SPC": "6.5%"
    },
    {
        "UID": 1169,
        "SN": "Penkridge",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1168,
        "NE": 968,
        "WB": 1124,
        "HC": 796,
        "SCH": 1386,
        "HP": 227,
        "AP": "£422,048",
        "SPC": "1.3%"
    },
    {
        "UID": 1170,
        "SN": "Rhydaman",
        "COU": "Carmarthenshire",
        "REG": "Wales",
        "OR": 1170,
        "NE": 710,
        "WB": 684,
        "HC": 1316,
        "SCH": 1185,
        "HP": 607,
        "AP": "£258,393",
        "SPC": "-0.7%"
    },
    {
        "UID": 1171,
        "SN": "Steeton",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1170,
        "NE": 1158,
        "WB": 741,
        "HC": 308,
        "SCH": 1310,
        "HP": 985,
        "AP": "£413,882",
        "SPC": "11.8%"
    },
    {
        "UID": 1172,
        "SN": "Thundersley and South Benfleet",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1172,
        "NE": 1120,
        "WB": 949,
        "HC": 638,
        "SCH": 817,
        "HP": 979,
        "AP": "£640,223",
        "SPC": "3.4%"
    },
    {
        "UID": 1173,
        "SN": "Hwlffordd",
        "COU": "Pembrokeshire",
        "REG": "Wales",
        "OR": 1173,
        "NE": 728,
        "WB": 1337,
        "HC": 525,
        "SCH": 1311,
        "HP": 605,
        "AP": "£282,211",
        "SPC": "-3.9%"
    },
    {
        "UID": 1174,
        "SN": "Hythe and Dibden Purlieu",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1174,
        "NE": 687,
        "WB": 1335,
        "HC": 720,
        "SCH": 1172,
        "HP": 594,
        "AP": "£571,179",
        "SPC": "-3.0%"
    },
    {
        "UID": 1175,
        "SN": "Pelton and Ouston",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1174,
        "NE": 506,
        "WB": 1065,
        "HC": 1213,
        "SCH": 1317,
        "HP": 407,
        "AP": "£239,728",
        "SPC": "-5.3%"
    },
    {
        "UID": 1176,
        "SN": "Davenham",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 1174,
        "NE": 1230,
        "WB": 545,
        "HC": 1136,
        "SCH": 1069,
        "HP": 528,
        "AP": "£426,616",
        "SPC": "8.7%"
    },
    {
        "UID": 1177,
        "SN": "Thrybergh and Dalton",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1177,
        "NE": 176,
        "WB": 1172,
        "HC": 1309,
        "SCH": 1032,
        "HP": 834,
        "AP": "£270,605",
        "SPC": "-0.7%"
    },
    {
        "UID": 1178,
        "SN": "Normanton (Wakefield)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1178,
        "NE": 693,
        "WB": 916,
        "HC": 984,
        "SCH": 661,
        "HP": 1270,
        "AP": "£297,269",
        "SPC": "3.4%"
    },
    {
        "UID": 1179,
        "SN": "Quedgeley and Hardwicke",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 1178,
        "NE": 975,
        "WB": 574,
        "HC": 1095,
        "SCH": 575,
        "HP": 1305,
        "AP": "£470,129",
        "SPC": "4.2%"
    },
    {
        "UID": 1180,
        "SN": "Casnewydd",
        "COU": "Newport",
        "REG": "Wales",
        "OR": 1180,
        "NE": 1286,
        "WB": 1416,
        "HC": 394,
        "SCH": 542,
        "HP": 889,
        "AP": "£332,813",
        "SPC": "2.2%"
    },
    {
        "UID": 1181,
        "SN": "Wincanton",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1180,
        "NE": 393,
        "WB": 596,
        "HC": 849,
        "SCH": 1334,
        "HP": 1355,
        "AP": "£453,588",
        "SPC": "7.3%"
    },
    {
        "UID": 1182,
        "SN": "Kirby Cross",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1182,
        "NE": 711,
        "WB": 728,
        "HC": 997,
        "SCH": 749,
        "HP": 1343,
        "AP": "£559,743",
        "SPC": "9.9%"
    },
    {
        "UID": 1183,
        "SN": "Y Trallwng",
        "COU": "Powys",
        "REG": "Wales",
        "OR": 1183,
        "NE": 925,
        "WB": 1292,
        "HC": 604,
        "SCH": 379,
        "HP": 1329,
        "AP": "£311,438",
        "SPC": "4.4%"
    },
    {
        "UID": 1184,
        "SN": "Thornton (Wyre)",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1183,
        "NE": 1252,
        "WB": 494,
        "HC": 1187,
        "SCH": 873,
        "HP": 723,
        "AP": "£301,739",
        "SPC": "0.2%"
    },
    {
        "UID": 1185,
        "SN": "Finningley",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1185,
        "NE": 1139,
        "WB": 644,
        "HC": 1195,
        "SCH": 499,
        "HP": 1053,
        "AP": "£342,052",
        "SPC": "10.4%"
    },
    {
        "UID": 1186,
        "SN": "Willenhall",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1186,
        "NE": 317,
        "WB": 1384,
        "HC": 705,
        "SCH": 764,
        "HP": 1364,
        "AP": "£323,275",
        "SPC": "4.0%"
    },
    {
        "UID": 1187,
        "SN": "Great Notley",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1187,
        "NE": 892,
        "WB": 70,
        "HC": 1408,
        "SCH": 1291,
        "HP": 876,
        "AP": "£618,969",
        "SPC": "6.9%"
    },
    {
        "UID": 1188,
        "SN": "Leigh (Wigan)",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1188,
        "NE": 1250,
        "WB": 1246,
        "HC": 608,
        "SCH": 191,
        "HP": 1247,
        "AP": "£271,883",
        "SPC": "0.8%"
    },
    {
        "UID": 1189,
        "SN": "Billingshurst",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1189,
        "NE": 1035,
        "WB": 229,
        "HC": 1247,
        "SCH": 1322,
        "HP": 712,
        "AP": "£629,931",
        "SPC": "1.7%"
    },
    {
        "UID": 1190,
        "SN": "Iver Heath",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 1190,
        "NE": 680,
        "WB": 1258,
        "HC": 1082,
        "SCH": 1062,
        "HP": 465,
        "AP": "£831,709",
        "SPC": "6.1%"
    },
    {
        "UID": 1191,
        "SN": "Cannock",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1191,
        "NE": 247,
        "WB": 855,
        "HC": 1206,
        "SCH": 1075,
        "HP": 1167,
        "AP": "£387,393",
        "SPC": "4.0%"
    },
    {
        "UID": 1192,
        "SN": "Kempston",
        "COU": "Bedford",
        "REG": "East of England",
        "OR": 1192,
        "NE": 906,
        "WB": 1229,
        "HC": 920,
        "SCH": 298,
        "HP": 1203,
        "AP": "£505,353",
        "SPC": "2.0%"
    },
    {
        "UID": 1193,
        "SN": "Yr Wyddgrug",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1193,
        "NE": 408,
        "WB": 1038,
        "HC": 1042,
        "SCH": 1204,
        "HP": 866,
        "AP": "£352,880",
        "SPC": "6.3%"
    },
    {
        "UID": 1194,
        "SN": "Towcester",
        "COU": "West Northamptonshire",
        "REG": "East Midlands",
        "OR": 1194,
        "NE": 1298,
        "WB": 757,
        "HC": 995,
        "SCH": 1385,
        "HP": 127,
        "AP": "£543,399",
        "SPC": "0.6%"
    },
    {
        "UID": 1195,
        "SN": "Gwersyllt",
        "COU": "Wrexham",
        "REG": "Wales",
        "OR": 1195,
        "NE": 439,
        "WB": 1093,
        "HC": 1201,
        "SCH": 1086,
        "HP": 746,
        "AP": "£306,322",
        "SPC": "-0.2%"
    },
    {
        "UID": 1196,
        "SN": "South Molton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1196,
        "NE": 1078,
        "WB": 176,
        "HC": 867,
        "SCH": 1419,
        "HP": 1027,
        "AP": "£419,122",
        "SPC": "-4.6%"
    },
    {
        "UID": 1197,
        "SN": "Horbury",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1197,
        "NE": 1114,
        "WB": 774,
        "HC": 258,
        "SCH": 1239,
        "HP": 1184,
        "AP": "£365,404",
        "SPC": "7.6%"
    },
    {
        "UID": 1198,
        "SN": "Melton Mowbray",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1198,
        "NE": 1363,
        "WB": 727,
        "HC": 1226,
        "SCH": 537,
        "HP": 720,
        "AP": "£389,286",
        "SPC": "-0.2%"
    },
    {
        "UID": 1199,
        "SN": "Penwortham",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1199,
        "NE": 1362,
        "WB": 909,
        "HC": 960,
        "SCH": 458,
        "HP": 886,
        "AP": "£358,293",
        "SPC": "4.0%"
    },
    {
        "UID": 1200,
        "SN": "Tre-gwyr",
        "COU": "Swansea",
        "REG": "Wales",
        "OR": 1200,
        "NE": 861,
        "WB": 1213,
        "HC": 658,
        "SCH": 1142,
        "HP": 703,
        "AP": "£313,177",
        "SPC": "0.8%"
    },
    {
        "UID": 1201,
        "SN": "Caergybi",
        "COU": "Isle of Anglesey",
        "REG": "Wales",
        "OR": 1200,
        "NE": 576,
        "WB": 1082,
        "HC": 1007,
        "SCH": 1135,
        "HP": 777,
        "AP": "£243,933",
        "SPC": "-0.8%"
    },
    {
        "UID": 1202,
        "SN": "Barton on Sea",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1202,
        "NE": 842,
        "WB": 936,
        "HC": 1229,
        "SCH": 1285,
        "HP": 286,
        "AP": "£745,023",
        "SPC": "-1.7%"
    },
    {
        "UID": 1203,
        "SN": "Blackheath",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1203,
        "NE": 787,
        "WB": 1295,
        "HC": 543,
        "SCH": 829,
        "HP": 1129,
        "AP": "£327,778",
        "SPC": "-0.7%"
    },
    {
        "UID": 1204,
        "SN": "Y Fflint",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1204,
        "NE": 563,
        "WB": 1266,
        "HC": 1285,
        "SCH": 614,
        "HP": 856,
        "AP": "£292,965",
        "SPC": "2.1%"
    },
    {
        "UID": 1205,
        "SN": "Stanford-le-Hope",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1205,
        "NE": 1249,
        "WB": 1019,
        "HC": 1153,
        "SCH": 625,
        "HP": 539,
        "AP": "£608,904",
        "SPC": "1.5%"
    },
    {
        "UID": 1206,
        "SN": "Dunscroft and Hatfield",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1206,
        "NE": 1274,
        "WB": 989,
        "HC": 1169,
        "SCH": 515,
        "HP": 639,
        "AP": "£290,739",
        "SPC": "-0.9%"
    },
    {
        "UID": 1207,
        "SN": "Aylsham",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1207,
        "NE": 937,
        "WB": 85,
        "HC": 916,
        "SCH": 1353,
        "HP": 1300,
        "AP": "£561,672",
        "SPC": "11.6%"
    },
    {
        "UID": 1208,
        "SN": "Swinton (Rotherham)",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1208,
        "NE": 783,
        "WB": 851,
        "HC": 1098,
        "SCH": 1050,
        "HP": 810,
        "AP": "£269,219",
        "SPC": "-1.1%"
    },
    {
        "UID": 1209,
        "SN": "South Hayling",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1208,
        "NE": 887,
        "WB": 434,
        "HC": 708,
        "SCH": 1324,
        "HP": 1239,
        "AP": "£564,151",
        "SPC": "1.6%"
    },
    {
        "UID": 1210,
        "SN": "Eastleigh",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1210,
        "NE": 1018,
        "WB": 1051,
        "HC": 482,
        "SCH": 1142,
        "HP": 901,
        "AP": "£521,917",
        "SPC": "0.9%"
    },
    {
        "UID": 1211,
        "SN": "Newbiggin-by-the-Sea",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1211,
        "NE": 235,
        "WB": 1209,
        "HC": 1191,
        "SCH": 907,
        "HP": 1056,
        "AP": "£192,780",
        "SPC": "5.6%"
    },
    {
        "UID": 1212,
        "SN": "Coseley",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1212,
        "NE": 524,
        "WB": 1346,
        "HC": 809,
        "SCH": 601,
        "HP": 1319,
        "AP": "£333,529",
        "SPC": "4.8%"
    },
    {
        "UID": 1213,
        "SN": "Cross Hands and Pen-y-groes",
        "COU": "Carmarthenshire",
        "REG": "Wales",
        "OR": 1213,
        "NE": 733,
        "WB": 659,
        "HC": 1400,
        "SCH": 951,
        "HP": 858,
        "AP": "£289,362",
        "SPC": "3.0%"
    },
    {
        "UID": 1214,
        "SN": "Horndean",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1213,
        "NE": 259,
        "WB": 721,
        "HC": 1315,
        "SCH": 1260,
        "HP": 1046,
        "AP": "£550,022",
        "SPC": "-1.3%"
    },
    {
        "UID": 1215,
        "SN": "Marston Moretaine",
        "COU": "Central Bedfordshire",
        "REG": "East of England",
        "OR": 1215,
        "NE": 1182,
        "WB": 363,
        "HC": 1343,
        "SCH": 904,
        "HP": 812,
        "AP": "£541,150",
        "SPC": "8.5%"
    },
    {
        "UID": 1216,
        "SN": "New Rossington and Rossington",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1216,
        "NE": 1371,
        "WB": 1293,
        "HC": 1228,
        "SCH": 129,
        "HP": 584,
        "AP": "£267,506",
        "SPC": "-4.6%"
    },
    {
        "UID": 1217,
        "SN": "Felixstowe",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1216,
        "NE": 746,
        "WB": 561,
        "HC": 1235,
        "SCH": 1158,
        "HP": 905,
        "AP": "£485,380",
        "SPC": "-2.1%"
    },
    {
        "UID": 1218,
        "SN": "Middlewich",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 1218,
        "NE": 986,
        "WB": 1170,
        "HC": 997,
        "SCH": 867,
        "HP": 586,
        "AP": "£348,555",
        "SPC": "4.8%"
    },
    {
        "UID": 1219,
        "SN": "Grove (Vale of White Horse)",
        "COU": "Oxfordshire",
        "REG": "South East",
        "OR": 1219,
        "NE": 1270,
        "WB": 690,
        "HC": 1355,
        "SCH": 173,
        "HP": 1121,
        "AP": "£572,947",
        "SPC": "10.8%"
    },
    {
        "UID": 1220,
        "SN": "Newmarket",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1219,
        "NE": 1229,
        "WB": 561,
        "HC": 692,
        "SCH": 1145,
        "HP": 982,
        "AP": "£477,030",
        "SPC": "-0.8%"
    },
    {
        "UID": 1221,
        "SN": "Red Lodge",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1221,
        "NE": 1181,
        "WB": 662,
        "HC": 1419,
        "SCH": 381,
        "HP": 967,
        "AP": "£426,983",
        "SPC": "-3.3%"
    },
    {
        "UID": 1222,
        "SN": "Bishop Auckland",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1222,
        "NE": 817,
        "WB": 786,
        "HC": 1109,
        "SCH": 632,
        "HP": 1268,
        "AP": "£189,976",
        "SPC": "4.1%"
    },
    {
        "UID": 1223,
        "SN": "Melksham",
        "COU": "Wiltshire",
        "REG": "South West",
        "OR": 1223,
        "NE": 778,
        "WB": 752,
        "HC": 927,
        "SCH": 1189,
        "HP": 970,
        "AP": "£458,130",
        "SPC": "3.7%"
    },
    {
        "UID": 1224,
        "SN": "Bedworth",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1224,
        "NE": 917,
        "WB": 1009,
        "HC": 974,
        "SCH": 405,
        "HP": 1321,
        "AP": "£376,667",
        "SPC": "5.2%"
    },
    {
        "UID": 1225,
        "SN": "Thurnscoe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1224,
        "NE": 471,
        "WB": 611,
        "HC": 1392,
        "SCH": 1262,
        "HP": 890,
        "AP": "£208,012",
        "SPC": "-5.4%"
    },
    {
        "UID": 1226,
        "SN": "Elland",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1226,
        "NE": 1193,
        "WB": 1341,
        "HC": 47,
        "SCH": 984,
        "HP": 1063,
        "AP": "£310,760",
        "SPC": "4.2%"
    },
    {
        "UID": 1227,
        "SN": "Lydney",
        "COU": "Gloucestershire",
        "REG": "South West",
        "OR": 1227,
        "NE": 811,
        "WB": 369,
        "HC": 1224,
        "SCH": 1391,
        "HP": 834,
        "AP": "£432,269",
        "SPC": "4.1%"
    },
    {
        "UID": 1228,
        "SN": "Yapton",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1228,
        "NE": 407,
        "WB": 959,
        "HC": 530,
        "SCH": 1344,
        "HP": 1398,
        "AP": "£585,301",
        "SPC": "9.2%"
    },
    {
        "UID": 1229,
        "SN": "Peterborough",
        "COU": "Peterborough",
        "REG": "East of England",
        "OR": 1229,
        "NE": 970,
        "WB": 1007,
        "HC": 650,
        "SCH": 621,
        "HP": 1394,
        "AP": "£381,345",
        "SPC": "3.4%"
    },
    {
        "UID": 1230,
        "SN": "Cradley Heath",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1230,
        "NE": 1022,
        "WB": 1138,
        "HC": 764,
        "SCH": 736,
        "HP": 984,
        "AP": "£340,456",
        "SPC": "-2.5%"
    },
    {
        "UID": 1231,
        "SN": "Stone (Dartford)",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1231,
        "NE": 1146,
        "WB": 1063,
        "HC": 960,
        "SCH": 567,
        "HP": 909,
        "AP": "£595,165",
        "SPC": "2.6%"
    },
    {
        "UID": 1232,
        "SN": "St Austell",
        "COU": "Cornwall",
        "REG": "South West",
        "OR": 1231,
        "NE": 794,
        "WB": 829,
        "HC": 906,
        "SCH": 783,
        "HP": 1333,
        "AP": "£425,002",
        "SPC": "5.0%"
    },
    {
        "UID": 1233,
        "SN": "Caerllion",
        "COU": "Newport",
        "REG": "Wales",
        "OR": 1233,
        "NE": 1373,
        "WB": 1327,
        "HC": 408,
        "SCH": 664,
        "HP": 874,
        "AP": "£419,876",
        "SPC": "6.3%"
    },
    {
        "UID": 1234,
        "SN": "Sedgley",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1234,
        "NE": 1081,
        "WB": 1126,
        "HC": 662,
        "SCH": 1022,
        "HP": 782,
        "AP": "£365,980",
        "SPC": "-0.8%"
    },
    {
        "UID": 1235,
        "SN": "Burnham-on-Sea",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1235,
        "NE": 1224,
        "WB": 951,
        "HC": 1351,
        "SCH": 265,
        "HP": 891,
        "AP": "£450,361",
        "SPC": "-1.0%"
    },
    {
        "UID": 1236,
        "SN": "Mildenhall (West Suffolk)",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1236,
        "NE": 1380,
        "WB": 141,
        "HC": 1240,
        "SCH": 761,
        "HP": 1161,
        "AP": "£418,898",
        "SPC": "0.1%"
    },
    {
        "UID": 1237,
        "SN": "Desborough",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1237,
        "NE": 1006,
        "WB": 647,
        "HC": 881,
        "SCH": 1267,
        "HP": 884,
        "AP": "£399,259",
        "SPC": "3.2%"
    },
    {
        "UID": 1238,
        "SN": "Braintree",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1238,
        "NE": 495,
        "WB": 928,
        "HC": 1138,
        "SCH": 1341,
        "HP": 787,
        "AP": "£543,860",
        "SPC": "2.4%"
    },
    {
        "UID": 1239,
        "SN": "Fence Houses",
        "COU": "Tyne and Wear",
        "REG": "North East",
        "OR": 1239,
        "NE": 278,
        "WB": 1389,
        "HC": 1256,
        "SCH": 432,
        "HP": 1338,
        "AP": "£212,866",
        "SPC": "4.0%"
    },
    {
        "UID": 1240,
        "SN": "Grantham",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1240,
        "NE": 1306,
        "WB": 957,
        "HC": 1074,
        "SCH": 140,
        "HP": 1217,
        "AP": "£330,549",
        "SPC": "4.5%"
    },
    {
        "UID": 1241,
        "SN": "CwmbrÃ¢n",
        "COU": "Torfaen",
        "REG": "Wales",
        "OR": 1240,
        "NE": 1112,
        "WB": 1233,
        "HC": 964,
        "SCH": 675,
        "HP": 710,
        "AP": "£327,902",
        "SPC": "-0.9%"
    },
    {
        "UID": 1242,
        "SN": "West Moors",
        "COU": "Dorset",
        "REG": "South West",
        "OR": 1242,
        "NE": 1052,
        "WB": 567,
        "HC": 1324,
        "SCH": 1365,
        "HP": 391,
        "AP": "£625,470",
        "SPC": "1.8%"
    },
    {
        "UID": 1243,
        "SN": "Bentley (Doncaster)",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1243,
        "NE": 1319,
        "WB": 1102,
        "HC": 1081,
        "SCH": 49,
        "HP": 1149,
        "AP": "£199,859",
        "SPC": "2.0%"
    },
    {
        "UID": 1244,
        "SN": "Longstanton and Northstowe",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1244,
        "NE": 1428,
        "WB": 506,
        "HC": 801,
        "SCH": 1331,
        "HP": 636,
        "AP": "£541,858",
        "SPC": "4.9%"
    },
    {
        "UID": 1245,
        "SN": "Fleetwood",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1245,
        "NE": 1316,
        "WB": 1114,
        "HC": 832,
        "SCH": 82,
        "HP": 1359,
        "AP": "£225,397",
        "SPC": "8.2%"
    },
    {
        "UID": 1246,
        "SN": "Heysham",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1245,
        "NE": 1127,
        "WB": 1425,
        "HC": 687,
        "SCH": 422,
        "HP": 1042,
        "AP": "£301,096",
        "SPC": "0.3%"
    },
    {
        "UID": 1247,
        "SN": "Prudhoe",
        "COU": "Northumberland",
        "REG": "North East",
        "OR": 1245,
        "NE": 897,
        "WB": 810,
        "HC": 1343,
        "SCH": 1374,
        "HP": 279,
        "AP": "£275,123",
        "SPC": "1.5%"
    },
    {
        "UID": 1248,
        "SN": "Purfleet-on-Thames",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1248,
        "NE": 1383,
        "WB": 1364,
        "HC": 768,
        "SCH": 288,
        "HP": 904,
        "AP": "£580,514",
        "SPC": "4.5%"
    },
    {
        "UID": 1249,
        "SN": "Atherstone",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1249,
        "NE": 1389,
        "WB": 828,
        "HC": 842,
        "SCH": 1114,
        "HP": 538,
        "AP": "£358,663",
        "SPC": "2.3%"
    },
    {
        "UID": 1250,
        "SN": "Barnstaple",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1250,
        "NE": 1217,
        "WB": 833,
        "HC": 215,
        "SCH": 1067,
        "HP": 1386,
        "AP": "£456,831",
        "SPC": "5.2%"
    },
    {
        "UID": 1251,
        "SN": "Holbury",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1251,
        "NE": 328,
        "WB": 1329,
        "HC": 663,
        "SCH": 1336,
        "HP": 1064,
        "AP": "£525,606",
        "SPC": "1.8%"
    },
    {
        "UID": 1252,
        "SN": "Attleborough",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1251,
        "NE": 872,
        "WB": 547,
        "HC": 1275,
        "SCH": 636,
        "HP": 1390,
        "AP": "£462,969",
        "SPC": "4.2%"
    },
    {
        "UID": 1253,
        "SN": "North Anston",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1251,
        "NE": 1008,
        "WB": 276,
        "HC": 1300,
        "SCH": 1377,
        "HP": 759,
        "AP": "£312,562",
        "SPC": "0.8%"
    },
    {
        "UID": 1254,
        "SN": "South Woodham Ferrers",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1254,
        "NE": 1342,
        "WB": 98,
        "HC": 1398,
        "SCH": 1417,
        "HP": 474,
        "AP": "£637,211",
        "SPC": "1.2%"
    },
    {
        "UID": 1255,
        "SN": "Baglan",
        "COU": "Neath Port Talbot",
        "REG": "Wales",
        "OR": 1255,
        "NE": 1296,
        "WB": 1265,
        "HC": 392,
        "SCH": 624,
        "HP": 1155,
        "AP": "£250,804",
        "SPC": "3.2%"
    },
    {
        "UID": 1256,
        "SN": "Wingate",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1256,
        "NE": 786,
        "WB": 1239,
        "HC": 1405,
        "SCH": 582,
        "HP": 722,
        "AP": "£147,902",
        "SPC": "-16.6%"
    },
    {
        "UID": 1257,
        "SN": "Measham",
        "COU": "Leicestershire",
        "REG": "East Midlands",
        "OR": 1257,
        "NE": 1303,
        "WB": 1028,
        "HC": 1029,
        "SCH": 1111,
        "HP": 275,
        "AP": "£361,892",
        "SPC": "-1.2%"
    },
    {
        "UID": 1258,
        "SN": "Hindley",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1258,
        "NE": 1307,
        "WB": 1196,
        "HC": 736,
        "SCH": 481,
        "HP": 1027,
        "AP": "£272,291",
        "SPC": "-2.7%"
    },
    {
        "UID": 1259,
        "SN": "East Tilbury",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1259,
        "NE": 1373,
        "WB": 508,
        "HC": 1282,
        "SCH": 920,
        "HP": 669,
        "AP": "£552,067",
        "SPC": "1.1%"
    },
    {
        "UID": 1260,
        "SN": "Thirsk",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1260,
        "NE": 1054,
        "WB": 735,
        "HC": 1211,
        "SCH": 1052,
        "HP": 707,
        "AP": "£425,048",
        "SPC": "10.6%"
    },
    {
        "UID": 1261,
        "SN": "Boston",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1261,
        "NE": 1407,
        "WB": 553,
        "HC": 428,
        "SCH": 1041,
        "HP": 1331,
        "AP": "£282,854",
        "SPC": "0.9%"
    },
    {
        "UID": 1262,
        "SN": "Sprotbrough",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1262,
        "NE": 1408,
        "WB": 1158,
        "HC": 1187,
        "SCH": 139,
        "HP": 871,
        "AP": "£378,898",
        "SPC": "7.7%"
    },
    {
        "UID": 1263,
        "SN": "Killamarsh",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1263,
        "NE": 996,
        "WB": 597,
        "HC": 1303,
        "SCH": 1009,
        "HP": 860,
        "AP": "£321,268",
        "SPC": "1.6%"
    },
    {
        "UID": 1264,
        "SN": "Bloxwich",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1264,
        "NE": 627,
        "WB": 1386,
        "HC": 753,
        "SCH": 707,
        "HP": 1293,
        "AP": "£309,976",
        "SPC": "1.7%"
    },
    {
        "UID": 1265,
        "SN": "Goole",
        "COU": "East Riding of Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1265,
        "NE": 1419,
        "WB": 1091,
        "HC": 1134,
        "SCH": 604,
        "HP": 524,
        "AP": "£234,433",
        "SPC": "-4.0%"
    },
    {
        "UID": 1266,
        "SN": "Todmorden",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1266,
        "NE": 1300,
        "WB": 1076,
        "HC": 83,
        "SCH": 1322,
        "HP": 994,
        "AP": "£264,986",
        "SPC": "1.1%"
    },
    {
        "UID": 1267,
        "SN": "Bridgwater",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1267,
        "NE": 1174,
        "WB": 878,
        "HC": 978,
        "SCH": 426,
        "HP": 1323,
        "AP": "£392,168",
        "SPC": "3.2%"
    },
    {
        "UID": 1268,
        "SN": "Ashford Common",
        "COU": "Surrey",
        "REG": "South East",
        "OR": 1268,
        "NE": 1401,
        "WB": 1247,
        "HC": 742,
        "SCH": 939,
        "HP": 451,
        "AP": "£759,210",
        "SPC": "5.3%"
    },
    {
        "UID": 1269,
        "SN": "Barrowford",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1269,
        "NE": 1292,
        "WB": 769,
        "HC": 271,
        "SCH": 1307,
        "HP": 1142,
        "AP": "£302,260",
        "SPC": "0.1%"
    },
    {
        "UID": 1270,
        "SN": "Hailsham",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1270,
        "NE": 544,
        "WB": 576,
        "HC": 1133,
        "SCH": 1186,
        "HP": 1344,
        "AP": "£548,321",
        "SPC": "4.4%"
    },
    {
        "UID": 1271,
        "SN": "Murton (County Durham)",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1271,
        "NE": 375,
        "WB": 1256,
        "HC": 1363,
        "SCH": 494,
        "HP": 1301,
        "AP": "£170,698",
        "SPC": "4.2%"
    },
    {
        "UID": 1272,
        "SN": "Needham Market",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1272,
        "NE": 1225,
        "WB": 152,
        "HC": 976,
        "SCH": 1080,
        "HP": 1360,
        "AP": "£496,293",
        "SPC": "11.0%"
    },
    {
        "UID": 1273,
        "SN": "Chelmsford",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1273,
        "NE": 1253,
        "WB": 866,
        "HC": 1186,
        "SCH": 1100,
        "HP": 389,
        "AP": "£643,719",
        "SPC": "0.2%"
    },
    {
        "UID": 1274,
        "SN": "Takeley and Little Canfield",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1274,
        "NE": 1116,
        "WB": 1090,
        "HC": 775,
        "SCH": 1251,
        "HP": 565,
        "AP": "£616,547",
        "SPC": "8.7%"
    },
    {
        "UID": 1275,
        "SN": "Walton-on-the-Naze",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1275,
        "NE": 1242,
        "WB": 696,
        "HC": 805,
        "SCH": 786,
        "HP": 1274,
        "AP": "£480,377",
        "SPC": "2.2%"
    },
    {
        "UID": 1276,
        "SN": "Bilston (Wolverhampton)",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1276,
        "NE": 1105,
        "WB": 1192,
        "HC": 645,
        "SCH": 586,
        "HP": 1276,
        "AP": "£305,696",
        "SPC": "0.9%"
    },
    {
        "UID": 1277,
        "SN": "Stratton St Margaret",
        "COU": "Swindon",
        "REG": "South West",
        "OR": 1277,
        "NE": 831,
        "WB": 1391,
        "HC": 1078,
        "SCH": 635,
        "HP": 871,
        "AP": "£473,911",
        "SPC": "3.7%"
    },
    {
        "UID": 1278,
        "SN": "Ince-in-Makerfield",
        "COU": "Greater Manchester",
        "REG": "North West",
        "OR": 1278,
        "NE": 1322,
        "WB": 1415,
        "HC": 856,
        "SCH": 187,
        "HP": 1027,
        "AP": "£240,377",
        "SPC": "-6.8%"
    },
    {
        "UID": 1279,
        "SN": "Bangor",
        "COU": "Gwynedd",
        "REG": "Wales",
        "OR": 1279,
        "NE": 1056,
        "WB": 1360,
        "HC": 323,
        "SCH": 870,
        "HP": 1202,
        "AP": "£275,722",
        "SPC": "1.8%"
    },
    {
        "UID": 1280,
        "SN": "Oldbury (Sandwell)",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1280,
        "NE": 1074,
        "WB": 1319,
        "HC": 389,
        "SCH": 669,
        "HP": 1363,
        "AP": "£360,756",
        "SPC": "5.6%"
    },
    {
        "UID": 1281,
        "SN": "Watton",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1281,
        "NE": 1085,
        "WB": 457,
        "HC": 1314,
        "SCH": 827,
        "HP": 1132,
        "AP": "£428,145",
        "SPC": "-2.5%"
    },
    {
        "UID": 1282,
        "SN": "Cullompton",
        "COU": "Devon",
        "REG": "South West",
        "OR": 1282,
        "NE": 1152,
        "WB": 603,
        "HC": 1046,
        "SCH": 720,
        "HP": 1299,
        "AP": "£439,444",
        "SPC": "2.0%"
    },
    {
        "UID": 1283,
        "SN": "Street",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1282,
        "NE": 524,
        "WB": 676,
        "HC": 1111,
        "SCH": 1373,
        "HP": 1136,
        "AP": "£455,927",
        "SPC": "1.9%"
    },
    {
        "UID": 1284,
        "SN": "Burton upon Trent",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1284,
        "NE": 1325,
        "WB": 1114,
        "HC": 770,
        "SCH": 539,
        "HP": 1075,
        "AP": "£325,865",
        "SPC": "0.2%"
    },
    {
        "UID": 1285,
        "SN": "Scawthorpe and Cusworth",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1285,
        "NE": 1382,
        "WB": 912,
        "HC": 1310,
        "SCH": 5,
        "HP": 1217,
        "AP": "£300,711",
        "SPC": "9.3%"
    },
    {
        "UID": 1286,
        "SN": "Runcorn",
        "COU": "Halton",
        "REG": "North West",
        "OR": 1286,
        "NE": 1043,
        "WB": 1368,
        "HC": 978,
        "SCH": 605,
        "HP": 834,
        "AP": "£285,631",
        "SPC": "0.9%"
    },
    {
        "UID": 1287,
        "SN": "Highbridge",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1287,
        "NE": 1341,
        "WB": 888,
        "HC": 1068,
        "SCH": 554,
        "HP": 979,
        "AP": "£343,386",
        "SPC": "-3.6%"
    },
    {
        "UID": 1288,
        "SN": "Wisbech",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1288,
        "NE": 1169,
        "WB": 1336,
        "HC": 565,
        "SCH": 392,
        "HP": 1371,
        "AP": "£329,037",
        "SPC": "2.8%"
    },
    {
        "UID": 1289,
        "SN": "Whiteley",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1289,
        "NE": 1083,
        "WB": 1140,
        "HC": 875,
        "SCH": 907,
        "HP": 830,
        "AP": "£571,067",
        "SPC": "0.5%"
    },
    {
        "UID": 1290,
        "SN": "Clowne",
        "COU": "Derbyshire",
        "REG": "East Midlands",
        "OR": 1290,
        "NE": 343,
        "WB": 602,
        "HC": 1072,
        "SCH": 1399,
        "HP": 1425,
        "AP": "£301,011",
        "SPC": "7.5%"
    },
    {
        "UID": 1291,
        "SN": "Sacriston",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1291,
        "NE": 764,
        "WB": 816,
        "HC": 1321,
        "SCH": 1355,
        "HP": 596,
        "AP": "£208,922",
        "SPC": "-4.9%"
    },
    {
        "UID": 1292,
        "SN": "Buckingham",
        "COU": "Buckinghamshire",
        "REG": "South East",
        "OR": 1292,
        "NE": 1355,
        "WB": 191,
        "HC": 1160,
        "SCH": 1235,
        "HP": 921,
        "AP": "£562,015",
        "SPC": "4.5%"
    },
    {
        "UID": 1293,
        "SN": "Peterlee",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1292,
        "NE": 145,
        "WB": 1402,
        "HC": 1424,
        "SCH": 698,
        "HP": 1193,
        "AP": "£182,678",
        "SPC": "2.6%"
    },
    {
        "UID": 1294,
        "SN": "Acrefair and Cefn-mawr",
        "COU": "Wrexham",
        "REG": "Wales",
        "OR": 1294,
        "NE": 700,
        "WB": 1366,
        "HC": 708,
        "SCH": 1096,
        "HP": 993,
        "AP": "£271,347",
        "SPC": "0.5%"
    },
    {
        "UID": 1295,
        "SN": "Glyn Ebwy",
        "COU": "Blaenau Gwent",
        "REG": "Wales",
        "OR": 1295,
        "NE": 319,
        "WB": 1394,
        "HC": 834,
        "SCH": 926,
        "HP": 1392,
        "AP": "£248,249",
        "SPC": "4.3%"
    },
    {
        "UID": 1296,
        "SN": "Fazeley",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1296,
        "NE": 1415,
        "WB": 1182,
        "HC": 1270,
        "SCH": 355,
        "HP": 646,
        "AP": "£439,419",
        "SPC": "10.3%"
    },
    {
        "UID": 1297,
        "SN": "Market Drayton",
        "COU": "Shropshire",
        "REG": "West Midlands",
        "OR": 1297,
        "NE": 825,
        "WB": 920,
        "HC": 1076,
        "SCH": 1254,
        "HP": 798,
        "AP": "£368,958",
        "SPC": "2.9%"
    },
    {
        "UID": 1298,
        "SN": "Llanelli",
        "COU": "Carmarthenshire",
        "REG": "Wales",
        "OR": 1298,
        "NE": 736,
        "WB": 1273,
        "HC": 914,
        "SCH": 961,
        "HP": 990,
        "AP": "£228,817",
        "SPC": "2.3%"
    },
    {
        "UID": 1299,
        "SN": "Stainforth",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1298,
        "NE": 1429,
        "WB": 845,
        "HC": 1425,
        "SCH": 384,
        "HP": 791,
        "AP": "£192,090",
        "SPC": "-2.9%"
    },
    {
        "UID": 1300,
        "SN": "Porth",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1300,
        "NE": 1366,
        "WB": 1302,
        "HC": 390,
        "SCH": 487,
        "HP": 1336,
        "AP": "£202,404",
        "SPC": "4.4%"
    },
    {
        "UID": 1301,
        "SN": "Thetford",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1301,
        "NE": 853,
        "WB": 1109,
        "HC": 1104,
        "SCH": 395,
        "HP": 1421,
        "AP": "£403,342",
        "SPC": "5.2%"
    },
    {
        "UID": 1302,
        "SN": "Rhuthun",
        "COU": "Denbighshire",
        "REG": "Wales",
        "OR": 1302,
        "NE": 1131,
        "WB": 1028,
        "HC": 735,
        "SCH": 1286,
        "HP": 705,
        "AP": "£334,724",
        "SPC": "-2.2%"
    },
    {
        "UID": 1303,
        "SN": "Wickersley and Bramley",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1303,
        "NE": 798,
        "WB": 925,
        "HC": 1353,
        "SCH": 1133,
        "HP": 682,
        "AP": "£373,578",
        "SPC": "2.6%"
    },
    {
        "UID": 1304,
        "SN": "Sarn",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 1304,
        "NE": 1263,
        "WB": 1133,
        "HC": 832,
        "SCH": 663,
        "HP": 1005,
        "AP": "£301,919",
        "SPC": "2.2%"
    },
    {
        "UID": 1305,
        "SN": "March",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1305,
        "NE": 1292,
        "WB": 347,
        "HC": 1243,
        "SCH": 643,
        "HP": 1374,
        "AP": "£385,349",
        "SPC": "3.2%"
    },
    {
        "UID": 1306,
        "SN": "West Bromwich",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1306,
        "NE": 974,
        "WB": 1313,
        "HC": 421,
        "SCH": 864,
        "HP": 1335,
        "AP": "£361,306",
        "SPC": "4.2%"
    },
    {
        "UID": 1307,
        "SN": "Wetherby",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1307,
        "NE": 1231,
        "WB": 1033,
        "HC": 1347,
        "SCH": 1178,
        "HP": 121,
        "AP": "£490,531",
        "SPC": "0.9%"
    },
    {
        "UID": 1308,
        "SN": "Coppull",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1308,
        "NE": 922,
        "WB": 969,
        "HC": 1043,
        "SCH": 788,
        "HP": 1190,
        "AP": "£311,982",
        "SPC": "7.4%"
    },
    {
        "UID": 1309,
        "SN": "Sheerness",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1309,
        "NE": 1331,
        "WB": 1429,
        "HC": 511,
        "SCH": 329,
        "HP": 1313,
        "AP": "£347,944",
        "SPC": "3.3%"
    },
    {
        "UID": 1310,
        "SN": "Cheddar",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1310,
        "NE": 583,
        "WB": 799,
        "HC": 909,
        "SCH": 1366,
        "HP": 1267,
        "AP": "£526,064",
        "SPC": "10.4%"
    },
    {
        "UID": 1311,
        "SN": "Blythe Bridge and Forsbrook",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1311,
        "NE": 1361,
        "WB": 677,
        "HC": 1298,
        "SCH": 1152,
        "HP": 443,
        "AP": "£349,292",
        "SPC": "0.6%"
    },
    {
        "UID": 1312,
        "SN": "Crigglestone and Durkar",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1312,
        "NE": 970,
        "WB": 1353,
        "HC": 868,
        "SCH": 918,
        "HP": 827,
        "AP": "£378,746",
        "SPC": "2.1%"
    },
    {
        "UID": 1313,
        "SN": "Glastonbury",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1313,
        "NE": 762,
        "WB": 1088,
        "HC": 390,
        "SCH": 1389,
        "HP": 1312,
        "AP": "£500,214",
        "SPC": "13.7%"
    },
    {
        "UID": 1314,
        "SN": "Stanley (County Durham)",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1314,
        "NE": 243,
        "WB": 1197,
        "HC": 1227,
        "SCH": 1124,
        "HP": 1159,
        "AP": "£154,597",
        "SPC": "1.7%"
    },
    {
        "UID": 1315,
        "SN": "Brandon (West Suffolk)",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1315,
        "NE": 1353,
        "WB": 786,
        "HC": 1322,
        "SCH": 460,
        "HP": 1031,
        "AP": "£415,295",
        "SPC": "-2.1%"
    },
    {
        "UID": 1316,
        "SN": "Elworth",
        "COU": "Cheshire East",
        "REG": "North West",
        "OR": 1316,
        "NE": 932,
        "WB": 839,
        "HC": 1342,
        "SCH": 1360,
        "HP": 485,
        "AP": "£407,261",
        "SPC": "7.8%"
    },
    {
        "UID": 1317,
        "SN": "Yaxley (Huntingdonshire)",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1317,
        "NE": 978,
        "WB": 927,
        "HC": 823,
        "SCH": 1032,
        "HP": 1199,
        "AP": "£415,386",
        "SPC": "1.8%"
    },
    {
        "UID": 1318,
        "SN": "Hemsby",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1318,
        "NE": 1063,
        "WB": 375,
        "HC": 783,
        "SCH": 1328,
        "HP": 1412,
        "AP": "£478,466",
        "SPC": "8.5%"
    },
    {
        "UID": 1319,
        "SN": "Crawley (Crawley)",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1319,
        "NE": 533,
        "WB": 1284,
        "HC": 1070,
        "SCH": 831,
        "HP": 1245,
        "AP": "£600,145",
        "SPC": "3.5%"
    },
    {
        "UID": 1320,
        "SN": "Brierley Hill",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1320,
        "NE": 561,
        "WB": 1216,
        "HC": 913,
        "SCH": 1037,
        "HP": 1240,
        "AP": "£356,877",
        "SPC": "3.9%"
    },
    {
        "UID": 1321,
        "SN": "Y Drenewydd",
        "COU": "Powys",
        "REG": "Wales",
        "OR": 1321,
        "NE": 1026,
        "WB": 1193,
        "HC": 639,
        "SCH": 847,
        "HP": 1263,
        "AP": "£275,420",
        "SPC": "1.1%"
    },
    {
        "UID": 1322,
        "SN": "Cambourne",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1321,
        "NE": 1095,
        "WB": 681,
        "HC": 1428,
        "SCH": 1159,
        "HP": 605,
        "AP": "£503,585",
        "SPC": "3.0%"
    },
    {
        "UID": 1323,
        "SN": "Polegate",
        "COU": "East Sussex",
        "REG": "South East",
        "OR": 1323,
        "NE": 878,
        "WB": 777,
        "HC": 1050,
        "SCH": 942,
        "HP": 1331,
        "AP": "£599,541",
        "SPC": "7.0%"
    },
    {
        "UID": 1324,
        "SN": "Pontardawe",
        "COU": "Neath Port Talbot",
        "REG": "Wales",
        "OR": 1324,
        "NE": 1295,
        "WB": 684,
        "HC": 560,
        "SCH": 1243,
        "HP": 1201,
        "AP": "£285,768",
        "SPC": "6.6%"
    },
    {
        "UID": 1325,
        "SN": "Seaton (Allerdale)",
        "COU": "Cumberland",
        "REG": "North West",
        "OR": 1325,
        "NE": 1157,
        "WB": 961,
        "HC": 1152,
        "SCH": 1342,
        "HP": 373,
        "AP": "£257,399",
        "SPC": "-8.4%"
    },
    {
        "UID": 1326,
        "SN": "Shepton Mallet",
        "COU": "Somerset",
        "REG": "South West",
        "OR": 1326,
        "NE": 616,
        "WB": 960,
        "HC": 647,
        "SCH": 1403,
        "HP": 1367,
        "AP": "£446,486",
        "SPC": "8.8%"
    },
    {
        "UID": 1327,
        "SN": "Selsey",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1327,
        "NE": 1147,
        "WB": 242,
        "HC": 1130,
        "SCH": 1224,
        "HP": 1251,
        "AP": "£604,144",
        "SPC": "5.8%"
    },
    {
        "UID": 1328,
        "SN": "South Elmsall",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1328,
        "NE": 962,
        "WB": 619,
        "HC": 1422,
        "SCH": 873,
        "HP": 1119,
        "AP": "£241,708",
        "SPC": "-0.8%"
    },
    {
        "UID": 1329,
        "SN": "Haverhill",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1329,
        "NE": 780,
        "WB": 601,
        "HC": 1384,
        "SCH": 1045,
        "HP": 1208,
        "AP": "£476,909",
        "SPC": "1.9%"
    },
    {
        "UID": 1330,
        "SN": "Armthorpe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1330,
        "NE": 1368,
        "WB": 1111,
        "HC": 1357,
        "SCH": 413,
        "HP": 770,
        "AP": "£285,393",
        "SPC": "0.3%"
    },
    {
        "UID": 1331,
        "SN": "Prestatyn",
        "COU": "Denbighshire",
        "REG": "Wales",
        "OR": 1331,
        "NE": 903,
        "WB": 1162,
        "HC": 1331,
        "SCH": 660,
        "HP": 971,
        "AP": "£340,679",
        "SPC": "1.4%"
    },
    {
        "UID": 1332,
        "SN": "Witham",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1332,
        "NE": 1010,
        "WB": 1033,
        "HC": 1209,
        "SCH": 1303,
        "HP": 473,
        "AP": "£543,960",
        "SPC": "-0.6%"
    },
    {
        "UID": 1333,
        "SN": "Rowley Regis",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1333,
        "NE": 690,
        "WB": 1332,
        "HC": 801,
        "SCH": 835,
        "HP": 1374,
        "AP": "£371,640",
        "SPC": "8.5%"
    },
    {
        "UID": 1334,
        "SN": "Tipton",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1334,
        "NE": 671,
        "WB": 1322,
        "HC": 699,
        "SCH": 956,
        "HP": 1387,
        "AP": "£326,810",
        "SPC": "4.5%"
    },
    {
        "UID": 1335,
        "SN": "Burton Latimer",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1335,
        "NE": 1099,
        "WB": 1339,
        "HC": 489,
        "SCH": 1225,
        "HP": 894,
        "AP": "£408,437",
        "SPC": "3.8%"
    },
    {
        "UID": 1336,
        "SN": "Long Sutton (South Holland)",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1336,
        "NE": 1189,
        "WB": 23,
        "HC": 1140,
        "SCH": 1358,
        "HP": 1339,
        "AP": "£369,260",
        "SPC": "7.9%"
    },
    {
        "UID": 1337,
        "SN": "TÅ·-Du",
        "COU": "Newport",
        "REG": "Wales",
        "OR": 1337,
        "NE": 963,
        "WB": 1416,
        "HC": 1009,
        "SCH": 881,
        "HP": 782,
        "AP": "£453,545",
        "SPC": "5.6%"
    },
    {
        "UID": 1338,
        "SN": "Abercynon",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1338,
        "NE": 1109,
        "WB": 1320,
        "HC": 932,
        "SCH": 546,
        "HP": 1148,
        "AP": "£209,439",
        "SPC": "1.2%"
    },
    {
        "UID": 1339,
        "SN": "Upton (Wakefield)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1338,
        "NE": 1102,
        "WB": 351,
        "HC": 1426,
        "SCH": 780,
        "HP": 1396,
        "AP": "£284,556",
        "SPC": "11.0%"
    },
    {
        "UID": 1340,
        "SN": "Abergele",
        "COU": "Conwy",
        "REG": "Wales",
        "OR": 1340,
        "NE": 1258,
        "WB": 1156,
        "HC": 1039,
        "SCH": 844,
        "HP": 764,
        "AP": "£369,595",
        "SPC": "3.5%"
    },
    {
        "UID": 1341,
        "SN": "Rhondda",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1341,
        "NE": 990,
        "WB": 1106,
        "HC": 926,
        "SCH": 811,
        "HP": 1234,
        "AP": "£196,538",
        "SPC": "2.3%"
    },
    {
        "UID": 1342,
        "SN": "Castleford",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1341,
        "NE": 1035,
        "WB": 998,
        "HC": 1143,
        "SCH": 790,
        "HP": 1101,
        "AP": "£278,768",
        "SPC": "0.4%"
    },
    {
        "UID": 1343,
        "SN": "Scunthorpe",
        "COU": "North Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1343,
        "NE": 1138,
        "WB": 1275,
        "HC": 1368,
        "SCH": 426,
        "HP": 861,
        "AP": "£237,934",
        "SPC": "-3.6%"
    },
    {
        "UID": 1344,
        "SN": "Worksop",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1344,
        "NE": 532,
        "WB": 1174,
        "HC": 1001,
        "SCH": 1043,
        "HP": 1319,
        "AP": "£289,546",
        "SPC": "1.3%"
    },
    {
        "UID": 1345,
        "SN": "Pontarddulais",
        "COU": "Swansea",
        "REG": "Wales",
        "OR": 1344,
        "NE": 1369,
        "WB": 583,
        "HC": 1263,
        "SCH": 1030,
        "HP": 824,
        "AP": "£274,073",
        "SPC": "-0.0%"
    },
    {
        "UID": 1346,
        "SN": "Waverley and Catcliffe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1346,
        "NE": 1372,
        "WB": 1107,
        "HC": 942,
        "SCH": 1356,
        "HP": 310,
        "AP": "£343,359",
        "SPC": "-6.6%"
    },
    {
        "UID": 1347,
        "SN": "Northallerton",
        "COU": "North Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1347,
        "NE": 1286,
        "WB": 836,
        "HC": 1338,
        "SCH": 1396,
        "HP": 237,
        "AP": "£364,854",
        "SPC": "-1.2%"
    },
    {
        "UID": 1348,
        "SN": "Cawston (Rugby)",
        "COU": "Warwickshire",
        "REG": "West Midlands",
        "OR": 1348,
        "NE": 1160,
        "WB": 1071,
        "HC": 1352,
        "SCH": 1258,
        "HP": 258,
        "AP": "£444,408",
        "SPC": "2.2%"
    },
    {
        "UID": 1349,
        "SN": "Newton Aycliffe",
        "COU": "County Durham",
        "REG": "North East",
        "OR": 1349,
        "NE": 1269,
        "WB": 1086,
        "HC": 1334,
        "SCH": 672,
        "HP": 748,
        "AP": "£222,139",
        "SPC": "0.0%"
    },
    {
        "UID": 1350,
        "SN": "Ruskington",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1350,
        "NE": 1400,
        "WB": 224,
        "HC": 1245,
        "SCH": 1279,
        "HP": 962,
        "AP": "£369,178",
        "SPC": "6.4%"
    },
    {
        "UID": 1351,
        "SN": "Rhyl",
        "COU": "Denbighshire",
        "REG": "Wales",
        "OR": 1351,
        "NE": 634,
        "WB": 1183,
        "HC": 1004,
        "SCH": 941,
        "HP": 1349,
        "AP": "£285,828",
        "SPC": "3.9%"
    },
    {
        "UID": 1352,
        "SN": "Redditch",
        "COU": "Worcestershire",
        "REG": "West Midlands",
        "OR": 1352,
        "NE": 1093,
        "WB": 1198,
        "HC": 1157,
        "SCH": 529,
        "HP": 1144,
        "AP": "£418,347",
        "SPC": "4.5%"
    },
    {
        "UID": 1353,
        "SN": "Brierfield",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1353,
        "NE": 1031,
        "WB": 1059,
        "HC": 578,
        "SCH": 1052,
        "HP": 1409,
        "AP": "£216,820",
        "SPC": "3.1%"
    },
    {
        "UID": 1354,
        "SN": "Godmanchester",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1354,
        "NE": 1412,
        "WB": 542,
        "HC": 896,
        "SCH": 1203,
        "HP": 1082,
        "AP": "£489,033",
        "SPC": "1.9%"
    },
    {
        "UID": 1355,
        "SN": "Skegness",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1355,
        "NE": 1279,
        "WB": 1017,
        "HC": 1236,
        "SCH": 680,
        "HP": 925,
        "AP": "£306,357",
        "SPC": "-4.2%"
    },
    {
        "UID": 1356,
        "SN": "Appley Bridge",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1356,
        "NE": 1406,
        "WB": 1100,
        "HC": 1202,
        "SCH": 851,
        "HP": 592,
        "AP": "£391,535",
        "SPC": "-0.8%"
    },
    {
        "UID": 1357,
        "SN": "Moorends",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1357,
        "NE": 1215,
        "WB": 1238,
        "HC": 1427,
        "SCH": 439,
        "HP": 838,
        "AP": "£204,185",
        "SPC": "-1.6%"
    },
    {
        "UID": 1358,
        "SN": "Coningsby and Tattershall",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1358,
        "NE": 1364,
        "WB": 295,
        "HC": 1143,
        "SCH": 1413,
        "HP": 956,
        "AP": "£318,158",
        "SPC": "-2.2%"
    },
    {
        "UID": 1359,
        "SN": "Raunds",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1359,
        "NE": 1272,
        "WB": 732,
        "HC": 1118,
        "SCH": 1238,
        "HP": 815,
        "AP": "£439,912",
        "SPC": "4.0%"
    },
    {
        "UID": 1360,
        "SN": "Gwndy and Magwyr",
        "COU": "Monmouthshire",
        "REG": "Wales",
        "OR": 1360,
        "NE": 984,
        "WB": 1306,
        "HC": 1385,
        "SCH": 1338,
        "HP": 163,
        "AP": "£506,659",
        "SPC": "2.5%"
    },
    {
        "UID": 1361,
        "SN": "Bordon",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1361,
        "NE": 490,
        "WB": 1070,
        "HC": 1418,
        "SCH": 1017,
        "HP": 1185,
        "AP": "£565,627",
        "SPC": "8.3%"
    },
    {
        "UID": 1362,
        "SN": "Holbeach",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1362,
        "NE": 1349,
        "WB": 257,
        "HC": 1305,
        "SCH": 1164,
        "HP": 1109,
        "AP": "£346,722",
        "SPC": "1.0%"
    },
    {
        "UID": 1363,
        "SN": "Winsford",
        "COU": "Cheshire West and Chester",
        "REG": "North West",
        "OR": 1363,
        "NE": 950,
        "WB": 1282,
        "HC": 1301,
        "SCH": 794,
        "HP": 863,
        "AP": "£314,147",
        "SPC": "5.3%"
    },
    {
        "UID": 1364,
        "SN": "Rawmarsh",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1364,
        "NE": 1060,
        "WB": 1351,
        "HC": 759,
        "SCH": 645,
        "HP": 1378,
        "AP": "£243,368",
        "SPC": "15.6%"
    },
    {
        "UID": 1365,
        "SN": "Cleveleys",
        "COU": "Lancashire",
        "REG": "North West",
        "OR": 1365,
        "NE": 1340,
        "WB": 895,
        "HC": 1275,
        "SCH": 592,
        "HP": 1111,
        "AP": "£312,618",
        "SPC": "5.1%"
    },
    {
        "UID": 1366,
        "SN": "Pontyclun",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1366,
        "NE": 1395,
        "WB": 1321,
        "HC": 1237,
        "SCH": 463,
        "HP": 799,
        "AP": "£462,990",
        "SPC": "9.2%"
    },
    {
        "UID": 1367,
        "SN": "Forest Town",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1367,
        "NE": 954,
        "WB": 873,
        "HC": 1406,
        "SCH": 580,
        "HP": 1409,
        "AP": "£331,757",
        "SPC": "9.0%"
    },
    {
        "UID": 1368,
        "SN": "Crofton",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1368,
        "NE": 941,
        "WB": 1181,
        "HC": 1091,
        "SCH": 1318,
        "HP": 708,
        "AP": "£367,473",
        "SPC": "0.6%"
    },
    {
        "UID": 1369,
        "SN": "Treharris",
        "COU": "Merthyr Tydfil",
        "REG": "Wales",
        "OR": 1369,
        "NE": 1091,
        "WB": 1259,
        "HC": 827,
        "SCH": 836,
        "HP": 1234,
        "AP": "£253,545",
        "SPC": "0.5%"
    },
    {
        "UID": 1370,
        "SN": "Tilbury",
        "COU": "Thurrock",
        "REG": "East of England",
        "OR": 1370,
        "NE": 1314,
        "WB": 1139,
        "HC": 1365,
        "SCH": 483,
        "HP": 947,
        "AP": "£542,751",
        "SPC": "3.6%"
    },
    {
        "UID": 1371,
        "SN": "Clacton-on-Sea",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1371,
        "NE": 952,
        "WB": 1249,
        "HC": 1063,
        "SCH": 1035,
        "HP": 953,
        "AP": "£458,224",
        "SPC": "-4.1%"
    },
    {
        "UID": 1372,
        "SN": "Eye (Peterborough)",
        "COU": "Peterborough",
        "REG": "East of England",
        "OR": 1372,
        "NE": 1329,
        "WB": 964,
        "HC": 732,
        "SCH": 845,
        "HP": 1383,
        "AP": "£386,961",
        "SPC": "3.1%"
    },
    {
        "UID": 1373,
        "SN": "Huntingdon",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1373,
        "NE": 1022,
        "WB": 485,
        "HC": 1204,
        "SCH": 1346,
        "HP": 1197,
        "AP": "£451,196",
        "SPC": "2.3%"
    },
    {
        "UID": 1374,
        "SN": "Bagillt",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1374,
        "NE": 948,
        "WB": 1308,
        "HC": 1060,
        "SCH": 1038,
        "HP": 914,
        "AP": "£266,279",
        "SPC": "1.6%"
    },
    {
        "UID": 1375,
        "SN": "Kingswinford",
        "COU": "West Midlands",
        "REG": "West Midlands",
        "OR": 1375,
        "NE": 1107,
        "WB": 1016,
        "HC": 935,
        "SCH": 1135,
        "HP": 1076,
        "AP": "£431,028",
        "SPC": "5.6%"
    },
    {
        "UID": 1376,
        "SN": "Grimsby",
        "COU": "North East Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1376,
        "NE": 1236,
        "WB": 1405,
        "HC": 522,
        "SCH": 1062,
        "HP": 1062,
        "AP": "£193,229",
        "SPC": "-7.6%"
    },
    {
        "UID": 1377,
        "SN": "Humberston and New Waltham",
        "COU": "North East Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1377,
        "NE": 1111,
        "WB": 315,
        "HC": 1259,
        "SCH": 1395,
        "HP": 1209,
        "AP": "£358,241",
        "SPC": "5.4%"
    },
    {
        "UID": 1378,
        "SN": "Bradwell (Great Yarmouth)",
        "COU": "Norfolk",
        "REG": "East of England",
        "OR": 1378,
        "NE": 357,
        "WB": 1276,
        "HC": 1232,
        "SCH": 1014,
        "HP": 1413,
        "AP": "£470,995",
        "SPC": "7.5%"
    },
    {
        "UID": 1379,
        "SN": "Retford",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1378,
        "NE": 1332,
        "WB": 536,
        "HC": 718,
        "SCH": 1357,
        "HP": 1349,
        "AP": "£294,267",
        "SPC": "2.0%"
    },
    {
        "UID": 1380,
        "SN": "New Ollerton and Ollerton",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1380,
        "NE": 1273,
        "WB": 1243,
        "HC": 1307,
        "SCH": 579,
        "HP": 893,
        "AP": "£291,907",
        "SPC": "2.6%"
    },
    {
        "UID": 1381,
        "SN": "Aylesham",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1380,
        "NE": 237,
        "WB": 1217,
        "HC": 1429,
        "SCH": 1013,
        "HP": 1399,
        "AP": "£528,347",
        "SPC": "16.8%"
    },
    {
        "UID": 1382,
        "SN": "South Kirkby",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1382,
        "NE": 801,
        "WB": 902,
        "HC": 1395,
        "SCH": 1161,
        "HP": 1037,
        "AP": "£237,600",
        "SPC": "-2.5%"
    },
    {
        "UID": 1383,
        "SN": "Pen-y-bont ar Ogwr",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 1383,
        "NE": 1046,
        "WB": 1363,
        "HC": 1269,
        "SCH": 832,
        "HP": 788,
        "AP": "£371,884",
        "SPC": "3.2%"
    },
    {
        "UID": 1384,
        "SN": "Havant",
        "COU": "Hampshire",
        "REG": "South East",
        "OR": 1383,
        "NE": 458,
        "WB": 1382,
        "HC": 1064,
        "SCH": 1048,
        "HP": 1346,
        "AP": "£489,982",
        "SPC": "1.9%"
    },
    {
        "UID": 1385,
        "SN": "Grimethorpe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1385,
        "NE": 1266,
        "WB": 694,
        "HC": 1325,
        "SCH": 768,
        "HP": 1257,
        "AP": "£213,839",
        "SPC": "1.9%"
    },
    {
        "UID": 1386,
        "SN": "Littleport",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1386,
        "NE": 1239,
        "WB": 529,
        "HC": 1345,
        "SCH": 1364,
        "HP": 852,
        "AP": "£415,575",
        "SPC": "0.5%"
    },
    {
        "UID": 1387,
        "SN": "Ramsey",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1387,
        "NE": 1324,
        "WB": 87,
        "HC": 1157,
        "SCH": 1422,
        "HP": 1368,
        "AP": "£404,632",
        "SPC": "6.0%"
    },
    {
        "UID": 1388,
        "SN": "Uttoxeter",
        "COU": "Staffordshire",
        "REG": "West Midlands",
        "OR": 1388,
        "NE": 983,
        "WB": 807,
        "HC": 1281,
        "SCH": 1029,
        "HP": 1268,
        "AP": "£377,572",
        "SPC": "5.4%"
    },
    {
        "UID": 1389,
        "SN": "Dinnington (Rotherham)",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1389,
        "NE": 753,
        "WB": 1012,
        "HC": 1379,
        "SCH": 1097,
        "HP": 1130,
        "AP": "£276,519",
        "SPC": "2.6%"
    },
    {
        "UID": 1390,
        "SN": "Minster (Swale)",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1390,
        "NE": 1320,
        "WB": 631,
        "HC": 1380,
        "SCH": 743,
        "HP": 1316,
        "AP": "£545,588",
        "SPC": "8.9%"
    },
    {
        "UID": 1391,
        "SN": "St Neots",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1391,
        "NE": 1197,
        "WB": 952,
        "HC": 1219,
        "SCH": 954,
        "HP": 1080,
        "AP": "£517,185",
        "SPC": "2.7%"
    },
    {
        "UID": 1392,
        "SN": "St Ives (Huntingdonshire)",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1392,
        "NE": 1427,
        "WB": 716,
        "HC": 1193,
        "SCH": 1045,
        "HP": 1033,
        "AP": "£543,142",
        "SPC": "3.1%"
    },
    {
        "UID": 1393,
        "SN": "Clydach (Swansea)",
        "COU": "Swansea",
        "REG": "Wales",
        "OR": 1393,
        "NE": 924,
        "WB": 1245,
        "HC": 875,
        "SCH": 1128,
        "HP": 1245,
        "AP": "£262,822",
        "SPC": "4.5%"
    },
    {
        "UID": 1394,
        "SN": "Stowmarket",
        "COU": "Suffolk",
        "REG": "East of England",
        "OR": 1394,
        "NE": 945,
        "WB": 1161,
        "HC": 1137,
        "SCH": 1166,
        "HP": 1016,
        "AP": "£433,320",
        "SPC": "-0.6%"
    },
    {
        "UID": 1395,
        "SN": "Broughton (Flintshire)",
        "COU": "Flintshire",
        "REG": "Wales",
        "OR": 1395,
        "NE": 1198,
        "WB": 1396,
        "HC": 1143,
        "SCH": 1219,
        "HP": 476,
        "AP": "£368,133",
        "SPC": "2.0%"
    },
    {
        "UID": 1396,
        "SN": "Bolton upon Dearne",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1396,
        "NE": 928,
        "WB": 780,
        "HC": 1396,
        "SCH": 990,
        "HP": 1341,
        "AP": "£218,956",
        "SPC": "3.5%"
    },
    {
        "UID": 1397,
        "SN": "Kirton (Boston)",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1397,
        "NE": 1386,
        "WB": 336,
        "HC": 951,
        "SCH": 1367,
        "HP": 1416,
        "AP": "£315,309",
        "SPC": "6.2%"
    },
    {
        "UID": 1398,
        "SN": "Ystrad Mynach",
        "COU": "Caerphilly",
        "REG": "Wales",
        "OR": 1398,
        "NE": 1282,
        "WB": 1167,
        "HC": 1016,
        "SCH": 936,
        "HP": 1056,
        "AP": "£318,617",
        "SPC": "3.5%"
    },
    {
        "UID": 1399,
        "SN": "Waterlooville",
        "COU": "Portsmouth",
        "REG": "South East",
        "OR": 1399,
        "NE": 919,
        "WB": 1131,
        "HC": 1047,
        "SCH": 1073,
        "HP": 1304,
        "AP": "£539,545",
        "SPC": "2.0%"
    },
    {
        "UID": 1400,
        "SN": "Jaywick",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1400,
        "NE": 1398,
        "WB": 1087,
        "HC": 1397,
        "SCH": 572,
        "HP": 1022,
        "AP": "£313,543",
        "SPC": "-18.1%"
    },
    {
        "UID": 1401,
        "SN": "Sutton on Sea and Trusthorpe",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1401,
        "NE": 1397,
        "WB": 344,
        "HC": 1286,
        "SCH": 1306,
        "HP": 1147,
        "AP": "£441,771",
        "SPC": "7.3%"
    },
    {
        "UID": 1402,
        "SN": "Port Talbot",
        "COU": "Neath Port Talbot",
        "REG": "Wales",
        "OR": 1402,
        "NE": 1356,
        "WB": 1422,
        "HC": 665,
        "SCH": 749,
        "HP": 1294,
        "AP": "£229,874",
        "SPC": "5.4%"
    },
    {
        "UID": 1403,
        "SN": "Thurcroft",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1403,
        "NE": 587,
        "WB": 1368,
        "HC": 1394,
        "SCH": 1083,
        "HP": 1089,
        "AP": "£250,203",
        "SPC": "1.4%"
    },
    {
        "UID": 1404,
        "SN": "Ystalyfera",
        "COU": "Vale of Glamorgan",
        "REG": "Wales",
        "OR": 1404,
        "NE": 746,
        "WB": 894,
        "HC": 1194,
        "SCH": 1272,
        "HP": 1423,
        "AP": "£255,884",
        "SPC": "7.3%"
    },
    {
        "UID": 1405,
        "SN": "Maltby",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1404,
        "NE": 385,
        "WB": 1178,
        "HC": 1403,
        "SCH": 1326,
        "HP": 1237,
        "AP": "£248,401",
        "SPC": "3.1%"
    },
    {
        "UID": 1406,
        "SN": "Thrapston",
        "COU": "North Northamptonshire",
        "REG": "East Midlands",
        "OR": 1406,
        "NE": 1420,
        "WB": 785,
        "HC": 1256,
        "SCH": 1416,
        "HP": 690,
        "AP": "£429,738",
        "SPC": "2.4%"
    },
    {
        "UID": 1407,
        "SN": "Treorci",
        "COU": "Rhondda Cynon Taf",
        "REG": "Wales",
        "OR": 1407,
        "NE": 1373,
        "WB": 1390,
        "HC": 1086,
        "SCH": 503,
        "HP": 1228,
        "AP": "£213,792",
        "SPC": "2.3%"
    },
    {
        "UID": 1408,
        "SN": "Canvey Island",
        "COU": "Essex",
        "REG": "East of England",
        "OR": 1408,
        "NE": 1404,
        "WB": 1409,
        "HC": 968,
        "SCH": 1054,
        "HP": 766,
        "AP": "£602,020",
        "SPC": "0.4%"
    },
    {
        "UID": 1409,
        "SN": "Whittlesey",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1409,
        "NE": 1379,
        "WB": 1317,
        "HC": 404,
        "SCH": 1124,
        "HP": 1388,
        "AP": "£395,236",
        "SPC": "3.9%"
    },
    {
        "UID": 1410,
        "SN": "Thorne",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1410,
        "NE": 1388,
        "WB": 1362,
        "HC": 1391,
        "SCH": 513,
        "HP": 991,
        "AP": "£247,661",
        "SPC": "1.1%"
    },
    {
        "UID": 1411,
        "SN": "Brigg",
        "COU": "North Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1411,
        "NE": 994,
        "WB": 1268,
        "HC": 1125,
        "SCH": 1056,
        "HP": 1229,
        "AP": "£294,825",
        "SPC": "4.5%"
    },
    {
        "UID": 1412,
        "SN": "Ackworth Moor Top",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1412,
        "NE": 866,
        "WB": 1030,
        "HC": 1330,
        "SCH": 1368,
        "HP": 1173,
        "AP": "£340,932",
        "SPC": "4.5%"
    },
    {
        "UID": 1413,
        "SN": "Pontefract",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1413,
        "NE": 1177,
        "WB": 1367,
        "HC": 1277,
        "SCH": 858,
        "HP": 1090,
        "AP": "£305,631",
        "SPC": "1.6%"
    },
    {
        "UID": 1414,
        "SN": "Kirk Sandall and Edenthorpe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1414,
        "NE": 1425,
        "WB": 1068,
        "HC": 1326,
        "SCH": 934,
        "HP": 1019,
        "AP": "£334,025",
        "SPC": "6.7%"
    },
    {
        "UID": 1415,
        "SN": "Bae Cinmel",
        "COU": "Conwy",
        "REG": "Wales",
        "OR": 1415,
        "NE": 1381,
        "WB": 1291,
        "HC": 1415,
        "SCH": 1109,
        "HP": 588,
        "AP": "£336,869",
        "SPC": "0.5%"
    },
    {
        "UID": 1416,
        "SN": "Littlestone-on-Sea",
        "COU": "Kent",
        "REG": "South East",
        "OR": 1416,
        "NE": 1370,
        "WB": 442,
        "HC": 1389,
        "SCH": 1300,
        "HP": 1306,
        "AP": "£547,413",
        "SPC": "2.9%"
    },
    {
        "UID": 1417,
        "SN": "Mablethorpe",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1417,
        "NE": 1344,
        "WB": 502,
        "HC": 1409,
        "SCH": 1265,
        "HP": 1298,
        "AP": "£363,591",
        "SPC": "5.3%"
    },
    {
        "UID": 1418,
        "SN": "Brampton (Huntingdonshire)",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1418,
        "NE": 1418,
        "WB": 717,
        "HC": 1175,
        "SCH": 1372,
        "HP": 1145,
        "AP": "£520,174",
        "SPC": "3.5%"
    },
    {
        "UID": 1419,
        "SN": "Pencoed",
        "COU": "Bridgend",
        "REG": "Wales",
        "OR": 1419,
        "NE": 1248,
        "WB": 1210,
        "HC": 1264,
        "SCH": 1087,
        "HP": 1039,
        "AP": "£356,770",
        "SPC": "6.8%"
    },
    {
        "UID": 1420,
        "SN": "Chatteris",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1420,
        "NE": 1390,
        "WB": 632,
        "HC": 1095,
        "SCH": 1379,
        "HP": 1422,
        "AP": "£405,126",
        "SPC": "9.8%"
    },
    {
        "UID": 1421,
        "SN": "Sawtry",
        "COU": "Cambridgeshire",
        "REG": "East of England",
        "OR": 1421,
        "NE": 1171,
        "WB": 677,
        "HC": 1374,
        "SCH": 1411,
        "HP": 1287,
        "AP": "£477,564",
        "SPC": "4.6%"
    },
    {
        "UID": 1422,
        "SN": "Havercroft and Ryhill",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1422,
        "NE": 884,
        "WB": 1000,
        "HC": 1369,
        "SCH": 1274,
        "HP": 1411,
        "AP": "£262,597",
        "SPC": "11.1%"
    },
    {
        "UID": 1423,
        "SN": "Harworth and Bircotes",
        "COU": "Nottinghamshire",
        "REG": "East Midlands",
        "OR": 1423,
        "NE": 848,
        "WB": 1295,
        "HC": 1410,
        "SCH": 1330,
        "HP": 1071,
        "AP": "£285,285",
        "SPC": "-4.9%"
    },
    {
        "UID": 1424,
        "SN": "Goldthorpe",
        "COU": "South Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1424,
        "NE": 1218,
        "WB": 1188,
        "HC": 1412,
        "SCH": 1284,
        "HP": 867,
        "AP": "£195,042",
        "SPC": "-11.3%"
    },
    {
        "UID": 1425,
        "SN": "Immingham",
        "COU": "North East Lincolnshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1425,
        "NE": 1409,
        "WB": 975,
        "HC": 1348,
        "SCH": 1223,
        "HP": 1049,
        "AP": "£236,296",
        "SPC": "-4.9%"
    },
    {
        "UID": 1426,
        "SN": "Spalding",
        "COU": "Lincolnshire",
        "REG": "East Midlands",
        "OR": 1426,
        "NE": 1417,
        "WB": 1252,
        "HC": 1171,
        "SCH": 964,
        "HP": 1297,
        "AP": "£329,986",
        "SPC": "2.8%"
    },
    {
        "UID": 1427,
        "SN": "Featherstone (Wakefield)",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1427,
        "NE": 1310,
        "WB": 1302,
        "HC": 1041,
        "SCH": 1236,
        "HP": 1229,
        "AP": "£259,614",
        "SPC": "1.3%"
    },
    {
        "UID": 1428,
        "SN": "Wick (Arun)",
        "COU": "West Sussex",
        "REG": "South East",
        "OR": 1428,
        "NE": 1088,
        "WB": 1413,
        "HC": 1280,
        "SCH": 1402,
        "HP": 1121,
        "AP": "£529,174",
        "SPC": "-1.3%"
    },
    {
        "UID": 1429,
        "SN": "Knottingley",
        "COU": "West Yorkshire",
        "REG": "Yorkshire and The Humber",
        "OR": 1429,
        "NE": 1378,
        "WB": 1428,
        "HC": 1382,
        "SCH": 1248,
        "HP": 914,
        "AP": "£238,533",
        "SPC": "-11.3%"
    }
]
export default data;
